'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var equals = require('deep-equal');
var pickAll = require('ramda/src/pickAll.js');
var reactRouterDom = require('react-router-dom');
var Functions = require('@ultradent/utilities/Functions');
var Window = require('@ultradent/utilities/Window');
var i18next = require('i18next');
var ReactPostprocessor = require('i18next-react-postprocessor');
var cx = require('classnames');
var Strings = require('@ultradent/utilities/Strings');
var _rollupPluginBabelHelpers = require('./_rollupPluginBabelHelpers-b7755977.js');
var invoke = require('lodash.invoke');
var Tippy = require('@tippyjs/react');
var TippyJs = require('tippy.js');
require('tippy.js/dist/tippy.css');
require('tippy.js/themes/light.css');
require('react-date-range/dist/styles.css');
require('react-date-range/dist/theme/default.css');
var reactDateRange = require('react-date-range');
var propTypes = require('prop-types');
var Media = require('@ultradent/utilities/Media');
var JSZip = require('jszip');
var countBy = require('ramda/src/countBy');
var identity = require('ramda/src/identity');
var __ = require('ramda/src/__.js');
var and = require('ramda/src/and.js');
var map = require('ramda/src/map.js');
var prop = require('ramda/src/prop.js');
var gte = require('ramda/src/gte.js');
var compose = require('ramda/src/compose.js');
var length = require('ramda/src/length.js');
var flatten = require('ramda/src/flatten.js');
var pick = require('ramda/src/pick.js');
var equals$1 = require('ramda/src/equals.js');
var upiFuzzySearch = require('@ultradent/upi-fuzzy-search');
var pathOr = require('ramda/src/pathOr');
var Guid = require('@ultradent/utilities/Guid');
var reactWindow = require('react-window');
var mediaQuery = require('@ultradent/utilities/MediaQueries');
var take = require('ramda/src/take.js');
var EmptyOrNil = require('@ultradent/utilities/EmptyOrNil');
var Modal = require('react-modal');
var formik = require('formik');
var reactDropzone = require('react-dropzone');
var useDebounce = require('use-debounce');
var MaskedInput = require('react-text-mask');
var TokenInput = require('react-tag-autocomplete');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

function _interopNamespace(e) {
    if (e && e.__esModule) return e;
    var n = Object.create(null);
    if (e) {
        Object.keys(e).forEach(function (k) {
            if (k !== 'default') {
                var d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: function () { return e[k]; }
                });
            }
        });
    }
    n["default"] = e;
    return Object.freeze(n);
}

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var React__namespace = /*#__PURE__*/_interopNamespace(React);
var equals__default = /*#__PURE__*/_interopDefaultLegacy(equals);
var pickAll__default = /*#__PURE__*/_interopDefaultLegacy(pickAll);
var i18next__default = /*#__PURE__*/_interopDefaultLegacy(i18next);
var ReactPostprocessor__default = /*#__PURE__*/_interopDefaultLegacy(ReactPostprocessor);
var cx__default = /*#__PURE__*/_interopDefaultLegacy(cx);
var invoke__default = /*#__PURE__*/_interopDefaultLegacy(invoke);
var Tippy__default = /*#__PURE__*/_interopDefaultLegacy(Tippy);
var TippyJs__default = /*#__PURE__*/_interopDefaultLegacy(TippyJs);
var JSZip__default = /*#__PURE__*/_interopDefaultLegacy(JSZip);
var countBy__default = /*#__PURE__*/_interopDefaultLegacy(countBy);
var identity__default = /*#__PURE__*/_interopDefaultLegacy(identity);
var ____default = /*#__PURE__*/_interopDefaultLegacy(__);
var and__default = /*#__PURE__*/_interopDefaultLegacy(and);
var map__default = /*#__PURE__*/_interopDefaultLegacy(map);
var prop__default = /*#__PURE__*/_interopDefaultLegacy(prop);
var gte__default = /*#__PURE__*/_interopDefaultLegacy(gte);
var compose__default = /*#__PURE__*/_interopDefaultLegacy(compose);
var length__default = /*#__PURE__*/_interopDefaultLegacy(length);
var flatten__default = /*#__PURE__*/_interopDefaultLegacy(flatten);
var pick__default = /*#__PURE__*/_interopDefaultLegacy(pick);
var equals__default$1 = /*#__PURE__*/_interopDefaultLegacy(equals$1);
var pathOr__default = /*#__PURE__*/_interopDefaultLegacy(pathOr);
var mediaQuery__default = /*#__PURE__*/_interopDefaultLegacy(mediaQuery);
var take__default = /*#__PURE__*/_interopDefaultLegacy(take);
var Modal__default = /*#__PURE__*/_interopDefaultLegacy(Modal);
var MaskedInput__default = /*#__PURE__*/_interopDefaultLegacy(MaskedInput);
var TokenInput__default = /*#__PURE__*/_interopDefaultLegacy(TokenInput);

function isClassComponent(component) {
  return typeof component === 'function' && !!component.prototype.isReactComponent;
}

function isFunctionComponent(component) {
  return typeof component === 'function' && String(component).includes('return React.createElement');
}

function isReactComponent(component) {
  return isClassComponent(component) || isFunctionComponent(component);
}
function isElement(element) {
  return /*#__PURE__*/React__default["default"].isValidElement(element);
}
function isDOMTypeElement(element) {
  return isElement(element) && typeof element.type === 'string';
}
function isCompositeTypeElement(element) {
  return isElement(element) && typeof element.type === 'function';
}
const arePropsEqual = compareProps => (props, nextProps) => equals__default["default"](pickAll__default["default"](compareProps, props), pickAll__default["default"](compareProps, nextProps));
/**
 * Generates a list of steps for display by the steps component.
 *
 * This function returns a function that accepts a step object and returns
 * the object with extra properties.
 *
 * @param {Object} route
 * @returns {Function}
 */

function generateStepsList(_ref) {
  let {
    route
  } = _ref;
  const routeParams = route.params;
  const routeParamKeys = Object.keys(routeParams); // Swap out any dynamic routes with their param values so "/portfolio/:portfolioId" becomes "/portfolio/1"

  const replaceParams = (path, param) => path.replace(`:${param}`, routeParams[param]);

  return _ref2 => {
    let {
      path,
      label
    } = _ref2;
    const routePath = routeParamKeys.length ? routeParamKeys.reduce(replaceParams, path) : path;
    const pattern = new RegExp(`${path}$`);
    const active = pattern.test(route.pathname);
    return {
      path: routePath,
      active,
      label
    };
  };
}

var ReactHelpers = /*#__PURE__*/Object.freeze({
    __proto__: null,
    isReactComponent: isReactComponent,
    isElement: isElement,
    isDOMTypeElement: isDOMTypeElement,
    isCompositeTypeElement: isCompositeTypeElement,
    arePropsEqual: arePropsEqual,
    generateStepsList: generateStepsList
});

function useIsMountedRef() {
  const isMountedRef = React.useRef(null);
  React.useEffect(() => {
    isMountedRef.current = true;
    return () => isMountedRef.current = false;
  });
  return isMountedRef;
}
function useDidUpdateEffect(fn, inputs) {
  const isMountedRef = React.useRef(null);
  React.useEffect(() => {
    if (isMountedRef.current) {
      return fn();
    }

    isMountedRef.current = true;
    return Functions.noop;
  }, inputs);
}
const useScrollToTop = function () {
  let {
    condition,
    scrollContext = document.documentElement
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const location = reactRouterDom.useLocation();
  React.useLayoutEffect(() => {
    let doScroll = true;

    if (condition) {
      doScroll = condition(location);
    }

    doScroll && scrollContext.scrollTo(0, 0);
  }, [location.pathname]);
  return {
    scrollContext
  };
};
const getLocations = location => {
  const backgroundLocation = location.state?.backgroundLocation;
  return {
    parentLocation: backgroundLocation === undefined ? location : backgroundLocation,
    modalLocation: backgroundLocation === undefined ? undefined : location
  };
};
const useMediaQuery = function () {
  if (typeof window === 'undefined') {
    return () => false;
  }

  return query => {
    const mediaMatch = window.matchMedia(query);
    const [matches, setMatches] = React.useState(mediaMatch.matches);
    React.useEffect(() => {
      const handler = e => setMatches(e.matches);

      mediaMatch.addEventListener('change', handler);
      return () => mediaMatch.removeEventListener('change', handler);
    }, [mediaMatch]);
    return matches;
  };
}();

var ReactHooks = /*#__PURE__*/Object.freeze({
    __proto__: null,
    useIsMountedRef: useIsMountedRef,
    useDidUpdateEffect: useDidUpdateEffect,
    useScrollToTop: useScrollToTop,
    getLocations: getLocations,
    useMediaQuery: useMediaQuery
});

//  integration resource - https://www.i18next.com/how-to/backend-fallback;

const t = i18next__default["default"].t.bind(i18next__default["default"]);
const lang = Window.isBrowser() && navigator.language || 'en-us'; // preloaded resources from js file

let _initialized = false;

const i18nFactory = () => {
  if (_initialized) {
    return;
  }

  _initialized = true;
  i18next__default["default"].use(new ReactPostprocessor__default["default"]()).init({
    // note - if using a language detector, do not define the lng option
    lng: lang,
    debug: process.env.NODE_ENV === 'development',
    resources: {
      [lang]: {
        translation: Window.isBrowser() && window.upi?.i18n?.translations
      }
    },
    interpolation: {
      format: function (value, format, lng) {
        if (format === 'uppercase') {
          return value.toUpperCase();
        }

        return value;
      }
    }
  }, (err, tFunc) => {
    if (err) {
      console.error('[Failed to load translations]', err);
    }
  });
};

i18nFactory();

var _path$V, _path2$r;

function _extends$W() { _extends$W = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$W.apply(this, arguments); }

const SvgAccounts = props => /*#__PURE__*/React__namespace.createElement("svg", _extends$W({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 25",
  fill: "currentColor"
}, props), _path$V || (_path$V = /*#__PURE__*/React__namespace.createElement("path", {
  d: "M9.85 12.358a3.55 3.55 0 0 0-2.47-6.1 3.55 3.55 0 0 0-2.46 6.12 4.91 4.91 0 0 0-2 4 1 1 0 0 0 1.9 0 2.76 2.76 0 0 1 2.58-2.92 2.758 2.758 0 0 1 2.6 2.92.95.95 0 1 0 1.9 0 4.91 4.91 0 0 0-2.05-4.02Zm-2.48-4a1.46 1.46 0 1 1 .242 2.91 1.46 1.46 0 0 1-.242-2.91Zm12.52.601h-6a1 1 0 0 1 0-2h6a1 1 0 1 1 0 2Zm0 4.01h-7a1 1 0 1 1 0-2h7a1 1 0 0 1 0 2Zm0 4.08h-5a1 1 0 1 1 0-2h5a1 1 0 0 1 0 2Z"
})), _path2$r || (_path2$r = /*#__PURE__*/React__namespace.createElement("path", {
  d: "M20.78 20.939H3a3 3 0 0 1-3-3V6.049a3 3 0 0 1 3-3h17.78a3 3 0 0 1 3 3v11.91a3 3 0 0 1-3 2.98ZM3 5.049a1 1 0 0 0-1 1v11.91a1 1 0 0 0 1 1h17.78a1 1 0 0 0 1-1V6.049a1 1 0 0 0-1-1H3Z"
})));

var _path$U, _path2$q;

function _extends$V() { _extends$V = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$V.apply(this, arguments); }

const SvgAddress = props => /*#__PURE__*/React__namespace.createElement("svg", _extends$V({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 25",
  fill: "currentColor"
}, props), _path$U || (_path$U = /*#__PURE__*/React__namespace.createElement("path", {
  d: "M12.06 2a7.17 7.17 0 0 1 6.81 7.44 12.32 12.32 0 0 1-2 5.9 49.52 49.52 0 0 1-4.95 6.44 73.321 73.321 0 0 1-5-6.59A9.07 9.07 0 0 1 5 9.41 7.27 7.27 0 0 1 12.06 2Zm0-2A9.05 9.05 0 0 0 5.7 2.72 9.34 9.34 0 0 0 3 9.43a11 11 0 0 0 2.24 6.86 76.464 76.464 0 0 0 5.16 6.8 2 2 0 0 0 1.47.68 2 2 0 0 0 1.46-.64 50.378 50.378 0 0 0 5.17-6.72 14.119 14.119 0 0 0 2.33-7 9.499 9.499 0 0 0-2.74-6.84A8.65 8.65 0 0 0 12.06 0Z"
})), _path2$q || (_path2$q = /*#__PURE__*/React__namespace.createElement("path", {
  d: "M11.93 6.21a2.72 2.72 0 1 1 .02 5.44 2.72 2.72 0 0 1-.02-5.44Zm0-2a4.72 4.72 0 1 0 4.72 4.71 4.71 4.71 0 0 0-4.72-4.71Z"
})));

var _path$T;

function _extends$U() { _extends$U = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$U.apply(this, arguments); }

const SvgArrowDown = props => /*#__PURE__*/React__namespace.createElement("svg", _extends$U({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props), _path$T || (_path$T = /*#__PURE__*/React__namespace.createElement("path", {
  d: "M12 18.9c-.3 0-.6-.1-.8-.3L.4 7.8c-.4-.4-.4-1 0-1.4.4-.4 1.1-.4 1.5 0L12 16.5 22.1 6.4c.4-.4 1.1-.4 1.5 0 .4.4.4 1.1 0 1.5L12.8 18.6c-.2.2-.5.3-.8.3Z"
})));

var _path$S;

function _extends$T() { _extends$T = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$T.apply(this, arguments); }

const SvgArrowLeft = props => /*#__PURE__*/React__namespace.createElement("svg", _extends$T({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 25 25",
  fill: "currentColor"
}, props), _path$S || (_path$S = /*#__PURE__*/React__namespace.createElement("path", {
  d: "M5.125 12.038c-.001-.3.098-.6.298-.8L16.2.416c.4-.401 1-.402 1.4-.003.4.4.402 1.1.003 1.5l-10.08 10.12 10.12 10.08c.402.4.403 1.1.004 1.5-.4.4-1.1.402-1.5.003L5.426 12.838c-.2-.2-.3-.5-.301-.8Z"
})));

var _path$R;

function _extends$S() { _extends$S = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$S.apply(this, arguments); }

const SvgArrowUp = props => /*#__PURE__*/React__namespace.createElement("svg", _extends$S({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props), _path$R || (_path$R = /*#__PURE__*/React__namespace.createElement("path", {
  d: "M12 6.1c.3 0 .6.1.8.3l10.8 10.8c.4.4.4 1.1 0 1.5-.4.4-1.1.4-1.5 0L12 8.5 1.9 18.6c-.4.4-1.1.4-1.5 0-.4-.4-.4-1.1 0-1.5L11.3 6.4c.1-.2.4-.3.7-.3Z"
})));

var _path$Q;

function _extends$R() { _extends$R = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$R.apply(this, arguments); }

const SvgArrowRight = props => /*#__PURE__*/React__namespace.createElement("svg", _extends$R({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props), _path$Q || (_path$Q = /*#__PURE__*/React__namespace.createElement("path", {
  d: "M18.9 12c0 .3-.1.6-.3.8L7.8 23.6c-.4.4-1 .4-1.4 0-.4-.4-.4-1.1 0-1.5L16.5 12 6.4 1.9C6 1.5 6 .8 6.4.4 6.8 0 7.5 0 7.9.4l10.7 10.8c.2.2.3.5.3.8Z"
})));

var _path$P;

function _extends$Q() { _extends$Q = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$Q.apply(this, arguments); }

const SvgBeaker = props => /*#__PURE__*/React__namespace.createElement("svg", _extends$Q({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 25",
  fill: "currentColor"
}, props), _path$P || (_path$P = /*#__PURE__*/React__namespace.createElement("path", {
  d: "M22.14 18.48 16.47 10V2h.85A1.1 1.1 0 0 0 18.49.9a1.05 1.05 0 0 0-1.16-.9H6.49a1.08 1.08 0 0 0-1.16 1 1 1 0 0 0 1.16 1h1v8l-6 8.46A3.43 3.43 0 0 0 4.4 23.7h14.8a3.43 3.43 0 0 0 2.94-5.22ZM5 17l4.23-6.11a1.52 1.52 0 0 0 .24-.89V2h5v8c.001.318.099.629.28.89L18.5 17H5Z"
})));

var _path$O, _path2$p;

function _extends$P() { _extends$P = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$P.apply(this, arguments); }

const SvgBuilding = props => /*#__PURE__*/React__namespace.createElement("svg", _extends$P({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 25",
  fill: "currentColor"
}, props), _path$O || (_path$O = /*#__PURE__*/React__namespace.createElement("path", {
  d: "M18.19 2a.91.91 0 0 1 .88.93V20h.56a.449.449 0 0 1 .44.46v1.33H4v-1.35a.45.45 0 0 1 .44-.44h.62V3a.91.91 0 0 1 .88-1h12.25Zm0-2H5.94a2.9 2.9 0 0 0-2.88 2.93v15.48a2.46 2.46 0 0 0-1.06 2v3.35h20.07v-3.3a2.5 2.5 0 0 0-1-2V2.93A2.9 2.9 0 0 0 18.19 0Z"
})), _path2$p || (_path2$p = /*#__PURE__*/React__namespace.createElement("path", {
  d: "M10.46 3.96H8.63a.55.55 0 0 0-.55.55v1.83c0 .304.246.55.55.55h1.83a.55.55 0 0 0 .55-.55V4.51a.55.55 0 0 0-.55-.55Zm0 4.09H8.63a.55.55 0 0 0-.55.55v1.83c0 .304.246.55.55.55h1.83a.55.55 0 0 0 .55-.55V8.6a.55.55 0 0 0-.55-.55Zm0 3.99H8.63a.55.55 0 0 0-.55.55v1.83c0 .304.246.55.55.55h1.83a.55.55 0 0 0 .55-.55v-1.83a.55.55 0 0 0-.55-.55Zm4.97-8.08H13.6a.55.55 0 0 0-.55.55v1.83c0 .304.246.55.55.55h1.83a.55.55 0 0 0 .55-.55V4.51a.55.55 0 0 0-.55-.55Zm0 4.09H13.6a.55.55 0 0 0-.55.55v1.83c0 .304.246.55.55.55h1.83a.55.55 0 0 0 .55-.55V8.6a.55.55 0 0 0-.55-.55Zm0 3.99H13.6a.55.55 0 0 0-.55.55v1.83c0 .304.246.55.55.55h1.83a.55.55 0 0 0 .55-.55v-1.83a.55.55 0 0 0-.55-.55ZM13.55 21h-3v-3.9a.56.56 0 0 1 .56-.55H13a.56.56 0 0 1 .56.55l-.01 3.9Z"
})));

var _path$N;

function _extends$O() { _extends$O = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$O.apply(this, arguments); }

const SvgBox = props => /*#__PURE__*/React__namespace.createElement("svg", _extends$O({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 25",
  fill: "currentColor"
}, props), _path$N || (_path$N = /*#__PURE__*/React__namespace.createElement("path", {
  d: "m23.74 8.519-2-3a.94.94 0 0 0-.49-.38l-9.13-3.09a.91.91 0 0 0-.61 0L2.7 4.679h-.17a1 1 0 0 0-.4.37l-1.89 3a1 1 0 0 0-.12.83 1 1 0 0 0 .56.62l1.32.63v8.1a1 1 0 0 0 .68.94l8.81 2.94c.1.031.204.048.31.05a.996.996 0 0 0 .33-.06l9.07-3.44a1 1 0 0 0 .64-.93v-7.19l1.4-.51a1 1 0 0 0 .61-.64 1 1 0 0 0-.11-.87Zm-3.28-1.26.91 1.33-6.91 2.52-1.08-1.61 7.08-2.24Zm-8.68-3.27 5.91 2.06-5.86 1.85-5.75-2.16 5.7-1.75Zm-8.39 2.87 6.85 2.58-1.13 1.61-6.56-2.86.84-1.33Zm.61 4.19 5.07 2.22a1 1 0 0 0 1.22-.34l.52-.75v7.63L4 17.498v-6.45Zm15.87 6-7.07 2.66v-7.49l.45.66a1 1 0 0 0 1.17.38l5.44-2 .01 5.79Z"
})));

var _path$M, _path2$o;

function _extends$N() { _extends$N = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$N.apply(this, arguments); }

const SvgCalendar = props => /*#__PURE__*/React__namespace.createElement("svg", _extends$N({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props), _path$M || (_path$M = /*#__PURE__*/React__namespace.createElement("path", {
  d: "M21.17 2.09h-2.66V.4a.4.4 0 0 0-.4-.4h-1.25a.4.4 0 0 0-.41.4v1.69H7.36V.4A.4.4 0 0 0 7 0H5.68a.4.4 0 0 0-.4.4v1.69H2.56A2.56 2.56 0 0 0 0 4.65v16.5a2.57 2.57 0 0 0 2.56 2.57h18.61a2.57 2.57 0 0 0 2.56-2.57V4.65a2.56 2.56 0 0 0-2.56-2.56Zm-18.61 2h2.72v1.55a.4.4 0 0 0 .4.4H7a.4.4 0 0 0 .4-.4V4.09h9.09v1.55a.4.4 0 0 0 .41.4h1.25a.4.4 0 0 0 .4-.4V4.09h2.66a.56.56 0 0 1 .56.56V8.9H2V4.65a.56.56 0 0 1 .56-.56Zm18.61 17.63H2.56a.57.57 0 0 1-.56-.57V10.9h19.73v10.25a.57.57 0 0 1-.56.57Z"
})), _path2$o || (_path2$o = /*#__PURE__*/React__namespace.createElement("path", {
  d: "M5.93 12.37h-1.3a.35.35 0 0 0-.35.35v1.3c0 .193.157.35.35.35h1.3a.35.35 0 0 0 .35-.35v-1.3a.35.35 0 0 0-.35-.35Zm4.48 0h-1.3a.35.35 0 0 0-.35.35v1.3c0 .193.156.35.35.35h1.3a.35.35 0 0 0 .35-.35v-1.3a.35.35 0 0 0-.35-.35Zm4.48 0h-1.3a.35.35 0 0 0-.35.35v1.3c0 .193.157.35.35.35h1.3a.35.35 0 0 0 .35-.35v-1.3a.35.35 0 0 0-.35-.35Zm4.24 0h-1.3a.35.35 0 0 0-.35.35v1.3c0 .193.157.35.35.35h1.3a.35.35 0 0 0 .35-.35v-1.3a.35.35 0 0 0-.35-.35Zm-13.2 3.25h-1.3a.35.35 0 0 0-.35.35v1.3c0 .193.157.35.35.35h1.3a.35.35 0 0 0 .35-.35v-1.3a.35.35 0 0 0-.35-.35Zm4.48 0h-1.3a.35.35 0 0 0-.35.35v1.3c0 .193.156.35.35.35h1.3a.35.35 0 0 0 .35-.35v-1.3a.35.35 0 0 0-.35-.35Zm4.48 0h-1.3a.35.35 0 0 0-.35.35v1.3c0 .193.157.35.35.35h1.3a.35.35 0 0 0 .35-.35v-1.3a.35.35 0 0 0-.35-.35Zm4.24 0h-1.3a.35.35 0 0 0-.35.35v1.3c0 .193.157.35.35.35h1.3a.35.35 0 0 0 .35-.35v-1.3a.35.35 0 0 0-.35-.35Zm-13.2 3.25h-1.3a.35.35 0 0 0-.35.35v1.3c0 .193.157.35.35.35h1.3a.35.35 0 0 0 .35-.35v-1.3a.35.35 0 0 0-.35-.35Zm4.48 0h-1.3a.35.35 0 0 0-.35.35v1.3c0 .193.156.35.35.35h1.3a.35.35 0 0 0 .35-.35v-1.3a.35.35 0 0 0-.35-.35Zm4.48 0h-1.3a.35.35 0 0 0-.35.35v1.3c0 .193.157.35.35.35h1.3a.35.35 0 0 0 .35-.35v-1.3a.35.35 0 0 0-.35-.35Z"
})));

var _path$L;

function _extends$M() { _extends$M = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$M.apply(this, arguments); }

const SvgCheckmarkFilled = props => /*#__PURE__*/React__namespace.createElement("svg", _extends$M({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props), _path$L || (_path$L = /*#__PURE__*/React__namespace.createElement("path", {
  d: "M21.5 0A2.5 2.5 0 0 1 24 2.5v19a2.5 2.5 0 0 1-2.5 2.5h-19A2.5 2.5 0 0 1 0 21.5v-19A2.5 2.5 0 0 1 2.5 0h19Zm-1.548 5.84a1.5 1.5 0 0 0-2.111.208l-7.206 8.779-3.624-3.304-.12-.098A1.5 1.5 0 0 0 4.99 13.74l4.793 4.369.116.095a1.5 1.5 0 0 0 2.054-.252l8.207-10 .092-.124a1.5 1.5 0 0 0-.3-1.987Z"
})));

var _path$K;

function _extends$L() { _extends$L = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$L.apply(this, arguments); }

const SvgCheckmark = props => /*#__PURE__*/React__namespace.createElement("svg", _extends$L({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props), _path$K || (_path$K = /*#__PURE__*/React__namespace.createElement("path", {
  d: "M11.84 22.63a1 1 0 0 1-.7-.28L.31 11.9a1.001 1.001 0 1 1 1.38-1.44L11.62 20 22 2.49a1.002 1.002 0 0 1 1.721-.174 1 1 0 0 1-.001 1.174l-11 18.63a.999.999 0 0 1-.73.48l-.15.03Z"
})));

var _path$J;

function _extends$K() { _extends$K = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$K.apply(this, arguments); }

const SvgCheckmark2 = props => /*#__PURE__*/React__namespace.createElement("svg", _extends$K({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 10 10",
  fill: "currentColor"
}, props), _path$J || (_path$J = /*#__PURE__*/React__namespace.createElement("path", {
  d: "M15.159 7.969a.625.625 0 1 1 1.016.729l-5.5 7.666a.625.625 0 0 1-.95.078l-2.167-2.167a.625.625 0 0 1 .884-.884l1.646 1.646 5.07-7.068Z"
})));

var _path$I, _path2$n;

function _extends$J() { _extends$J = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$J.apply(this, arguments); }

const SvgChemistry = props => /*#__PURE__*/React__namespace.createElement("svg", _extends$J({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 25",
  fill: "currentColor"
}, props), _path$I || (_path$I = /*#__PURE__*/React__namespace.createElement("path", {
  d: "M23.3 8.499a1 1 0 0 0-1.36-.37l-3.27 1.92-3.28-1.92v-4.36a1 1 0 0 0-.5-.87L10.61.429a1 1 0 0 0-1 0l-4.27 2.47a1 1 0 0 0-.5.87v4.36l-3.78 2.18a1 1 0 0 0-.5.86v4.94a1 1 0 0 0 .5.86l4.28 2.47a1 1 0 0 0 .5.13 1 1 0 0 0 .5-.13l3.77-2.18 3.28 1.89v3.79a1 1 0 1 0 2 0v-3.79l3.77-2.18a1 1 0 0 0-1-1.73l-3.77 2.18-3.28-1.89v-3.78l3.28-1.89 3.72 2.19a1 1 0 0 0 1.05.04l3.78-2.18a1 1 0 0 0 .36-1.41ZM6.84 4.349l3.27-1.89 3.28 1.89v3.78l-3.28 1.92-3.27-1.92v-3.78Zm2.27 11.18-3.27 1.89-3.28-1.89v-3.78l3.28-1.89 3.27 1.89v3.78Z"
})), _path2$n || (_path2$n = /*#__PURE__*/React__namespace.createElement("path", {
  d: "M10.35 9.119a.54.54 0 0 0 .25-.07l1.88-1.09a.5.5 0 0 0 .19-.68.51.51 0 0 0-.67-.18l-1.9 1.09a.5.5 0 0 0 .25.93Z"
})));

var _path$H, _path2$m;

function _extends$I() { _extends$I = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$I.apply(this, arguments); }

const SvgConsulting = props => /*#__PURE__*/React__namespace.createElement("svg", _extends$I({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 25",
  fill: "currentColor"
}, props), _path$H || (_path$H = /*#__PURE__*/React__namespace.createElement("path", {
  d: "M22.75 7.279h-7.34v-5.18a1 1 0 0 0-1-1H1.13a1 1 0 0 0-1 1v9.45a1 1 0 0 0 1 1h.69v3.5a1 1 0 0 0 .67.94c.106.038.217.058.33.06a1 1 0 0 0 .78-.38l3.31-4.12h1.56v5.18a1 1 0 0 0 1 1h7.07l3.13 3.55a1 1 0 0 0 .75.33c.122 0 .244-.021.36-.06a1 1 0 0 0 .64-.94v-2.88h1.33a1 1 0 0 0 1-1v-9.45a1 1 0 0 0-1-1Zm-14.37 3.27h-2a1 1 0 0 0-.78.38l-1.78 2.28v-1.66a1 1 0 0 0-1-1h-.69v-7.45h11.28v4.12h-4a1 1 0 0 0-1 1l-.03 2.33Zm13.37 6.18h-1.33a1 1 0 0 0-1 1v1.24l-1.68-1.92a1 1 0 0 0-.75-.34h-6.52v-7.43h11.28v7.45Z"
})), _path2$m || (_path2$m = /*#__PURE__*/React__namespace.createElement("path", {
  d: "M12.66 14.049a1.22 1.22 0 1 1 0-2.44 1.22 1.22 0 0 1 0 2.44Zm3.23 0a1.22 1.22 0 1 1 0-2.44 1.22 1.22 0 0 1 0 2.44Zm3.23 0a1.22 1.22 0 1 1-.02-2.44 1.22 1.22 0 0 1 .02 2.44Z"
})));

var _path$G;

function _extends$H() { _extends$H = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$H.apply(this, arguments); }

const SvgCross = props => /*#__PURE__*/React__namespace.createElement("svg", _extends$H({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 25 24",
  fill: "currentColor"
}, props), _path$G || (_path$G = /*#__PURE__*/React__namespace.createElement("path", {
  d: "m13.448 12 10.2-10.2c.4-.4.4-1 0-1.4-.4-.4-1-.4-1.4 0l-10.2 10.2L1.848.4c-.4-.4-1-.4-1.4 0-.4.4-.4 1 0 1.4l10.2 10.2-10.2 10.2c-.4.4-.4 1 0 1.4.2.2.5.3.7.3.2 0 .5-.1.7-.3l10.2-10.2 10.2 10.2c.2.2.5.3.7.3.2 0 .5-.1.7-.3.4-.4.4-1 0-1.4L13.448 12Z"
})));

var _path$F;

function _extends$G() { _extends$G = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$G.apply(this, arguments); }

const SvgDna = props => /*#__PURE__*/React__namespace.createElement("svg", _extends$G({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 25",
  fill: "currentColor"
}, props), _path$F || (_path$F = /*#__PURE__*/React__namespace.createElement("path", {
  d: "M16.31 14.201a.997.997 0 0 0-.219 1.095c.05.122.125.232.219.325.16.16.3.35.45.52H8.41a5.651 5.651 0 0 1 4.26-2.54c5.7 0 8.69-7.07 9.23-11.53a1 1 0 0 0-.9-1.12 1 1 0 0 0-1.11.87c-.057.462-.14.919-.25 1.37H5.31c-.14-.5-.24-1-.33-1.43a1 1 0 0 0-1.16-.81A1 1 0 0 0 3 2.131c.18 1 1.65 8.16 6.05 10.63-3.4 2.32-5.37 7.57-6.05 10.71a1 1 0 0 0 .8 1.18H4a1 1 0 0 0 1-.79c.12-.57.28-1.19.48-1.83h14.07c.16.63.29 1.23.37 1.77a1 1 0 0 0 1 .85h.15a1.001 1.001 0 0 0 .84-1.14c-.43-2.85-1.76-6.79-4.18-9.29a.998.998 0 0 0-1.42-.02Zm2.78-9a16.615 16.615 0 0 1-.8 1.92H6.76a17.111 17.111 0 0 1-.83-1.92h13.16Zm-6.85 6.4A5.43 5.43 0 0 1 8 9.121h9a5.581 5.581 0 0 1-4.37 2.48h-.39Zm-6.06 8.45c.27-.65.58-1.29.91-1.91h11c.328.618.615 1.256.86 1.91H6.18Z"
})));

var _path$E, _path2$l;

function _extends$F() { _extends$F = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$F.apply(this, arguments); }

const SvgDownload = props => /*#__PURE__*/React__namespace.createElement("svg", _extends$F({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 25",
  fill: "currentColor"
}, props), _path$E || (_path$E = /*#__PURE__*/React__namespace.createElement("path", {
  d: "M21.992 6.775v-.131a2.11 2.11 0 0 0-.394-1.01l-.08-.101-4.15-4.957A1.909 1.909 0 0 0 15.995 0H5.957A2.958 2.958 0 0 0 3 2.958v18.084A2.958 2.958 0 0 0 5.958 24h13.126a2.969 2.969 0 0 0 2.959-2.958V6.775h-.051Zm-2.08 0h-3.958V2.019l3.958 4.756Zm.08 14.267a.939.939 0 0 1-.938.939H5.928a.94.94 0 0 1-.909-.94V2.959a.929.929 0 0 1 .94-.939h7.976v5.836a.94.94 0 0 0 .929.94h5.129v12.247Z"
})), _path2$l || (_path2$l = /*#__PURE__*/React__namespace.createElement("path", {
  d: "M13.895 11.581a.716.716 0 0 0-.717-.717h-1.434a.716.716 0 0 0-.717.717v3.564H8.109a.717.717 0 0 0-.495 1.222l4.312 4.291a.757.757 0 0 0 1.07 0l4.321-4.291a.718.718 0 0 0-.505-1.222h-2.918v-3.564Z"
})));

var _path$D;

function _extends$E() { _extends$E = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$E.apply(this, arguments); }

const SvgDrug = props => /*#__PURE__*/React__namespace.createElement("svg", _extends$E({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 25",
  fill: "currentColor"
}, props), _path$D || (_path$D = /*#__PURE__*/React__namespace.createElement("path", {
  d: "m22.9 14-5.41-7.68a4.73 4.73 0 0 0-3.87-2 4.72 4.72 0 0 0-4.41 3.07A4.61 4.61 0 0 0 0 7.62v9.24a4.62 4.62 0 1 0 9.24 0V10.7c.135.354.313.69.53 1l5.42 7.71a4.711 4.711 0 0 0 8.484-3.722A4.712 4.712 0 0 0 22.9 14ZM7 12.22H2V7.18A2.33 2.33 0 0 1 4.48 5 2.31 2.31 0 0 1 7 7.17v5.05Zm8 3.41-3.4-4.79a3.4 3.4 0 0 1-.7-2.27 2.9 2.9 0 0 1 1.4-1.69 2.81 2.81 0 0 1 1.63-.51 2.54 2.54 0 0 1 2.14 1.27l3.35 4.85L15 15.63Z"
})));

var _path$C, _path2$k;

function _extends$D() { _extends$D = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$D.apply(this, arguments); }

const SvgDryIce = props => /*#__PURE__*/React__namespace.createElement("svg", _extends$D({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 25",
  fill: "currentColor"
}, props), _path$C || (_path$C = /*#__PURE__*/React__namespace.createElement("path", {
  d: "M20.7 15.618a2.05 2.05 0 0 0-.63-.5 1 1 0 0 0 .17-.53v-4.23a.808.808 0 0 0-.06-.31 1.364 1.364 0 0 0-.18-.31l-.09-.08a.9.9 0 0 0-.2-.14h-.1l-7.53-2.7a1 1 0 0 0-.62 0l-7.27 2.23a1.23 1.23 0 0 0-.26.12h-.05v.05a1 1 0 0 0-.21.26.9.9 0 0 0-.09.32.19.19 0 0 0 0 .08.13.13 0 0 0 0 .06v10.4a1 1 0 0 0 .68.95l7.28 2.42c.1.032.205.049.31.05a.77.77 0 0 0 .27 0l3-.84a.999.999 0 0 0 .69-.73c.419.191.87.297 1.33.31.205.004.408-.03.6-.1a.49.49 0 0 0 .25-.64.51.51 0 0 0-.63-.29 1.69 1.69 0 0 1-1.15-.2 1.09 1.09 0 0 1-.61-1.47 1.33 1.33 0 0 1 1.4-1.03c.77.13.86.65.87.72a.503.503 0 0 0 1-.11 1.93 1.93 0 0 0-1.7-1.6 2.3 2.3 0 0 0-2.54 1.74 2.41 2.41 0 0 0 0 1.48h-.13l-1.75.49v-8l5.49-1.75v2.87a.863.863 0 0 0 .05.23 2.31 2.31 0 0 0-1.22.51c-.44.4-.714.95-.77 1.54a.5.5 0 0 0 .46.53.52.52 0 0 0 .54-.46c0-.21.17-1.26 1.58-1.14a1.47 1.47 0 0 1 1 .45c.211.29.314.643.29 1a.5.5 0 0 0 .44.55h.06a.49.49 0 0 0 .49-.44 2.49 2.49 0 0 0-.46-1.76Zm-9.95 5.8-5.27-1.75v-8.23l5.27 2v7.98Zm1-9.74-4.17-1.63 4.16-1.27 4.33 1.5-4.32 1.4Z"
})), _path2$k || (_path2$k = /*#__PURE__*/React__namespace.createElement("path", {
  d: "M20.19 22.378a2.55 2.55 0 0 1-1.87-1.06.51.51 0 0 1 .12-.7.497.497 0 0 1 .7.13 1.6 1.6 0 0 0 1.07.63 1.56 1.56 0 0 0 1-.31 1 1 0 0 0 .25-.77 1.11 1.11 0 0 0-1.14-1.25.5.5 0 0 1-.5-.5.51.51 0 0 1 .5-.5 2.112 2.112 0 0 1 2.1 2.22 2 2 0 0 1-.55 1.49 2.38 2.38 0 0 1-1.68.62ZM8.8 5.119a1.43 1.43 0 0 1-.56.22 3.26 3.26 0 0 1-.7.07 2.47 2.47 0 0 1-.82-.13 1.81 1.81 0 0 1-.72-.44 2.14 2.14 0 0 1-.44-.79 3.59 3.59 0 0 1-.17-1.16 3.16 3.16 0 0 1 .19-1.19 2.07 2.07 0 0 1 .51-.75 1.75 1.75 0 0 1 .7-.42 2.35 2.35 0 0 1 .77-.13c.235-.004.47.016.7.06.162.024.32.068.47.13l-.18.8a1.31 1.31 0 0 0-.38-.11 2.619 2.619 0 0 0-.52 0 1.14 1.14 0 0 0-.92.41 1.86 1.86 0 0 0-.35 1.26c0 .229.026.457.08.68.05.187.136.363.25.52.114.142.257.258.42.34.182.082.38.123.58.12a2 2 0 0 0 .53-.06 1.38 1.38 0 0 0 .37-.16l.19.73Zm.2-2.21a2.9 2.9 0 0 1 .54-1.86 1.85 1.85 0 0 1 1.51-.65c.31-.009.617.053.9.18.252.115.472.29.64.51.18.234.309.503.38.79.089.325.133.662.13 1a2.81 2.81 0 0 1-.54 1.85 1.82 1.82 0 0 1-1.51.65 2.14 2.14 0 0 1-.91-.18 1.66 1.66 0 0 1-.63-.51 2.15 2.15 0 0 1-.38-.79 4 4 0 0 1-.13-.99Zm1 0a3.59 3.59 0 0 0 .06.67c.035.182.1.357.19.52a.93.93 0 0 0 .33.35 1 1 0 0 0 1.25-.27 2.29 2.29 0 0 0 .28-1.27 3.455 3.455 0 0 0-.06-.66 1.661 1.661 0 0 0-.19-.53.91.91 0 0 0-.32-.35.83.83 0 0 0-.49-.13.92.92 0 0 0-.78.4 2.33 2.33 0 0 0-.27 1.27Zm6.63.36a2 2 0 0 1-.13.71 4 4 0 0 1-.32.7c-.131.23-.278.45-.44.66-.16.22-.31.41-.46.59l-.37.28.5-.1h1.32v.76h-2.9v-.42l.37-.4.42-.49c.14-.17.28-.35.41-.54.13-.178.25-.361.36-.55.096-.174.18-.355.25-.54.058-.16.088-.33.09-.5a.66.66 0 0 0-.16-.46.66.66 0 0 0-.51-.18 1.2 1.2 0 0 0-.45.09 1.08 1.08 0 0 0-.39.24l-.36-.64c.185-.146.39-.264.61-.35a2.17 2.17 0 0 1 .8-.13 1.63 1.63 0 0 1 .55.08c.156.047.3.13.42.24a.996.996 0 0 1 .28.4c.076.173.114.36.11.55Z"
})));

var _path$B;

function _extends$C() { _extends$C = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$C.apply(this, arguments); }

const SvgEmail = props => /*#__PURE__*/React__namespace.createElement("svg", _extends$C({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 25",
  fill: "currentColor"
}, props), _path$B || (_path$B = /*#__PURE__*/React__namespace.createElement("path", {
  d: "M21.59 4H2.21A2.21 2.21 0 0 0 0 6.21v11.61A2.22 2.22 0 0 0 2.21 20h19.38a2.22 2.22 0 0 0 2.22-2.22V6.21A2.21 2.21 0 0 0 21.59 4Zm-1.66 2-7.7 6.43a.65.65 0 0 1-.81 0L3.75 6h16.18Zm1.66 12H2.21a.22.22 0 0 1-.21-.18V7.14L10.14 14a2.58 2.58 0 0 0 1.68.61 2.62 2.62 0 0 0 1.69-.61l8.3-7v10.82a.22.22 0 0 1-.22.18Z"
})));

var _path$A, _path2$j;

function _extends$B() { _extends$B = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$B.apply(this, arguments); }

const SvgError = props => /*#__PURE__*/React__namespace.createElement("svg", _extends$B({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props), _path$A || (_path$A = /*#__PURE__*/React__namespace.createElement("path", {
  d: "M11.81 23.62a11.81 11.81 0 1 1 11.81-11.81 11.83 11.83 0 0 1-11.81 11.81Zm0-21.62a9.81 9.81 0 1 0 9.81 9.81A9.82 9.82 0 0 0 11.81 2Z"
})), _path2$j || (_path2$j = /*#__PURE__*/React__namespace.createElement("path", {
  d: "m13.23 11.59 3.25-3.26a1 1 0 0 0-1.41-1.41l-3.26 3.26-3.25-3.26a1 1 0 0 0-1.41 1.41l3.25 3.26-3.25 3.25a1 1 0 1 0 1.41 1.42L11.81 13l3.26 3.26a1 1 0 1 0 1.41-1.42l-3.25-3.25Z"
})));

var _path$z, _path2$i;

function _extends$A() { _extends$A = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$A.apply(this, arguments); }

const SvgEyeClosed = props => /*#__PURE__*/React__namespace.createElement("svg", _extends$A({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props), _path$z || (_path$z = /*#__PURE__*/React__namespace.createElement("path", {
  d: "M18.44 10.704a20.454 20.454 0 0 1-2.005 2.181C14.35 14.838 12.165 16 10 16c-.77 0-1.548-.148-2.33-.434a.5.5 0 1 0-.343.94A7.77 7.77 0 0 0 10 17c2.467 0 4.867-1.275 7.119-3.385a21.443 21.443 0 0 0 2.676-3.044c.1-.139.169-.24.206-.296a.5.5 0 0 0 0-.55 19.367 19.367 0 0 0-.78-1.052 21.412 21.412 0 0 0-2.105-2.29 18.516 18.516 0 0 0-.523-.473.5.5 0 1 0-.656.756c.167.144.332.293.495.446A20.473 20.473 0 0 1 18.974 10c-.153.213-.332.45-.535.704ZM1.56 9.296a20.454 20.454 0 0 1 2.005-2.181C5.65 5.162 7.835 4 10 4c.64 0 1.289.103 1.94.303a.5.5 0 1 0 .293-.956A7.598 7.598 0 0 0 10 3C7.533 3 5.133 4.275 2.881 6.385A21.443 21.443 0 0 0 .205 9.43c-.1.139-.169.24-.206.296a.5.5 0 0 0 0 .55c.037.057.107.157.206.296a21.459 21.459 0 0 0 2.679 3.046c.169.158.34.312.511.461a.5.5 0 1 0 .656-.754 17.533 17.533 0 0 1-.483-.437A20.47 20.47 0 0 1 1.026 10c.153-.213.332-.45.535-.704Z"
})), _path2$i || (_path2$i = /*#__PURE__*/React__namespace.createElement("path", {
  d: "M7.167 10c0-1.952 1.29-3.5 2.833-3.5a.5.5 0 1 0 0-1c-2.14 0-3.833 2.032-3.833 4.5a.5.5 0 1 0 1 0Zm5.666 0c0 1.952-1.29 3.5-2.833 3.5a.5.5 0 1 0 0 1c2.14 0 3.833-2.032 3.833-4.5a.5.5 0 1 0-1 0ZM17.74-.07 1.49 19.43a.5.5 0 1 0 .77.64L18.51.57a.5.5 0 0 0-.77-.64Z"
})));

var _path$y, _path2$h;

function _extends$z() { _extends$z = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$z.apply(this, arguments); }

const SvgEyeOpen = props => /*#__PURE__*/React__namespace.createElement("svg", _extends$z({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props), _path$y || (_path$y = /*#__PURE__*/React__namespace.createElement("path", {
  d: "M23.892 6.69a.5.5 0 0 1 0 .62 8.118 8.118 0 0 1-.247.296 23.48 23.48 0 0 1-3.205 3.038C17.759 12.738 14.909 14 12 14s-5.759-1.262-8.44-3.356A23.48 23.48 0 0 1 .355 7.606a9.117 9.117 0 0 1-.247-.296.5.5 0 0 1 0-.62c.044-.057.127-.157.247-.296A23.48 23.48 0 0 1 3.56 3.356C6.241 1.262 9.091 0 12 0s5.759 1.262 8.44 3.356a23.48 23.48 0 0 1 3.205 3.038c.12.139.203.24.247.296Zm-1.657-.36a22.49 22.49 0 0 0-2.41-2.186C17.302 2.175 14.648 1 12 1 9.35 1 6.697 2.175 4.176 4.144A22.49 22.49 0 0 0 1.153 7a22.49 22.49 0 0 0 3.023 2.856C6.697 11.825 9.35 13 12 13c2.65 0 5.303-1.175 7.824-3.144A22.49 22.49 0 0 0 22.847 7a19.392 19.392 0 0 0-.612-.67Z"
})), _path2$h || (_path2$h = /*#__PURE__*/React__namespace.createElement("path", {
  d: "M16.5 7c0 2.943-1.557 4.5-4.5 4.5S7.5 9.943 7.5 7 9.057 2.5 12 2.5s4.5 1.557 4.5 4.5Zm-1 0c0-2.39-1.11-3.5-3.5-3.5-2.39 0-3.5 1.11-3.5 3.5 0 2.39 1.11 3.5 3.5 3.5 2.39 0 3.5-1.11 3.5-3.5Z"
})));

var _path$x;

function _extends$y() { _extends$y = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$y.apply(this, arguments); }

const SvgFilter = props => /*#__PURE__*/React__namespace.createElement("svg", _extends$y({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 25",
  fill: "currentColor"
}, props), _path$x || (_path$x = /*#__PURE__*/React__namespace.createElement("path", {
  d: "M21 2.149c.8 0 1.2 1 .7 1.6l-7.1 7.1v10.2c0 .5-.5.9-.9.9-.2 0-.4-.1-.5-.2l-3.1-2.2c-.2-.2-.4-.5-.4-.8v-8l-7.3-7c-.6-.6-.2-1.6.7-1.6H21Zm0-2H3.1c-1.2 0-2.2.7-2.7 1.8s-.3 2.4.6 3.2l6.6 6.6v7.1c0 1 .5 1.8 1.2 2.4l3.1 2.2c.5.3 1.1.5 1.7.5 1.6 0 2.9-1.3 2.9-2.9v-9.3l6.5-6.6c.8-.8 1.1-2.1.6-3.2-.4-1.1-1.4-1.8-2.6-1.8Z"
})));

var _path$w, _path2$g;

function _extends$x() { _extends$x = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$x.apply(this, arguments); }

const SvgHazardous = props => /*#__PURE__*/React__namespace.createElement("svg", _extends$x({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props), _path$w || (_path$w = /*#__PURE__*/React__namespace.createElement("path", {
  d: "M22.69 23.76H1a1 1 0 0 1-.89-1.45L11 .55a1.1 1.1 0 0 1 .9-.55 1 1 0 0 1 .89.56l10.79 21.75a1 1 0 0 1 0 1 1 1 0 0 1-.89.45Zm-20.07-2h18.46L11.92 3.24l-9.3 18.52Z"
})), _path2$g || (_path2$g = /*#__PURE__*/React__namespace.createElement("path", {
  d: "m13.41 10-.88 6.41a.63.63 0 0 1-1.25 0L10.4 10a1.519 1.519 0 0 1 2.658-1.23A1.519 1.519 0 0 1 13.4 10h.01Zm-1.56 10.92a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z"
})));

var _path$v;

function _extends$w() { _extends$w = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$w.apply(this, arguments); }

const SvgHome = props => /*#__PURE__*/React__namespace.createElement("svg", _extends$w({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props), _path$v || (_path$v = /*#__PURE__*/React__namespace.createElement("path", {
  d: "M20.31 9.94a1 1 0 0 0-1 1v10.9h-4v-7.95a1 1 0 0 0-1-1h-5a1 1 0 0 0-1 1v8H4.24V10.94a1 1 0 1 0-2 0v11.9a1 1 0 0 0 1 1h17.07a1 1 0 0 0 1-1v-11.9a1 1 0 0 0-1-1Zm-10 11.9v-6.95h3v7l-3-.05Zm13.06-13.9L20.3 5.76V2a1 1 0 1 0-2 0v2.34L12.45.18a1 1 0 0 0-1.16 0L.42 7.94a1 1 0 1 0 1.16 1.63l10.29-7.34 10.34 7.34a1 1 0 0 0 1.16-1.63Z"
})));

var _path$u, _path2$f, _path3$1, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;

function _extends$v() { _extends$v = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$v.apply(this, arguments); }

const SvgIcePack = props => /*#__PURE__*/React__namespace.createElement("svg", _extends$v({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 25",
  fill: "currentColor"
}, props), _path$u || (_path$u = /*#__PURE__*/React__namespace.createElement("path", {
  d: "M12.29 12.448a.5.5 0 0 1-.5-.5v-4.33a.5.5 0 0 1 1 0v4.33a.51.51 0 0 1-.5.5Z"
})), _path2$f || (_path2$f = /*#__PURE__*/React__namespace.createElement("path", {
  d: "M12.29 10.129a.5.5 0 0 1-.35-.15l-1.25-1.25a.5.5 0 0 1 .355-.848.5.5 0 0 1 .355.148l1.25 1.25a.5.5 0 0 1-.36.85Z"
})), _path3$1 || (_path3$1 = /*#__PURE__*/React__namespace.createElement("path", {
  d: "M12.29 10.129a.5.5 0 0 1-.35-.85l1.26-1.23a.51.51 0 0 1 .71 0 .501.501 0 0 1 0 .71l-1.26 1.22a.51.51 0 0 1-.36.15Zm0 2.319a.549.549 0 0 1-.25-.07l-3.75-2.16a.52.52 0 0 1-.19-.69.51.51 0 0 1 .69-.18l3.75 2.16a.51.51 0 0 1-.001.873.5.5 0 0 1-.249.067Z"
})), _path4 || (_path4 = /*#__PURE__*/React__namespace.createElement("path", {
  d: "M8.58 11.739a.51.51 0 0 1-.49-.37.5.5 0 0 1 .36-.61l1.71-.46a.517.517 0 0 1 .26 1l-1.71.46-.13-.02Z"
})), _path5 || (_path5 = /*#__PURE__*/React__namespace.createElement("path", {
  d: "M10.29 11.278a.5.5 0 0 1-.49-.37l-.46-1.72a.516.516 0 1 1 1-.26l.46 1.72a.5.5 0 0 1-.35.61.32.32 0 0 1-.16.02Zm-1.75 3.33a.52.52 0 0 1-.44-.25.51.51 0 0 1 .19-.68l3.71-2.17a.5.5 0 0 1 .647.742.501.501 0 0 1-.147.129l-3.71 2.16a.47.47 0 0 1-.25.07Z"
})), _path6 || (_path6 = /*#__PURE__*/React__namespace.createElement("path", {
  d: "M9.82 15.309h-.13a.5.5 0 0 1-.35-.61l.45-1.71a.517.517 0 0 1 1 .26l-.46 1.71a.5.5 0 0 1-.51.35Z"
})), _path7 || (_path7 = /*#__PURE__*/React__namespace.createElement("path", {
  d: "M10.28 13.598h-.13l-1.73-.46a.5.5 0 0 1-.265-.786.498.498 0 0 1 .525-.184l1.73.46a.52.52 0 0 1 .35.62.5.5 0 0 1-.48.35Zm2.01 3.17a.5.5 0 0 1-.5-.5v-4.32a.5.5 0 1 1 1 0v4.32a.5.5 0 0 1-.5.5Z"
})), _path8 || (_path8 = /*#__PURE__*/React__namespace.createElement("path", {
  d: "M13.53 16.049a.5.5 0 0 1-.35-.14l-1.25-1.25a.502.502 0 0 1 0-.71.481.481 0 0 1 .7 0l1.25 1.25a.5.5 0 0 1-.35.85Z"
})), _path9 || (_path9 = /*#__PURE__*/React__namespace.createElement("path", {
  d: "M11 16.049a.51.51 0 0 1-.36-.15.51.51 0 0 1 0-.71l1.27-1.26a.481.481 0 0 1 .7 0 .5.5 0 0 1 0 .71l-1.26 1.26a.5.5 0 0 1-.35.15Zm5-1.441a.43.43 0 0 1-.25-.07L12 12.379a.502.502 0 1 1 .5-.87l3.75 2.17a.5.5 0 0 1-.25.93Z"
})), _path10 || (_path10 = /*#__PURE__*/React__namespace.createElement("path", {
  d: "M14.29 13.608a.49.49 0 0 1-.48-.37.478.478 0 0 1 .35-.61l1.71-.46a.5.5 0 0 1 .61.35.52.52 0 0 1-.35.62l-1.71.45a.32.32 0 0 1-.13.02Z"
})), _path11 || (_path11 = /*#__PURE__*/React__namespace.createElement("path", {
  d: "M14.75 15.338a.5.5 0 0 1-.48-.37l-.46-1.73a.478.478 0 0 1 .35-.61.5.5 0 0 1 .61.35l.46 1.73a.49.49 0 0 1-.35.61l-.13.02Zm-2.46-2.89a.51.51 0 0 1-.44-.25.52.52 0 0 1 .19-.69l3.75-2.16a.49.49 0 0 1 .68.18.51.51 0 0 1-.18.69l-3.75 2.16a.589.589 0 0 1-.25.07Z"
})), _path12 || (_path12 = /*#__PURE__*/React__namespace.createElement("path", {
  d: "M14.3 11.299h-.13a.498.498 0 0 1-.36-.61l.46-1.71a.5.5 0 0 1 .917-.124.51.51 0 0 1 .053.384l-.46 1.7a.5.5 0 0 1-.48.36Z"
})), _path13 || (_path13 = /*#__PURE__*/React__namespace.createElement("path", {
  d: "M16 11.758h-.13l-1.72-.46a.498.498 0 0 1-.123-.917.51.51 0 0 1 .383-.053l1.72.46a.504.504 0 1 1-.13 1v-.03Z"
})), _path14 || (_path14 = /*#__PURE__*/React__namespace.createElement("path", {
  d: "M18.26.359h-12a1 1 0 0 0-1 1v6.43l.02 9.06v5.68a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V1.358a1 1 0 0 0-1.02-1ZM7.28 16.849l.06-9v-2.31h9.94v12.86H7.3l-.02-1.55Zm0-14.49h10v1.13h-10v-1.13Zm10 19.17h-10v-1.13h10v1.13Z"
})));

var _path$t;

function _extends$u() { _extends$u = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$u.apply(this, arguments); }

const SvgInformation = props => /*#__PURE__*/React__namespace.createElement("svg", _extends$u({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 25",
  fill: "currentColor"
}, props), _path$t || (_path$t = /*#__PURE__*/React__namespace.createElement("path", {
  d: "M12 .149C5.4.149.1 5.449.1 12.049c0 6.6 5.3 11.9 11.9 11.9 6.6 0 11.9-5.3 11.9-11.9 0-6.6-5.3-11.9-11.9-11.9Zm0 3.2c1.5 0 2.7 1.2 2.7 2.7 0 1.5-1.2 2.6-2.7 2.6-1.5 0-2.7-1.2-2.7-2.6 0-1.4 1.2-2.7 2.7-2.7Zm3.6 16.2c0 .4-.3.8-.8.8H9.2c-.4 0-.8-.3-.8-.8v-1.5c0-.4.3-.8.8-.8h.8v-4.1h-.8c-.4 0-.8-.3-.8-.8v-1.5c0-.4.3-.8.8-.8h4.1c.4 0 .8.3.8.8v6.4h.8c.4 0 .8.3.8.8v1.5h-.1Z"
})));

var _path$s, _path2$e;

function _extends$t() { _extends$t = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$t.apply(this, arguments); }

const SvgInformationLight = props => /*#__PURE__*/React__namespace.createElement("svg", _extends$t({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props), _path$s || (_path$s = /*#__PURE__*/React__namespace.createElement("path", {
  d: "M11.81 23.62a11.81 11.81 0 1 1 11.81-11.81 11.83 11.83 0 0 1-11.81 11.81Zm0-21.62a9.81 9.81 0 1 0 9.81 9.81A9.82 9.82 0 0 0 11.81 2Z"
})), _path2$e || (_path2$e = /*#__PURE__*/React__namespace.createElement("path", {
  d: "M11.46 9.42a2.32 2.32 0 1 0 0-4.64 2.32 2.32 0 0 0 0 4.64Zm3.54 9.4a.66.66 0 0 1-.66.66H9.45a.65.65 0 0 1-.66-.66v-1.33a.66.66 0 0 1 .66-.66h.66v-3.54h-.66a.66.66 0 0 1-.66-.66V11.3a.65.65 0 0 1 .66-.66H13a.66.66 0 0 1 .66.66v5.53h.67a.67.67 0 0 1 .66.66l.01 1.33Z"
})));

var _path$r, _path2$d, _path3;

function _extends$s() { _extends$s = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$s.apply(this, arguments); }

const SvgKeystrokeEnter = props => /*#__PURE__*/React__namespace.createElement("svg", _extends$s({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 17 17",
  fill: "currentColor"
}, props), _path$r || (_path$r = /*#__PURE__*/React__namespace.createElement("path", {
  d: "M12.667-.5h-10A3.174 3.174 0 0 0-.5 2.667v10a3.174 3.174 0 0 0 3.167 3.166h10a3.174 3.174 0 0 0 3.166-3.166v-10A3.174 3.174 0 0 0 12.667-.5Zm-10 1h10c1.19 0 2.166.976 2.166 2.167v10c0 1.19-.976 2.166-2.166 2.166h-10A2.174 2.174 0 0 1 .5 12.667v-10C.5 1.477 1.476.5 2.667.5Z"
})), _path2$d || (_path2$d = /*#__PURE__*/React__namespace.createElement("path", {
  d: "M11.333 4.833a.5.5 0 0 1 .492.41l.008.09V8a.5.5 0 0 1-.41.492l-.09.008H4a.5.5 0 0 1-.09-.992L4 7.5h6.834V5.333a.5.5 0 0 1 .41-.492l.09-.008Z"
})), _path3 || (_path3 = /*#__PURE__*/React__namespace.createElement("path", {
  d: "M5.646 5.646a.5.5 0 0 1 .765.638l-.057.07L4.707 8l1.647 1.646a.5.5 0 0 1 .057.638l-.057.07a.5.5 0 0 1-.638.057l-.07-.057-2-2a.5.5 0 0 1-.057-.638l.057-.07 2-2Z"
})));

var _path$q, _path2$c;

function _extends$r() { _extends$r = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$r.apply(this, arguments); }

const SvgLogout = props => /*#__PURE__*/React__namespace.createElement("svg", _extends$r({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 25",
  fill: "currentColor"
}, props), _path$q || (_path$q = /*#__PURE__*/React__namespace.createElement("path", {
  d: "M13.85 22a1.861 1.861 0 0 1-.73-.14A1.93 1.93 0 0 1 12 20v-4H7.86A1.91 1.91 0 0 1 6 14.1V9.85a1.91 1.91 0 0 1 1.9-1.92H12v-4a1.92 1.92 0 0 1 1.16-1.78 1.88 1.88 0 0 1 2.07.41l7.83 7.94a2 2 0 0 1 0 2.72l-7.87 8.18a1.89 1.89 0 0 1-1.34.6ZM8 14h6v5.79l7.63-7.92L14 4.17 13.94 10H8v4Z"
})), _path2$c || (_path2$c = /*#__PURE__*/React__namespace.createElement("path", {
  d: "M7 20H3.16A3.17 3.17 0 0 1 0 16.82V7.16A3.17 3.17 0 0 1 3.16 4H7a1 1 0 0 1 0 2H3.16A1.17 1.17 0 0 0 2 7.16v9.66A1.17 1.17 0 0 0 3.16 18H7a1 1 0 0 1 0 2Z"
})));

var _path$p;

function _extends$q() { _extends$q = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$q.apply(this, arguments); }

const SvgMedicalDevice = props => /*#__PURE__*/React__namespace.createElement("svg", _extends$q({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 25",
  fill: "currentColor"
}, props), _path$p || (_path$p = /*#__PURE__*/React__namespace.createElement("path", {
  d: "M23.6 5.629 18.47.499a1 1 0 1 0-1.42 1.41l.83.83-3.14 3.14-.74-.71-1.48-1.52a1 1 0 1 0-1.42 1.4l.81.81-9.58 9.6a1 1 0 0 0-.24 1l1 3.26-2.49 2.52a1 1 0 0 0 .71 1.71 1 1 0 0 0 .69-.29l2.53-2.54 3.18.87a.854.854 0 0 0 .29.06.999.999 0 0 0 .71-.29l9.54-9.54.81.82a1 1 0 0 0 .71.29.998.998 0 0 0 .71-1.71l-2.25-2.25 3.14-3.14.82.82a1 1 0 0 0 1.41-1.42ZM7.7 19.909l-2.7-.73-.86-2.74.66-.66 1.41 1.41a.489.489 0 0 0 .35.15.51.51 0 0 0 .583-.5.5.5 0 0 0-.143-.35l-1.45-1.44L7 13.629l1.4 1.42a.478.478 0 0 0 .7 0 .48.48 0 0 0 0-.7l-1.41-1.42 1.4-1.4 1.41 1.4a.478.478 0 0 0 .7 0 .502.502 0 0 0 0-.71l-1.4-1.4 1.41-1.41 1.41 1.41a.52.52 0 0 0 .71 0 .502.502 0 0 0 0-.71l-1.41-1.41 1.41-1.41 1 1 2.46 2.47-9.09 9.15Zm9.12-12-.33-.32-.34-.34 3.14-3.1.66.66-3.13 3.1Z"
})));

var _path$o;

function _extends$p() { _extends$p = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$p.apply(this, arguments); }

const SvgMenuArrowDown = props => /*#__PURE__*/React__namespace.createElement("svg", _extends$p({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  fill: "none"
}, props), _path$o || (_path$o = /*#__PURE__*/React__namespace.createElement("path", {
  fill: "#000",
  d: "M19.407 8.697c.534 0 .8.666.4 1.067l-7.207 5.34c-.4.266-.934.266-1.334 0l-7.074-5.34c-.4-.4-.133-1.067.4-1.067h14.815Z"
})));

var _path$n;

function _extends$o() { _extends$o = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$o.apply(this, arguments); }

const SvgMenuArrowUp = props => /*#__PURE__*/React__namespace.createElement("svg", _extends$o({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  fill: "none"
}, props), _path$n || (_path$n = /*#__PURE__*/React__namespace.createElement("path", {
  fill: "#000",
  d: "M19.407 15.303c.534 0 .8-.666.4-1.067L12.6 8.896a1.212 1.212 0 0 0-1.334 0l-7.074 5.34c-.4.4-.133 1.067.4 1.067h14.815Z"
})));

var _path$m;

function _extends$n() { _extends$n = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$n.apply(this, arguments); }

const SvgMenuMoreHorizontal = props => /*#__PURE__*/React__namespace.createElement("svg", _extends$n({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props), _path$m || (_path$m = /*#__PURE__*/React__namespace.createElement("path", {
  d: "M6 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2Zm12 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2Zm-6 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2Z"
})));

var _path$l;

function _extends$m() { _extends$m = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$m.apply(this, arguments); }

const SvgMenuMoreVertical = props => /*#__PURE__*/React__namespace.createElement("svg", _extends$m({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props), _path$l || (_path$l = /*#__PURE__*/React__namespace.createElement("path", {
  d: "M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2Zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2Zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2Z"
})));

var _path$k, _path2$b;

function _extends$l() { _extends$l = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$l.apply(this, arguments); }

const SvgMicroscope = props => /*#__PURE__*/React__namespace.createElement("svg", _extends$l({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 25",
  fill: "currentColor"
}, props), _path$k || (_path$k = /*#__PURE__*/React__namespace.createElement("path", {
  d: "M21 21.48h-.79a9.71 9.71 0 0 0 2.07-6 8.06 8.06 0 0 0-8-8V4.31A2.159 2.159 0 0 0 13.1 2.4 1.58 1.58 0 0 0 11.53 1h-3A1.58 1.58 0 0 0 7 2.4a2.14 2.14 0 0 0-1.2 1.91v8.1a2.15 2.15 0 0 0 1.59 2.08v.89A1.58 1.58 0 0 0 9 17h2.1a1.568 1.568 0 0 0 1.57-1.58v-.89a2.15 2.15 0 0 0 1.6-2.08v-3a6.6 6.6 0 0 1 6 6c0 3-1.16 6-6.06 6L2 21.46a1 1 0 0 0 0 2l19 .07a1 1 0 0 0 1-1.05 1 1 0 0 0-1-1Zm-8.71-9.07a.16.16 0 0 1-.16.16h-1.46V15H9.39v-2.43H8a.16.16 0 0 1-.16-.16v-8.1A.16.16 0 0 1 8 4.16h1V3h2.15v1.16h1a.16.16 0 0 1 .16.15l-.02 8.1Z"
})), _path2$b || (_path2$b = /*#__PURE__*/React__namespace.createElement("path", {
  d: "M15 20.45H6a.5.5 0 0 1 0-1h9a.5.5 0 0 1 0 1Z"
})));

var _path$j;

function _extends$k() { _extends$k = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$k.apply(this, arguments); }

const SvgMinus = props => /*#__PURE__*/React__namespace.createElement("svg", _extends$k({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 25 24",
  fill: "currentColor"
}, props), _path$j || (_path$j = /*#__PURE__*/React__namespace.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M.054 12a1 1 0 0 1 1-1h22a1 1 0 1 1 0 2h-22a1 1 0 0 1-1-1Z"
})));

var _path$i;

function _extends$j() { _extends$j = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$j.apply(this, arguments); }

const SvgNavigationDrawer = props => /*#__PURE__*/React__namespace.createElement("svg", _extends$j({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 25",
  fill: "currentColor"
}, props), _path$i || (_path$i = /*#__PURE__*/React__namespace.createElement("path", {
  d: "M22.9 5.049H1.1c-.5 0-1-.4-1-1s.4-1 1-1h21.8c.5 0 1 .4 1 1s-.5 1-1 1Zm0 8H1.1c-.5 0-1-.4-1-1 0-.5.4-1 1-1h21.8c.5 0 1 .4 1 1 0 .5-.5 1-1 1Zm0 8H1.1c-.5 0-1-.4-1-1 0-.5.4-1 1-1h21.8c.5 0 1 .4 1 1s-.5 1-1 1Z"
})));

var _path$h, _path2$a;

function _extends$i() { _extends$i = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$i.apply(this, arguments); }

const SvgPencil = props => /*#__PURE__*/React__namespace.createElement("svg", _extends$i({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 25",
  fill: "currentColor"
}, props), _path$h || (_path$h = /*#__PURE__*/React__namespace.createElement("path", {
  d: "M19.61 9.82a1.42 1.42 0 0 1-1-.42l-4-3.95a1.42 1.42 0 0 1 0-2l1.68-1.66a2.72 2.72 0 0 1 3.83 0l2.14 2.14a2.72 2.72 0 0 1 0 3.83L20.62 9.4a1.42 1.42 0 0 1-1.01.42Zm-3.14-5.38 3.14 3.14 1.24-1.23a.74.74 0 0 0 .15-.775.68.68 0 0 0-.15-.225L18.71 3.2a.72.72 0 0 0-1 0l-1.24 1.24ZM2.35 23.06a1.328 1.328 0 0 1-1-.36c-.56-.55-.39-1.27-.2-2l.73-4.18a1.33 1.33 0 0 1 .39-.75l10.1-10a1.45 1.45 0 0 1 2 0l4 4a1.42 1.42 0 0 1 0 2l-10.07 10a1.48 1.48 0 0 1-.81.42l-4.21.74a3.51 3.51 0 0 1-.93.13Zm1.5-6-.68 3.87 3.88-.68 9.55-9.48-3.19-3.2-9.56 9.49Z"
})), _path2$a || (_path2$a = /*#__PURE__*/React__namespace.createElement("path", {
  d: "M7 19.25a.469.469 0 0 1-.35-.15.5.5 0 0 1 0-.71l8-8a.5.5 0 0 1 .848.355.5.5 0 0 1-.148.355l-8 8a.49.49 0 0 1-.35.15Z"
})));

var _path$g;

function _extends$h() { _extends$h = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$h.apply(this, arguments); }

const SvgPhone = props => /*#__PURE__*/React__namespace.createElement("svg", _extends$h({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 25",
  fill: "currentColor"
}, props), _path$g || (_path$g = /*#__PURE__*/React__namespace.createElement("path", {
  d: "M16.84 2h.21l4 .93a.93.93 0 0 1 .72.91A17.93 17.93 0 0 1 3.86 21.79a.94.94 0 0 1-.86-.72l-.93-4A.94.94 0 0 1 2.56 16l4.33-1.85a.91.91 0 0 1 1.08.26l1.92 2.35a14.33 14.33 0 0 0 6.85-6.85L14.4 8a.93.93 0 0 1-.27-1.08L16 2.56a.94.94 0 0 1 .84-.56Zm0-2a2.93 2.93 0 0 0-2.69 1.76L12.29 6.1a3 3 0 0 0 .85 3.43l1 .86a12.3 12.3 0 0 1-3.8 3.8l-.87-1.06a2.91 2.91 0 0 0-3.42-.84l-4.27 1.85A3 3 0 0 0 .07 17.5l.93 4a2.92 2.92 0 0 0 2.86 2.27A20 20 0 0 0 23.79 3.86 2.92 2.92 0 0 0 21.51 1l-4-.93a3.7 3.7 0 0 0-.67-.07Z"
})));

var _path$f;

function _extends$g() { _extends$g = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$g.apply(this, arguments); }

const SvgPlus = props => /*#__PURE__*/React__namespace.createElement("svg", _extends$g({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 25 24",
  fill: "currentColor"
}, props), _path$f || (_path$f = /*#__PURE__*/React__namespace.createElement("path", {
  d: "M22.948 11h-9.9V1.1c0-.6-.4-1-1-1s-1 .4-1 1V11h-9.9c-.6 0-1 .4-1 1s.4 1 1 1h9.9v9.9c0 .6.4 1 1 1s1-.4 1-1V13h9.9c.6 0 1-.4 1-1 0-.5-.5-1-1-1Z"
})));

var _path$e, _path2$9;

function _extends$f() { _extends$f = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$f.apply(this, arguments); }

const SvgPrinter = props => /*#__PURE__*/React__namespace.createElement("svg", _extends$f({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 25",
  fill: "currentColor"
}, props), _path$e || (_path$e = /*#__PURE__*/React__namespace.createElement("path", {
  d: "M22.88 6.449h-3.55c.006-.07.006-.14 0-.21v-1.69a1 1 0 0 0-.29-.71l-3-3a1 1 0 0 0-.7-.29H5.6a1 1 0 0 0-1 1v4.44a.91.91 0 0 0 .13.46H1.15a1 1 0 0 0-1 1v9.83a1 1 0 0 0 1 1H4.6v3.53a1 1 0 0 0 1 1h12.77a1 1 0 0 0 1-1v-3.53h3.51a1 1 0 0 0 1-1v-9.83a1.001 1.001 0 0 0-1-1Zm-6.25-2.22h-1.08v-1.08l1.08 1.08ZM6.6 5.989v-3.41h7v2.65a1 1 0 0 0 1 1h2.82c-.005.07-.005.14 0 .21H6.48a1 1 0 0 0 .12-.45Zm10.77 14.82H6.6v-5.48h10.77v5.48Zm4.51-4.53h-2.51v-2a1 1 0 0 0-1-1H5.6a1 1 0 0 0-1 1v2H2.15v-7.83h19.73v7.83Z"
})), _path2$9 || (_path2$9 = /*#__PURE__*/React__namespace.createElement("path", {
  d: "M15.41 17.049h-7a.5.5 0 0 1-.5-.5.51.51 0 0 1 .5-.5h7a.5.5 0 0 1 0 1Zm0 1.52h-7a.51.51 0 0 1-.41-.52.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 .5.5.5.5 0 0 1-.59.52Zm0 1.539h-7a.5.5 0 1 1 0-1h7a.5.5 0 0 1 0 1Zm-11.14-7.91a1.58 1.58 0 1 1 0-3.16 1.58 1.58 0 0 1 0 3.16Zm0-2.15a.58.58 0 1 0 .001 1.162.58.58 0 0 0 0-1.162Z"
})));

var _path$d, _path2$8;

function _extends$e() { _extends$e = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$e.apply(this, arguments); }

const SvgRecords = props => /*#__PURE__*/React__namespace.createElement("svg", _extends$e({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 25",
  fill: "currentColor"
}, props), _path$d || (_path$d = /*#__PURE__*/React__namespace.createElement("path", {
  d: "M20.25.189H10a1 1 0 0 0-1 1v2.49H6.54a1 1 0 0 0-1 1v2.5H3a1 1 0 0 0-1 1v14.76a1 1 0 0 0 1 1h10.25a1 1 0 0 0 1-1v-2.5h2.5a1 1 0 0 0 1-1v-2.5h2.5a1 1 0 0 0 1-1V1.188a1 1 0 0 0-1-1Zm-8 21.75H4V9.179h8.21v12.76h.04Zm3.5-3.5h-1.5V8.179a1 1 0 0 0-1-1H7.54v-1.5h8.21v12.76Zm3.5-3.5h-1.5V4.678a1 1 0 0 0-1-1H11v-1.49h8.21l.04 12.75Z"
})), _path2$8 || (_path2$8 = /*#__PURE__*/React__namespace.createElement("path", {
  d: "M10.43 11.319H5.88a.51.51 0 0 1-.5-.5.5.5 0 0 1 .5-.5h4.55a.5.5 0 1 1 0 1Zm0 2.26H5.88a.51.51 0 0 1-.5-.5.5.5 0 0 1 .5-.5h4.55a.5.5 0 1 1 0 1Zm0 2.25H5.88a.5.5 0 0 1-.5-.5.51.51 0 0 1 .5-.5h4.55a.5.5 0 1 1 0 1Zm0 2.22H5.88a.5.5 0 0 1-.5-.5.51.51 0 0 1 .5-.5h4.55a.5.5 0 1 1 0 1Zm0 2.3H5.88a.5.5 0 0 1-.5-.5.51.51 0 0 1 .5-.5h4.55a.5.5 0 1 1 0 1Z"
})));

var _path$c;

function _extends$d() { _extends$d = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$d.apply(this, arguments); }

const SvgSearch = props => /*#__PURE__*/React__namespace.createElement("svg", _extends$d({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 25",
  fill: "currentColor"
}, props), _path$c || (_path$c = /*#__PURE__*/React__namespace.createElement("path", {
  d: "M15.3.249c-4.8-.1-8.8 3.7-8.9 8.5 0 2.2.7 4.2 2 5.7l-8 7.7c-.4.4-.4 1 0 1.4.2.2.5.3.7.3.2 0 .5-.1.7-.3l8.1-7.7c1.4 1.1 3.1 1.7 5 1.7h.2c4.7 0 8.6-3.8 8.7-8.5.1-4.8-3.7-8.7-8.5-8.8Zm-.3 15.4c-3.7-.1-6.6-3.1-6.6-6.8.1-3.6 3.1-6.6 6.7-6.6h.1c3.8 0 6.7 3.1 6.6 6.8-.1 3.7-3.1 6.6-6.8 6.6Z"
})));

var _path$b;

function _extends$c() { _extends$c = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$c.apply(this, arguments); }

const SvgSort = props => /*#__PURE__*/React__namespace.createElement("svg", _extends$c({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 25",
  fill: "currentColor"
}, props), _path$b || (_path$b = /*#__PURE__*/React__namespace.createElement("path", {
  d: "M21.9 2.949H10.1c-.6 0-1-.4-1-1s.5-1 1-1H22c.6 0 1 .4 1 1s-.5 1-1.1 1Zm-2 6H10c-.6 0-1-.4-1-1s.5-1 1-1h9.9c.6 0 1 .4 1 1s-.4 1-1 1Zm-2 5.999H10c-.6 0-1-.4-1-1s.5-1 1-1h7.9c.6 0 1 .4 1 1s-.4 1-1 1Zm-2 6h-5.8c-.6 0-1-.4-1-1s.5-1 1-1h5.8c.6 0 1 .4 1 1s-.4 1-1 1Zm-10.7-2.3v-17.5c0-.6-.4-1-1-1s-1 .4-1 1v17.5H1.5c-.3 0-.6.4-.4.7l2.5 4.3c.3.5.9.5 1.2 0l2.5-4.3c.2-.3 0-.7-.4-.7H5.2Z"
})));

var _path$a, _path2$7;

function _extends$b() { _extends$b = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$b.apply(this, arguments); }

const SvgSuccess = props => /*#__PURE__*/React__namespace.createElement("svg", _extends$b({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props), _path$a || (_path$a = /*#__PURE__*/React__namespace.createElement("path", {
  d: "M11.81 23.62a11.81 11.81 0 1 1 11.81-11.81 11.83 11.83 0 0 1-11.81 11.81Zm0-21.62a9.81 9.81 0 1 0 9.81 9.81A9.82 9.82 0 0 0 11.81 2Z"
})), _path2$7 || (_path2$7 = /*#__PURE__*/React__namespace.createElement("path", {
  d: "M11.78 17.71a1 1 0 0 1-.7-.28L6 12.54a1 1 0 1 1 1.41-1.42l4.17 4 4.5-7.63a1 1 0 1 1 1.72 1l-5.14 8.73a1 1 0 0 1-.73.48l-.15.01Z"
})));

var _path$9, _path2$6;

function _extends$a() { _extends$a = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$a.apply(this, arguments); }

const SvgTempFull = props => /*#__PURE__*/React__namespace.createElement("svg", _extends$a({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 25",
  fill: "currentColor"
}, props), _path$9 || (_path$9 = /*#__PURE__*/React__namespace.createElement("path", {
  d: "M14.89 17.84a3 3 0 1 1-4.46-2.57V4.54a1.5 1.5 0 1 1 3 0v10.73a3.001 3.001 0 0 1 1.46 2.57Z"
})), _path2$6 || (_path2$6 = /*#__PURE__*/React__namespace.createElement("path", {
  d: "M11.92 2a2.43 2.43 0 0 1 2.43 2.44v10.15l.51.57A3.92 3.92 0 1 1 8 17.73a3.87 3.87 0 0 1 1-2.57l.5-.57V4.44A2.44 2.44 0 0 1 11.92 2Zm0-2a4.44 4.44 0 0 0-4.44 4.44v9.4a5.92 5.92 0 0 0 4.39 9.83 5.92 5.92 0 0 0 4.43-9.83v-9.4A4.43 4.43 0 0 0 11.92 0Z"
})));

var _path$8, _path2$5;

function _extends$9() { _extends$9 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$9.apply(this, arguments); }

const SvgTempHalf = props => /*#__PURE__*/React__namespace.createElement("svg", _extends$9({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 25",
  fill: "currentColor"
}, props), _path$8 || (_path$8 = /*#__PURE__*/React__namespace.createElement("path", {
  d: "M14.88 17.84a2.999 2.999 0 1 1-4.45-2.57v-6.1a1.5 1.5 0 0 1 3 0v6.1a3 3 0 0 1 1.45 2.57Z"
})), _path2$5 || (_path2$5 = /*#__PURE__*/React__namespace.createElement("path", {
  d: "M11.92 2a2.43 2.43 0 0 1 2.43 2.44v10.15l.51.57A3.92 3.92 0 1 1 8 17.73a3.87 3.87 0 0 1 1-2.57l.5-.57V4.44A2.44 2.44 0 0 1 11.92 2Zm0-2a4.44 4.44 0 0 0-4.44 4.44v9.4a5.92 5.92 0 0 0 4.39 9.83 5.92 5.92 0 0 0 4.43-9.83v-9.4A4.43 4.43 0 0 0 11.92 0Z"
})));

var _path$7, _path2$4;

function _extends$8() { _extends$8 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$8.apply(this, arguments); }

const SvgTempOneThird = props => /*#__PURE__*/React__namespace.createElement("svg", _extends$8({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 25",
  fill: "currentColor"
}, props), _path$7 || (_path$7 = /*#__PURE__*/React__namespace.createElement("path", {
  d: "M14.88 17.84a2.999 2.999 0 1 1-4.45-2.57v-2a1.5 1.5 0 0 1 3 0v2a3 3 0 0 1 1.45 2.57Z"
})), _path2$4 || (_path2$4 = /*#__PURE__*/React__namespace.createElement("path", {
  d: "M11.92 2a2.43 2.43 0 0 1 2.43 2.44v10.15l.51.57A3.92 3.92 0 1 1 8 17.73a3.87 3.87 0 0 1 1-2.57l.5-.57V4.44A2.44 2.44 0 0 1 11.92 2Zm0-2a4.44 4.44 0 0 0-4.44 4.44v9.4a5.92 5.92 0 0 0 4.39 9.83 5.92 5.92 0 0 0 4.43-9.83v-9.4A4.43 4.43 0 0 0 11.92 0Z"
})));

var _path$6;

function _extends$7() { _extends$7 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$7.apply(this, arguments); }

const SvgTempOther = props => /*#__PURE__*/React__namespace.createElement("svg", _extends$7({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props), _path$6 || (_path$6 = /*#__PURE__*/React__namespace.createElement("path", {
  d: "M6.92 2a2.43 2.43 0 0 1 2.43 2.44v10.15l.51.57A3.92 3.92 0 1 1 3 17.73a3.87 3.87 0 0 1 1-2.57l.5-.57V4.44A2.44 2.44 0 0 1 6.92 2Zm0-2a4.44 4.44 0 0 0-4.44 4.44v9.4a5.92 5.92 0 0 0 4.39 9.83 5.92 5.92 0 0 0 4.43-9.83v-9.4A4.43 4.43 0 0 0 6.92 0Zm6.65 7.06a1.48 1.48 0 1 1-.1-2.959 1.48 1.48 0 0 1 .1 2.959Zm3.52 0a1.48 1.48 0 1 1-.02-2.96 1.48 1.48 0 0 1 .02 2.96Zm3.51 0a1.48 1.48 0 1 1 0-2.96 1.48 1.48 0 0 1 0 2.96Z"
})));

var _path$5, _path2$3;

function _extends$6() { _extends$6 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$6.apply(this, arguments); }

const SvgTrash = props => /*#__PURE__*/React__namespace.createElement("svg", _extends$6({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 25",
  fill: "currentColor"
}, props), _path$5 || (_path$5 = /*#__PURE__*/React__namespace.createElement("path", {
  d: "M21.64 3.419h-5v-2.23a1 1 0 0 0-1-1H9.06a1 1 0 0 0-1 1v2.23H2.89a1 1 0 1 0 0 2h1.26v15.81a2.66 2.66 0 0 0 2.66 2.65h11a2.65 2.65 0 0 0 2.64-2.64V5.418h1.23a1 1 0 1 0 0-2h-.04Zm-11.58-1.23h4.56v1.23h-4.56v-1.23Zm8.35 19.05a.64.64 0 0 1-.64.64h-11a.66.66 0 0 1-.66-.65V5.418h12.3v15.82Z"
})), _path2$3 || (_path2$3 = /*#__PURE__*/React__namespace.createElement("path", {
  d: "M9.06 6.499a.51.51 0 0 0-.5.5v13.29a.5.5 0 1 0 1 0V7.048a.5.5 0 0 0-.5-.55Zm3.26 0a.5.5 0 0 0-.5.5v13.29a.5.5 0 0 0 1 0V7.048a.509.509 0 0 0-.5-.55Zm2.8.55v13.24a.5.5 0 0 0 1 0V7.048a.51.51 0 0 0-.5-.5.5.5 0 0 0-.5.5Z"
})));

var _clipPath, _g;

function _extends$5() { _extends$5 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5.apply(this, arguments); }

const SvgTruck = props => /*#__PURE__*/React__namespace.createElement("svg", _extends$5({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 25",
  fill: "currentColor"
}, props), _clipPath || (_clipPath = /*#__PURE__*/React__namespace.createElement("clipPath", {
  id: "truck_svg__a"
}, /*#__PURE__*/React__namespace.createElement("path", {
  d: "M0 2h23.84v19.75H0z"
}))), _g || (_g = /*#__PURE__*/React__namespace.createElement("g", {
  clipPath: "url(#truck_svg__a)"
}, /*#__PURE__*/React__namespace.createElement("path", {
  d: "M17.65 21.75a4.13 4.13 0 0 1-4-3.12h-2.38a4.11 4.11 0 0 1-8.1-1v-2.07a1 1 0 1 1 2 0v2.07a2.11 2.11 0 1 0 4.22 0v-1h6.15v1a2.11 2.11 0 1 0 4.22 0v-1h2.08v-1.22h-1V10.9a.59.59 0 0 0-.16-.39L17.4 7.27a.59.59 0 0 0-.4-.16h-2.42V4.56A.559.559 0 0 0 14 4H5.73a.56.56 0 0 0-.56.56v1a1 1 0 0 1-2 0v-1A2.56 2.56 0 0 1 5.73 2H14a2.56 2.56 0 0 1 2.56 2.56v.55H17a2.54 2.54 0 0 1 1.8.75l3.25 3.24a2.529 2.529 0 0 1 .75 1.8v2.58a1.54 1.54 0 0 1 1 1.44v2.13a1.45 1.45 0 0 1-1.46 1.58h-.74a4.13 4.13 0 0 1-3.95 3.12z"
}), /*#__PURE__*/React__namespace.createElement("path", {
  d: "M7.28 18.98a1.56 1.56 0 1 0 0-3.12 1.56 1.56 0 0 0 0 3.12zm10.37 0a1.56 1.56 0 1 0 0-3.12 1.56 1.56 0 0 0 0 3.12zm1.68-7.42h-4.67V7.93h1.43l3.24 3.23zM8.9 8.78H1a1 1 0 0 1 0-2h7.9a1 1 0 0 1 0 2zm0 5.35H1a1 1 0 0 1 0-2h7.9a1 1 0 0 1 0 2zm2.1-2.68H3a1 1 0 1 1 0-2h8a1 1 0 1 1 0 2z"
}))));

var _path$4, _path2$2;

function _extends$4() { _extends$4 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4.apply(this, arguments); }

const SvgUpload = props => /*#__PURE__*/React__namespace.createElement("svg", _extends$4({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props), _path$4 || (_path$4 = /*#__PURE__*/React__namespace.createElement("path", {
  d: "M21.81 6.71v-.13a2.09 2.09 0 0 0-.39-1l-.08-.1L17.23.57A1.89 1.89 0 0 0 15.87 0H5.93A2.93 2.93 0 0 0 3 2.93v17.91a2.93 2.93 0 0 0 2.93 2.93h13a2.94 2.94 0 0 0 2.93-2.93V6.71h-.05Zm-2.06 0h-3.92V2l3.92 4.71Zm.08 14.13a.93.93 0 0 1-.93.93h-13a.93.93 0 0 1-.9-.93V2.93A.92.92 0 0 1 5.93 2h7.9v5.78a.93.93 0 0 0 .92.93h5.08v12.13Z"
})), _path2$2 || (_path2$2 = /*#__PURE__*/React__namespace.createElement("path", {
  d: "M11 20a.71.71 0 0 0 .71.71h1.42a.711.711 0 0 0 .71-.71v-3.57h2.89a.71.71 0 0 0 .5-1.21L12.9 11a.738.738 0 0 0-1.06 0l-4.28 4.22a.71.71 0 0 0 .5 1.21H11V20Z"
})));

var _path$3;

function _extends$3() { _extends$3 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3.apply(this, arguments); }

const SvgUser = props => /*#__PURE__*/React__namespace.createElement("svg", _extends$3({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 25",
  fill: "currentColor"
}, props), _path$3 || (_path$3 = /*#__PURE__*/React__namespace.createElement("path", {
  d: "M15.7 13.608a7.16 7.16 0 1 0-7.47 0 10.24 10.24 0 0 0-5.55 9.3 1 1 0 1 0 2 0c0-4.51 3.28-8.18 7.32-8.18 4.04 0 7.32 3.67 7.32 8.18a1 1 0 1 0 2 0 10.25 10.25 0 0 0-5.62-9.3Zm-8.93-6.09a5.16 5.16 0 1 1 10.32.02 5.16 5.16 0 0 1-10.32-.02Z"
})));

var _path$2;

function _extends$2() { _extends$2 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2.apply(this, arguments); }

const SvgUsers = props => /*#__PURE__*/React__namespace.createElement("svg", _extends$2({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props), _path$2 || (_path$2 = /*#__PURE__*/React__namespace.createElement("path", {
  d: "M3.6 11.2c1.324 0 2.4-1.076 2.4-2.4 0-1.324-1.076-2.4-2.4-2.4a2.402 2.402 0 0 0-2.4 2.4c0 1.324 1.076 2.4 2.4 2.4Zm16.8 0c1.324 0 2.4-1.076 2.4-2.4 0-1.324-1.076-2.4-2.4-2.4A2.402 2.402 0 0 0 18 8.8c0 1.324 1.076 2.4 2.4 2.4Zm1.2 1.2h-2.4c-.66 0-1.256.266-1.691.697a5.485 5.485 0 0 1 2.816 4.103H22.8c.664 0 1.2-.536 1.2-1.2v-1.2c0-1.324-1.076-2.4-2.4-2.4Zm-9.6 0c2.321 0 4.2-1.879 4.2-4.2S14.321 4 12 4a4.198 4.198 0 0 0-4.2 4.2c0 2.321 1.879 4.2 4.2 4.2Zm2.88 1.2h-.311a5.91 5.91 0 0 1-2.569.6 5.92 5.92 0 0 1-2.569-.6H9.12a4.321 4.321 0 0 0-4.32 4.32V19a1.8 1.8 0 0 0 1.8 1.8h10.8a1.8 1.8 0 0 0 1.8-1.8v-1.08a4.321 4.321 0 0 0-4.32-4.32Zm-8.389-.502A2.393 2.393 0 0 0 4.8 12.4H2.4A2.402 2.402 0 0 0 0 14.8V16c0 .664.536 1.2 1.2 1.2h2.471a5.499 5.499 0 0 1 2.82-4.102Z"
})));

var _path$1, _path2$1;

function _extends$1() { _extends$1 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1.apply(this, arguments); }

const SvgWarning = props => /*#__PURE__*/React__namespace.createElement("svg", _extends$1({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props), _path$1 || (_path$1 = /*#__PURE__*/React__namespace.createElement("path", {
  d: "M11.81 23.62a11.81 11.81 0 1 1 11.81-11.81 11.83 11.83 0 0 1-11.81 11.81Zm0-21.62a9.81 9.81 0 1 0 9.81 9.81A9.82 9.82 0 0 0 11.81 2Z"
})), _path2$1 || (_path2$1 = /*#__PURE__*/React__namespace.createElement("path", {
  d: "m13.83 6.75-1 7.46a.75.75 0 0 1-.83.63.73.73 0 0 1-.63-.63l-1-7.46a1.76 1.76 0 1 1 3.49 0h-.03Zm-1.81 12.73a1.74 1.74 0 1 0 0-3.48 1.74 1.74 0 0 0 0 3.48Z"
})));

var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const SvgAccountCircle = props => /*#__PURE__*/React__namespace.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 25",
  fill: "currentColor"
}, props), _path || (_path = /*#__PURE__*/React__namespace.createElement("path", {
  d: "M12 3.451c-2.8 0-5.1 2.3-5.1 5.1s2.3 5.1 5.1 5.1 5.1-2.3 5.1-5.1-2.3-5.1-5.1-5.1Zm0 8.1c-1.7 0-3.1-1.4-3.1-3.1 0-1.7 1.4-3 3.1-3 1.7 0 3.1 1.4 3.1 3-.1 1.8-1.4 3.1-3.1 3.1Z"
})), _path2 || (_path2 = /*#__PURE__*/React__namespace.createElement("path", {
  d: "M12 .051C5.4.051.1 5.351.1 11.951c0 6.6 5.3 11.9 11.9 11.9 6.6 0 11.9-5.3 11.9-11.9 0-6.6-5.3-11.9-11.9-11.9Zm0 2c5.5 0 9.9 4.4 9.9 9.9 0 2.3-.8 4.5-2.2 6.2l-2.2-2.5-.1-.1c-1-.8-2.4-1-3.6-.4-.7.4-1.6.7-2.1.7-.7 0-1.5-.3-2.1-.7-.7-.5-1.8-.4-2.8.1-.1.1-.2.1-.3.2l-2.4 2.5c-1.3-1.7-2.1-3.8-2.1-6.1.1-5.4 4.5-9.8 10-9.8Zm-6.4 17.4 2.3-2.5c.3-.1.6-.1.7-.1.5.3 1.8.9 3.1.9 1 0 2.3-.5 3-.9.4-.2 1-.2 1.4.1l2.2 2.5c-1.7 1.4-3.9 2.3-6.3 2.3-2.5.1-4.7-.8-6.4-2.3Z"
})));

const icons = {
  Accounts: SvgAccounts,
  Address: SvgAddress,
  ArrowDown: SvgArrowDown,
  ArrowLeft: SvgArrowLeft,
  ArrowUp: SvgArrowUp,
  ArrowRight: SvgArrowRight,
  Beaker: SvgBeaker,
  Building: SvgBuilding,
  Box: SvgBox,
  Calendar: SvgCalendar,
  CheckmarkFilled: SvgCheckmarkFilled,
  Checkmark: SvgCheckmark,
  Checkmark2: SvgCheckmark2,
  Chemistry: SvgChemistry,
  Consulting: SvgConsulting,
  Cross: SvgCross,
  DNA: SvgDna,
  Download: SvgDownload,
  Drug: SvgDrug,
  DryIce: SvgDryIce,
  Email: SvgEmail,
  ErrorCircle: SvgError,
  EyeClosed: SvgEyeClosed,
  EyeOpen: SvgEyeOpen,
  Filter: SvgFilter,
  Hazardous: SvgHazardous,
  Home: SvgHome,
  IcePack: SvgIcePack,
  Information: SvgInformation,
  InformationLight: SvgInformationLight,
  KeystrokeEnter: SvgKeystrokeEnter,
  Logout: SvgLogout,
  MedicalDevice: SvgMedicalDevice,
  MenuArrowDown: SvgMenuArrowDown,
  MenuArrowUp: SvgMenuArrowUp,
  MenuMoreHorizontal: SvgMenuMoreHorizontal,
  MenuMoreVertical: SvgMenuMoreVertical,
  Microscope: SvgMicroscope,
  Minus: SvgMinus,
  NavigationDrawer: SvgNavigationDrawer,
  Pencil: SvgPencil,
  Phone: SvgPhone,
  Plus: SvgPlus,
  Printer: SvgPrinter,
  Records: SvgRecords,
  Search: SvgSearch,
  Sort: SvgSort,
  Success: SvgSuccess,
  TempFull: SvgTempFull,
  TempHalf: SvgTempHalf,
  TempOneThird: SvgTempOneThird,
  TempOther: SvgTempOther,
  Trash: SvgTrash,
  Truck: SvgTruck,
  Upload: SvgUpload,
  User: SvgUser,
  Users: SvgUsers,
  Warning: SvgWarning,
  AccountCircle: SvgAccountCircle
};

const Icon = _ref => {
  let {
    name,
    ...props
  } = _ref;
  const Component = icons[name];

  if (Component) {
    return /*#__PURE__*/React__default["default"].createElement(Component, props);
  }

  return null;
};

var Icon$1 = Icon;

class AccordionItem extends React__default["default"].Component {
  constructor(props) {
    super(props);
    this.toggleActive = this.toggleActive.bind(this);
    this.state = {
      isActive: props.isActive
    };
  }

  toggleActive() {
    this.setState({
      isActive: !this.state.isActive
    });
  }

  render() {
    const {
      label,
      children,
      className = '',
      headingClassName = '',
      activeClassName,
      inactiveClassName
    } = this.props;
    const {
      isActive
    } = this.state;
    const collapseGroupClassName = cx__default["default"](className, {
      'collapse-group--active': isActive,
      [activeClassName]: isActive,
      [inactiveClassName]: !isActive
    });

    const _headingClassName = cx__default["default"]('flex w-full items-center cursor-pointer', headingClassName || 'py-3');

    return /*#__PURE__*/React__default["default"].createElement("div", {
      className: collapseGroupClassName
    }, /*#__PURE__*/React__default["default"].createElement("div", {
      onClick: this.toggleActive,
      className: _headingClassName
    }, /*#__PURE__*/React__default["default"].createElement(Icon$1, {
      name: "ArrowDown",
      width: "16",
      className: "flex-none collapse-group-icon text-grey mx-1"
    }), /*#__PURE__*/React__default["default"].createElement("span", {
      className: "inline-block ml-4 mr-2"
    }, label)), this.state.isActive && /*#__PURE__*/React__default["default"].createElement("div", {
      className: "hidden",
      "data-collapse-target": true
    }, children));
  }

}

const ActionTile = _ref => {
  let {
    label,
    isChecked,
    disabled,
    children,
    className
  } = _ref;
  return /*#__PURE__*/React__default["default"].createElement("div", {
    className: cx__default["default"]('h-44 p-2 rounded flex flex-col text-center items-center justify-center border', {
      'action-tile border-grey-lightest': !isChecked,
      'action-tile--active': isChecked,
      'text-grey bg-moon-grey cursor-not-allowed': disabled
    }, className)
  }, /*#__PURE__*/React__default["default"].createElement("div", null, children), /*#__PURE__*/React__default["default"].createElement("h4", {
    dangerouslySetInnerHTML: {
      __html: label
    }
  }));
};

var ActionTile$1 = ActionTile;

const Avatar = _ref => {
  let {
    name,
    large = false,
    textColor = 'near-white',
    bgColor = 'grey',
    className = ''
  } = _ref;
  const smallClass = 'w-12 h-12 md:w-14 md:h-14 text-base';
  const largeClass = 'w-16 h-16 md:w-20 md:h-20 headline-base';
  const avatarClassName = cx__default["default"](`flex-none flex items-center justify-center bg-${bgColor} text-${textColor} font-bold uppercase rounded-full`, large ? largeClass : smallClass, className);
  return /*#__PURE__*/React__default["default"].createElement("span", {
    className: avatarClassName
  }, Strings.toInitials(name) || /*#__PURE__*/React__default["default"].createElement(SvgUser, {
    width: "24"
  }));
};

var Avatar$1 = Avatar;

const Badge = _ref => {
  let {
    label,
    color = 'blue',
    filled = false,
    ...props
  } = _ref;
  return /*#__PURE__*/React__default["default"].createElement("span", _rollupPluginBabelHelpers._extends({}, props, {
    className: cx__default["default"]('rounded-full', {
      'badge': filled,
      'badge-hollow': !filled
    })
  }), /*#__PURE__*/React__default["default"].createElement("span", {
    className: cx__default["default"]('w-2 h-2 block rounded-full mr-2', {
      [`bg-${color}`]: !!color
    })
  }), label);
};

var Badge$1 = Badge;

const hideOnEsc = {
  name: 'hideOnEsc',
  defaultValue: true,

  fn(_ref) {
    let {
      hide
    } = _ref;

    function onKeyDown(event) {
      if (event.keyCode === 27) {
        hide();
      }
    }

    return {
      onShow() {
        document.addEventListener('keydown', onKeyDown);
      },

      onHide() {
        document.removeEventListener('keydown', onKeyDown);
      }

    };
  }

};
const hideOnInteraction = {
  name: 'hideOnInteraction',
  defaultValue: true,

  fn(api) {
    const {
      popper,
      hide
    } = api;

    function onClick(event) {
      hide();
    }

    return {
      onShow() {
        popper.addEventListener('click', onClick);
      },

      onHide() {
        popper.removeEventListener('click', onClick);
      }

    };
  }

};
const TooltipPlugins = {
  hideOnEsc,
  hideOnInteraction
};
const Tooltip = Tippy__default["default"];
var Tooltip$1 = Tooltip;
const tippy = TippyJs__default["default"];
const ShowTooltip = _ref2 => {
  let {
    tooltip,
    useIcon,
    iconName,
    className,
    children,
    ...props
  } = _ref2;

  if (tooltip) {
    return /*#__PURE__*/React__default["default"].createElement(Tooltip, _rollupPluginBabelHelpers._extends({
      content: tooltip,
      placement: "top",
      offset: [0, 8]
    }, props), /*#__PURE__*/React__default["default"].createElement("span", {
      tabIndex: "-1",
      className: cx__default["default"]('inline-block align-text-bottom', className)
    }, useIcon ? /*#__PURE__*/React__default["default"].createElement(Icon$1, {
      name: iconName || 'Information',
      width: "16",
      className: "inline-block ml-1"
    }) : children));
  }

  return useIcon ? null : children;
};
const ContextMenu = _ref3 => {
  let {
    children,
    className,
    horizontal,
    label = 'Additional actions',
    placement = 'bottom-end'
  } = _ref3;
  return /*#__PURE__*/React__default["default"].createElement(Tippy__default["default"], {
    plugins: hideOnEsc,
    trigger: "click",
    maxWidth: 480,
    arrow: false,
    placement: placement,
    interactive: true,
    theme: "light",
    content: children
  }, /*#__PURE__*/React__default["default"].createElement(ContextMenu.Trigger, {
    label: label,
    horizontal: horizontal,
    className: className
  }));
};
ContextMenu.Trigger = /*#__PURE__*/React.forwardRef((_ref4, ref) => {
  let {
    label,
    horizontal,
    className
  } = _ref4;
  return /*#__PURE__*/React__default["default"].createElement("button", {
    ref: ref,
    className: cx__default["default"](className, 'hover:link-2'),
    "aria-label": label
  }, /*#__PURE__*/React__default["default"].createElement(Tippy__default["default"], {
    content: label,
    touch: false
  }, /*#__PURE__*/React__default["default"].createElement("span", {
    tabIndex: "0"
  }, /*#__PURE__*/React__default["default"].createElement(ContextMenu.TriggerIcon, {
    horizontal: horizontal
  }))));
});
ContextMenu.TriggerIcon = /*#__PURE__*/React.forwardRef((_ref5, ref) => {
  let {
    horizontal
  } = _ref5;
  return horizontal ? /*#__PURE__*/React__default["default"].createElement(Icon$1, {
    ref: ref,
    name: 'MenuMoreHorizontal',
    width: "20"
  }) : /*#__PURE__*/React__default["default"].createElement(Icon$1, {
    ref: ref,
    name: 'MenuMoreVertical',
    width: "20"
  });
});
ContextMenu.Content = /*#__PURE__*/React.forwardRef((_ref6, ref) => {
  let {
    children
  } = _ref6;
  return /*#__PURE__*/React__default["default"].createElement("div", {
    ref: ref,
    className: "flex flex-col p-6 w-40 text-base"
  }, children);
});

class Button extends React__default["default"].Component {
  constructor(props) {
    super(props);
    this.state = {
      active: false
    };
    this.handleToggle = this.handleToggle.bind(this);
  }

  handleClick = e => {
    const {
      disabled
    } = this.props;

    if (disabled) {
      e.preventDefault();
      return;
    }

    invoke__default["default"](this.props, 'onClick', e, this.props);
  };
  handleToggle = e => {
    e.preventDefault();
    this.setState(prevState => ({
      active: !prevState.active
    }));
  };

  render() {
    const {
      as = 'button',
      appendLabel,
      className,
      iconClassName,
      labelClassName,
      icon,
      href,
      type,
      primary = true,
      secondary,
      tertiary,
      ghosted,
      textLink,
      success,
      error,
      info,
      loading,
      fill,
      fillMobile,
      large,
      small,
      gradient,
      disabled = false,
      tooltip,
      processing,
      onClick,
      children,
      ...props
    } = this.props;

    if (as === 'a' && href === undefined) {
      console.warn(as + ' is an <a> tag without an href.');
    }

    let Element = href ? 'a' : as;
    const Icon = icon;
    const tagsList = ['a', 'div', 'button', 'input'];

    if (!tagsList.includes(Element)) {
      Element = 'button';
    }

    const buttonClassName = cx__default["default"]('button', {
      primary,
      secondary,
      tertiary,
      ghosted,
      textLink,
      success,
      error,
      info,
      fill,
      gradient,
      'w-full md:w-auto': fillMobile,
      'lg': large,
      'sm': small,
      disabled,
      accept: this.state.active,
      processing: loading || processing
    }, className);

    const _iconClassName = cx__default["default"]('mx-1 -my-2 flex-none', {
      'w-4': !large,
      'w-6': large
    }, iconClassName);

    return /*#__PURE__*/React__default["default"].createElement(ShowTooltip, {
      tooltip: tooltip
    }, /*#__PURE__*/React__default["default"].createElement(Element, _rollupPluginBabelHelpers._extends({}, props, {
      href: href,
      type: type,
      className: buttonClassName,
      onClick: this.handleClick,
      disabled: disabled
    }), Icon != null ? /*#__PURE__*/React__default["default"].createElement(Icon, {
      className: _iconClassName
    }) : null, /*#__PURE__*/React__default["default"].createElement("span", {
      className: cx__default["default"](labelClassName)
    }, children), !!appendLabel && /*#__PURE__*/React__default["default"].createElement("span", {
      className: "mx-1"
    }, appendLabel)));
  }

}

var Button$1 = Button;

const BackButton = _ref => {
  let {
    children,
    className,
    onClick = Functions.noop
  } = _ref;
  return /*#__PURE__*/React__default["default"].createElement("span", {
    "data-testid": "Index",
    className: cx__default["default"]('flex flex-nowrap items-center flex-0 font-semibold link-hover', className),
    onClick: onClick
  }, /*#__PURE__*/React__default["default"].createElement(Icon$1, {
    name: "ArrowLeft",
    width: "20",
    height: "20",
    className: "flex-none inline-block mr-2"
  }), children);
};

const BackButtonDrawer = _ref2 => {
  let {
    children,
    className,
    onClick = Functions.noop
  } = _ref2;
  return /*#__PURE__*/React__default["default"].createElement("span", {
    "data-testid": "BackButtonDrawer",
    className: cx__default["default"]('flex items-center flex-0 font-semibold link-hover', className),
    onClick: onClick
  }, /*#__PURE__*/React__default["default"].createElement(Icon$1, {
    name: "ArrowDown",
    width: "20",
    height: "20",
    className: "flex-none mr-2"
  }), children);
};

/*
@media (max-width: 752px) {
    .rdrDefinedRangesWrapper {
        display: none;
    }

        // force calendar to fit it's container for mobile only
    .rdrDateRangePickerWrapper,
    .rdrCalendarWrapper,
    .rdrDateRangeWrapper,
    .rdrMonths,
    .rdrMonth {
        width: 100%;
    }
}
*/

const PickerDefaults$1 = {
  rangeColors: ['#2f80ed']
};

const DateRangePicker = _ref => {
  let {
    ranges,
    pickerOptions = {},
    onChange = Functions.noop,
    className = ''
  } = _ref;
  const options = { ...PickerDefaults$1,
    ...pickerOptions
  };
  return /*#__PURE__*/React__default["default"].createElement(reactDateRange.DateRangePicker, _rollupPluginBabelHelpers._extends({
    className: className
  }, options, {
    ranges: ranges,
    onChange: onChange
  }));
};

DateRangePicker.propTypes = {
  ranges: propTypes.arrayOf(propTypes.shape({
    startDate: propTypes.instanceOf(Date),
    endDate: propTypes.instanceOf(Date),
    key: propTypes.string
  })).isRequired,
  pickerOptions: propTypes.shape({
    months: propTypes.number,
    direction: propTypes.oneOf(['horizontal', 'vertical']),
    editableDateInputs: propTypes.bool,
    inputRanges: propTypes.array,
    rangeColors: propTypes.arrayOf(propTypes.string),
    maxDate: propTypes.instanceOf(Date),
    minDate: propTypes.instanceOf(Date)
  })
};
var DateRangePicker$1 = DateRangePicker;

/*
@media (max-width: 752px) {
    .rdrDefinedRangesWrapper {
        display: none;
    }

        // force calendar to fit it's container for mobile only
    .rdrDateRangeWrapper,
    .rdrCalendarWrapper,
    .rdrDateRangeWrapper,
    .rdrMonths,
    .rdrMonth {
        width: 100%;
    }
}
*/

const PickerDefaults = {
  rangeColors: ['#2f80ed']
};

const DateRange = _ref => {
  let {
    ranges,
    pickerOptions = {},
    onChange = Functions.noop,
    className = ''
  } = _ref;
  const options = { ...PickerDefaults,
    ...pickerOptions
  };
  return /*#__PURE__*/React__default["default"].createElement(reactDateRange.DateRange, _rollupPluginBabelHelpers._extends({
    className: className
  }, options, {
    ranges: ranges,
    onChange: onChange
  }));
};

DateRange.propTypes = {
  ranges: propTypes.arrayOf(propTypes.shape({
    startDate: propTypes.instanceOf(Date),
    endDate: propTypes.instanceOf(Date),
    key: propTypes.string
  })).isRequired,
  pickerOptions: propTypes.shape({
    months: propTypes.number,
    direction: propTypes.oneOf(['horizontal', 'vertical']),
    editableDateInputs: propTypes.bool,
    inputRanges: propTypes.array,
    rangeColors: propTypes.arrayOf(propTypes.string),
    maxDate: propTypes.instanceOf(Date),
    minDate: propTypes.instanceOf(Date)
  })
};
var DateRange$1 = DateRange;

/**
 *
 * @param onRequestDownload XHR request object
 * @param file File{id, name, ext, mimetype}
 * @param onProgress Function ({loaded, total}) => {}
 * @returns {Promise<void>}
 */

const downloadSingle = async function (onRequestDownload, file) {
  let onProgress = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : () => {};
  const {
    name,
    ext,
    mimetype
  } = file;
  const resp = await onRequestDownload({
    file,
    onDownloadProgress: onProgress
  });
  return Media.fileDownload({
    data: resp?.data,
    filename: `${name}.${ext}`,
    mimetype
  });
};
/**
 * @param onRequestDownload XHR request object
 * @param files [File{id, name, ext, mimetype}]
 * @param onProgress Function ({loaded, total}) => {}
 * @param bundleName String - Name of .zip to be downloaded as
 * @returns {Promise<void>}
 */


const downloadBundle = async function (onRequestDownload, files) {
  let onProgress = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : () => {};
  let bundleName = arguments.length > 3 ? arguments[3] : undefined;
  const resp = await onRequestDownload({
    files,
    name: bundleName,
    onDownloadProgress: onProgress
  });
  const zip = new JSZip__default["default"]();
  const nameList = [];
  resp.forEach((item, index) => {
    const {
      name,
      ext
    } = files[index];
    const n = `${name}.${ext}`; // detect files with the same name and append index to filename so it doesn't get overwritten

    const nameMap = countBy__default["default"](identity__default["default"])(nameList);
    let fileName = nameMap[n] > 0 ? `${name} (${nameMap[n]})` : name;
    zip.file(`${fileName}.${ext}`, item.data);
    nameList.push(n);
  });
  const blob = await zip.generateAsync({
    type: 'blob'
  });
  return Media.fileDownload({
    data: blob,
    filename: `Download.zip`
  });
};
/**
 * @param onRequestDownload XHR request object
 * @param files [File{id, name, ext, mimetype}]
 * @param bundleName String
 * @returns {{onDownload: ((function(): Promise<void>)|*), isDownloading: boolean, progress: number, isComplete: boolean}}
 */


function useFileDownload(_ref) {
  let {
    onRequestDownload,
    files,
    bundleName = 'Download'
  } = _ref;
  // note -> if [id, scheme, name, mimetype] are missing the file can not be downloaded
  let timerId = React.useRef();
  const [isDownloading, setDownloading] = React.useState(false);
  const [isComplete, setComplete] = React.useState(false);
  const [progress, setProgress] = React.useState(0); // prompt user that there is still a download in progress

  React.useEffect(() => {
    if (isDownloading) {
      window.onbeforeunload = e => {
        e.preventDefault(); // Chrome requires returnValue to be set

        e.returnValue = '';
      };

      return null;
    }

    window.onbeforeunload = null;
    return () => window.onbeforeunload = null;
  }, [isDownloading]);
  React.useEffect(() => {
    if (isComplete) {
      timerId.current = setTimeout(resetState, 3000);
    }
  }, [isComplete]);

  const onDownload = async () => {
    if (isDownloading) {
      return;
    }

    try {
      onDownloadStart();

      if (files.length > 1) {
        await downloadBundle(onRequestDownload, files, onProgress, bundleName);
      } else {
        await downloadSingle(onRequestDownload, files[0], onProgress);
      }
    } catch (err) {
      resetState();
      console.error(err); // todo - allow onError handler here to trigger custom notifier provided by developer
    }

    setTimeout(resetState, 3000);
  };

  function onDownloadStart() {
    timerId.current && clearTimeout(timerId.current);
    timerId.current = null;
    setProgress(0);
    setComplete(false);
    setDownloading(true);
  }

  function onProgress(_ref2) {
    let {
      loaded,
      total
    } = _ref2;
    const p = loaded / total;
    setProgress(parseInt(p * 100, 10));

    if (p >= 1) {
      setComplete(true);
      setDownloading(false);
    }
  }

  function resetState() {
    setProgress(0);
    setComplete(false);
    setDownloading(false);
  }

  return {
    isDownloading,
    isComplete,
    progress,
    onDownload
  };
}

const FileDownloadButton = _ref => {
  let {
    label,
    file,
    onRequestDownload,
    className,
    children
  } = _ref;
  const {
    isDownloading,
    isComplete,
    progress,
    onDownload
  } = useFileDownload({
    onRequestDownload,
    files: [file]
  });
  return /*#__PURE__*/React__default["default"].createElement(Button$1, {
    icon: props => /*#__PURE__*/React__default["default"].createElement(Icon$1, _rollupPluginBabelHelpers._extends({
      name: "Download"
    }, props)),
    small: true,
    ghosted: true,
    tertiary: true,
    "aria-label": "Download",
    type: "button",
    className: cx__default["default"](className, {
      'cursor-wait': isDownloading
    }),
    disabled: isDownloading,
    processing: isDownloading,
    onClick: onDownload
  }, children({
    label,
    isDownloading,
    isComplete,
    progress
  }));
};

var FileDownloadButton$1 = FileDownloadButton;

const Show = _ref => {
  let {
    when,
    children
  } = _ref;
  return Boolean(when) && /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, children);
};

var Show$1 = Show;

const FileListItem = _ref => {
  let {
    file,
    onRemove,
    onDownload,
    children,
    successColor = 'blue',
    className = ''
  } = _ref;
  const [error, setError] = React.useState(null);
  const [processing, setProcessing] = React.useState(false);

  const handleRemove = async () => {
    setError(null);

    try {
      setProcessing(true);
      await onRemove(file); // note -> NO setProcessing( false ) to avoid setting state on unmounted component
    } catch (err) {
      setError('There was a problem removing this file, please try again');
      setProcessing(false);
    }
  };

  const handleDownload = async params => {
    setError(null);

    try {
      return await onDownload(params);
    } catch (err) {
      setError('There was a problem downloading this file, please try again');
      throw err;
    }
  };

  const lineItemClassName = cx__default["default"]('mb-1 p-2 border border-grey-lightest rounded', className, {
    'text-fail': error
  });
  return /*#__PURE__*/React__default["default"].createElement("li", {
    className: lineItemClassName
  }, /*#__PURE__*/React__default["default"].createElement("div", {
    className: "flex items-center"
  }, /*#__PURE__*/React__default["default"].createElement(Icon$1, {
    name: "Success",
    width: "24",
    className: `text-${successColor} flex-none mr-2`
  }), /*#__PURE__*/React__default["default"].createElement("span", {
    className: "flex-auto pr-4"
  }, children), /*#__PURE__*/React__default["default"].createElement(Show$1, {
    when: !!onRemove
  }, /*#__PURE__*/React__default["default"].createElement(Button$1, {
    icon: props => /*#__PURE__*/React__default["default"].createElement(Icon$1, _rollupPluginBabelHelpers._extends({
      name: "Trash"
    }, props)),
    small: true,
    ghosted: true,
    tertiary: true,
    "aria-label": "Remove",
    type: "button",
    className: "flex-none",
    disabled: processing,
    processing: processing,
    onClick: handleRemove
  }, "Remove")), /*#__PURE__*/React__default["default"].createElement(Show$1, {
    when: !!onDownload
  }, /*#__PURE__*/React__default["default"].createElement(FileDownloadButton$1, {
    className: "flex-none",
    onRequestDownload: handleDownload,
    label: "Download",
    file: file
  }, _ref2 => {
    let {
      label,
      progress,
      isDownloading,
      isComplete
    } = _ref2;
    return /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, /*#__PURE__*/React__default["default"].createElement(Show$1, {
      when: !isDownloading && !isComplete
    }, label), /*#__PURE__*/React__default["default"].createElement(Show$1, {
      when: isDownloading
    }, progress, "%"), /*#__PURE__*/React__default["default"].createElement(Show$1, {
      when: isComplete
    }, "Done!"));
  }))), /*#__PURE__*/React__default["default"].createElement(Show$1, {
    when: error
  }, /*#__PURE__*/React__default["default"].createElement("span", {
    className: "flex w-full items-center justify-end px-4"
  }, error)));
};

const FileList = _ref3 => {
  let {
    list = [],
    label = 'File(s) Uploaded:',
    className,
    labelClassName,
    lineItemClassName,
    successColor,
    onRemove,
    onDownload
  } = _ref3;
  return /*#__PURE__*/React__default["default"].createElement("div", {
    className: cx__default["default"](className)
  }, /*#__PURE__*/React__default["default"].createElement(Show$1, {
    when: label
  }, /*#__PURE__*/React__default["default"].createElement("h4", {
    className: cx__default["default"]('mb-2', labelClassName)
  }, label)), /*#__PURE__*/React__default["default"].createElement("ul", {
    className: "flex-auto"
  }, list.map(file => /*#__PURE__*/React__default["default"].createElement(FileListItem, {
    key: file.id,
    className: lineItemClassName,
    file: file,
    onRemove: onRemove,
    successColor: successColor,
    onDownload: onDownload
  }, file.name, ".", file.ext))));
};

var FileList$1 = FileList;

const SkeletonElement = _ref => {
  let {
    type = 'skeleton-custom',
    className
  } = _ref;
  return /*#__PURE__*/React__default["default"].createElement("div", {
    "data-testid": "SkeletonElement",
    className: cx__default["default"]('skeleton pulse', type, className)
  }, "\xA0");
};

const ArticleTile = _ref2 => {
  let {
    className
  } = _ref2;
  return /*#__PURE__*/React__default["default"].createElement("div", {
    className: className
  }, /*#__PURE__*/React__default["default"].createElement(SkeletonElement, {
    type: "thumbnail-full",
    className: "mb-4"
  }), /*#__PURE__*/React__default["default"].createElement(SkeletonElement, {
    type: "title"
  }), /*#__PURE__*/React__default["default"].createElement(SkeletonElement, {
    type: "text"
  }), /*#__PURE__*/React__default["default"].createElement(SkeletonElement, {
    type: "text"
  }));
};

const Paragraph = _ref3 => {
  let {
    className
  } = _ref3;
  return /*#__PURE__*/React__default["default"].createElement("div", {
    className: className
  }, /*#__PURE__*/React__default["default"].createElement(SkeletonElement, {
    type: "title"
  }), /*#__PURE__*/React__default["default"].createElement(SkeletonElement, {
    type: "text"
  }), /*#__PURE__*/React__default["default"].createElement(SkeletonElement, {
    type: "text"
  }));
};

const NavListVertical = _ref4 => {
  let {
    className
  } = _ref4;
  return /*#__PURE__*/React__default["default"].createElement("div", {
    className: className
  }, /*#__PURE__*/React__default["default"].createElement(SkeletonElement, {
    type: "navLink"
  }), /*#__PURE__*/React__default["default"].createElement(SkeletonElement, {
    type: "navLink ml-6"
  }), /*#__PURE__*/React__default["default"].createElement(SkeletonElement, {
    type: "navLink ml-6"
  }), /*#__PURE__*/React__default["default"].createElement(SkeletonElement, {
    type: "navLink"
  }), /*#__PURE__*/React__default["default"].createElement(SkeletonElement, {
    type: "navLink ml-6"
  }), /*#__PURE__*/React__default["default"].createElement(SkeletonElement, {
    type: "navLink ml-6"
  }), /*#__PURE__*/React__default["default"].createElement(SkeletonElement, {
    type: "navLink ml-6"
  }), /*#__PURE__*/React__default["default"].createElement(SkeletonElement, {
    type: "navLink"
  }), /*#__PURE__*/React__default["default"].createElement(SkeletonElement, {
    type: "navLink ml-6"
  }));
};

SkeletonElement.ArticleTile = ArticleTile;
SkeletonElement.Paragraph = Paragraph;
SkeletonElement.NavListVertical = NavListVertical;
var SkeletonElement$1 = SkeletonElement;

const styles = {
  wrap: 'input-group search-field-wrapper'
};
const styleCloseButton = {
  zIndex: 1,
  cursor: 'pointer',
  position: 'absolute',
  top: 0,
  bottom: 0,
  right: 0,
  width: '40px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  fontSize: '1.5rem',
  color: '#303030'
};

class SearchInput extends React.Component {
  static defaultProps = {
    placeholder: 'Search',
    submitActionLabel: 'Search',
    label: 'Search',
    showSubmitAction: false,
    showLabel: false,
    allowClear: true // id: `search-suggestions-${Math.floor( Math.random() * 10000 )}`

  };

  constructor(props) {
    super(props);
    this.id = this.props.id || `search-suggestions-${Guid.guid()}`;
  }

  onInput = e => {
    invoke__default["default"](this.props.search, 'onInput', e.target.value, e);
  };
  onKeyPress = e => {
    invoke__default["default"](this.props.search, 'onKeyPress', e.which, e);
  };
  onKeyDown = e => {
    invoke__default["default"](this.props.search, 'onKeyDown', e.which, e);

    if (e.which === 13) {
      this.input.blur();
      invoke__default["default"](this.props.search, 'onEnter', e);
    }
  };
  onKeyUp = e => {
    invoke__default["default"](this.props.search, 'onKeyUp', e.which, e);
  };
  onFocus = e => {
    invoke__default["default"](this.props.search, 'onFocus', e);
  };
  onBlur = e => {
    invoke__default["default"](this.props.search, 'onBlur', e);
  };
  onClear = e => {
    invoke__default["default"](this.props.search, 'onClear', e);
    setTimeout(() => this.input.focus(), 10);
  };
  onClickSubmit = e => {
    invoke__default["default"](this.props.search, 'onSubmit', e);
  };

  render() {
    const {
      label,
      showLabel,
      placeholder,
      allowClear,
      large,
      showSubmitAction,
      submitActionLabel,
      roundedTextField,
      search,
      labelClassName,
      inputClassName,
      className,
      prependSlot,
      ...restProps
    } = this.props;
    const query = pathOr__default["default"]('', ['query'], search);
    const transientQuery = pathOr__default["default"]('', ['transientQuery'], search);
    const inputClassNameCx = cx__default["default"]('w-full no-ms-clear', {
      'input-field-lg': large,
      'rounded-l-full': roundedTextField && !prependSlot
    }, inputClassName);
    const inputAppendClassName = cx__default["default"]('input-group-text', {
      'rounded-r-full': roundedTextField
    });
    return /*#__PURE__*/React__default["default"].createElement("div", {
      className: cx__default["default"](styles.wrap, className)
    }, /*#__PURE__*/React__default["default"].createElement(Show$1, {
      when: prependSlot
    }, /*#__PURE__*/React__default["default"].createElement("div", {
      className: "input-group-prepend"
    }, prependSlot)), /*#__PURE__*/React__default["default"].createElement("div", {
      className: "input-group-append"
    }, showSubmitAction ? /*#__PURE__*/React__default["default"].createElement(Button$1, {
      className: cx__default["default"](inputAppendClassName, 'button sm tertiary'),
      onClick: this.onClickSubmit,
      icon: () => /*#__PURE__*/React__default["default"].createElement(Icon$1, {
        name: "Search",
        className: "mr-1",
        width: "16",
        height: "16"
      }),
      title: submitActionLabel
    }, /*#__PURE__*/React__default["default"].createElement("span", null, submitActionLabel)) : /*#__PURE__*/React__default["default"].createElement("span", {
      className: inputAppendClassName
    }, /*#__PURE__*/React__default["default"].createElement(Icon$1, {
      name: "Search",
      width: "16",
      height: "16"
    }))), /*#__PURE__*/React__default["default"].createElement("div", {
      className: "relative input-group-input"
    }, /*#__PURE__*/React__default["default"].createElement("label", {
      htmlFor: this.id,
      className: cx__default["default"](labelClassName, {
        hidden: !showLabel
      })
    }, label), /*#__PURE__*/React__default["default"].createElement("input", _rollupPluginBabelHelpers._extends({
      id: this.id,
      "data-testid": "search-query-field",
      ref: ref => this.input = ref,
      className: inputClassNameCx,
      type: "text",
      value: transientQuery || query,
      placeholder: placeholder,
      onInput: this.onInput,
      onKeyPress: this.onKeyPress,
      onKeyDown: this.onKeyDown,
      onKeyUp: this.onKeyUp,
      onFocus: this.onFocus,
      autoComplete: "off",
      autoCapitalize: "off",
      autoCorrect: "off"
    }, restProps)), allowClear && query.length > 0 && /*#__PURE__*/React__default["default"].createElement("span", {
      onClick: this.onClear,
      style: styleCloseButton
    }, "\xD7")));
  }

}

SearchInput.Skeleton = _ref => {
  let {
    className
  } = _ref;
  return /*#__PURE__*/React__default["default"].createElement("div", {
    className: cx__default["default"](styles.wrap, className)
  }, /*#__PURE__*/React__default["default"].createElement(SkeletonElement$1, {
    className: "rounded-full h-10 w-full"
  }));
};

var SearchInput$1 = SearchInput;

/**
 * SearchResultItem -> wrapper component to display current selected index mouse and keyboard interactions
 * @param active
 * @param children
 * @return {*}
 * @constructor
 */

class SearchResultItem extends React.PureComponent {
  handleMouseEnter = evt => {
    invoke__default["default"](this.props, 'onResultHover', evt, this.props);
  };
  handleClick = evt => {
    invoke__default["default"](this.props, 'onResultClick', evt, this.props);
  };

  render() {
    const {
      index,
      active,
      activeClass = '',
      children,
      onResultHover,
      onResultClick,
      className,
      style = {},
      ...rest
    } = this.props;
    const itemClasses = cx__default["default"]('t-transform t-duration-short', className, {
      [activeClass]: active
    }); // console.log( `[SearchResultItem] #${index}` )

    return /*#__PURE__*/React__default["default"].createElement("div", _rollupPluginBabelHelpers._extends({
      id: `search-result-item-${index}`,
      "data-testid": "search-result-item",
      style: style,
      onMouseEnter: this.handleMouseEnter,
      onClick: this.handleClick,
      className: itemClasses
    }, rest), children);
  }

}

var SearchResultItem$1 = SearchResultItem;

const defaultStyles = 'pt-2 pb-6 flex justify-center w-full';

const SearchResultsEmpty = _ref => {
  let {
    loading,
    className
  } = _ref;
  return /*#__PURE__*/React__default["default"].createElement("div", {
    className: cx__default["default"](className, {
      [defaultStyles]: !className
    })
  }, loading ? '...' : 'No Results');
};

var SearchResultsEmpty$1 = SearchResultsEmpty;

const List$1 = /*#__PURE__*/React.memo(_ref => {
  let {
    children,
    className,
    ...props
  } = _ref;
  return /*#__PURE__*/React__default["default"].createElement("div", _rollupPluginBabelHelpers._extends({}, props, {
    className: cx__default["default"]('ut-search-suggestions-list no-bullet', className)
  }), children);
});
var List$2 = List$1;

const GroupLabel = /*#__PURE__*/React.memo(_ref => {
  let {
    children,
    className,
    ...props
  } = _ref;
  // console.log( '[GroupLabel]', children )
  return /*#__PURE__*/React__default["default"].createElement("div", _rollupPluginBabelHelpers._extends({}, props, {
    className: cx__default["default"]('ut-search-suggestions-group-label', className)
  }), children);
});
var GroupLabel$1 = GroupLabel;

class SearchResultsPagination extends React.PureComponent {
  static defaultProps = {
    showPagination: false,
    pageIndex: 0,
    groupIndex: 0,
    resultPerPage: Infinity,
    results: [],
    onPageIndexChange: Functions.noop
  };

  constructor(props) {
    super(props);
    this.loadMore = this.loadMore.bind(this);
    this.state = {
      pageIndex: props.pageIndex || 0
    };
  }

  loadMore() {
    const {
      results,
      resultsPerPage,
      onPageIndexChange,
      groupIndex
    } = this.props;
    const maxPageIndex = Math.ceil(results.length / resultsPerPage);
    const pageIndex = Math.min(Math.max(0, this.state.pageIndex + 1), maxPageIndex - 1);
    onPageIndexChange(pageIndex, groupIndex);
    this.setState({
      pageIndex
    });
  }

  getPagedResults(results, countPerPage, pageIndex) {
    return results.slice(0, countPerPage * (pageIndex + 1));
  }

  showPagination(currentResultCount) {
    const {
      results,
      showPagination
    } = this.props;
    return showPagination && currentResultCount < results.length;
  }

  render() {
    const {
      groupIndex,
      results,
      resultsPerPage,
      className
    } = this.props;
    const pagedResults = this.getPagedResults(results, resultsPerPage, this.state.pageIndex); // send result updates back to Container in order to manage focus and item selections
    // from current result set properly

    invoke__default["default"](this.props, 'onResultsChange', groupIndex, {
      results: pagedResults,
      resultCount: pagedResults.length
    });

    if (!pagedResults.length) {
      return null;
    }

    return /*#__PURE__*/React__default["default"].createElement("div", {
      className: cx__default["default"](className)
    }, this.props.children({
      pagedResults
    }), this.showPagination(pagedResults.length) && /*#__PURE__*/React__default["default"].createElement("div", {
      className: "flex flex-col items-center mt-8",
      "data-testid": "pagination-summary"
    }, /*#__PURE__*/React__default["default"].createElement("p", {
      className: "text-xs uppercase txt-c2 tracking-wide"
    }, "Showing ", pagedResults.length, " of ", results.length), /*#__PURE__*/React__default["default"].createElement(Button$1, {
      className: "mt-2",
      secondary: true,
      onClick: this.loadMore
    }, pagedResults.length + resultsPerPage < results.length ? `Next ${resultsPerPage} results` : 'Remaining results')));
  }

}

var SearchResultsPagination$1 = SearchResultsPagination;

class SearchResults extends React.PureComponent {
  constructor() {
    super();
    this.renderedResultGroups = this.renderedResultGroups.bind(this);
    this.renderPagedResults = this.renderPagedResults.bind(this);
    this.renderResultItem = this.renderResultItem.bind(this);
  }

  renderPagedResults(_ref) {
    let {
      pagedResults
    } = _ref;
    const {
      groupLabelClass,
      groupResultsClass
    } = this.props;
    const {
      groupName,
      renderer,
      virtualized,
      itemSize
    } = pagedResults?.[0]?.queryGroup;
    return /*#__PURE__*/React__default["default"].createElement(List$2, {
      "data-testid": "search-results-list",
      className: groupResultsClass
    }, groupName && /*#__PURE__*/React__default["default"].createElement(GroupLabel$1, {
      className: groupLabelClass
    }, groupName), virtualized ? /*#__PURE__*/React__default["default"].createElement(reactWindow.FixedSizeList, {
      width: "100%",
      height: itemSize * pagedResults.length,
      itemCount: pagedResults.length,
      itemSize: itemSize
    }, this.renderVirtualResultItem({
      results: pagedResults,
      renderer
    })) : pagedResults.map(this.renderResultItem({
      renderer
    })));
  }

  createSearchResultItem(result, RendererComponent) {
    let style = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
    const {
      resultItemClass,
      activeClass,
      search: {
        itemProps,
        selectedIndex,
        handleResultHover,
        handleResultClick
      }
    } = this.props;
    return /*#__PURE__*/React__default["default"].createElement(SearchResultItem$1, {
      index: result.index,
      key: `SearchResultItem-${Guid.guid()}`,
      onResultHover: handleResultHover,
      onResultClick: handleResultClick,
      style: style,
      className: resultItemClass,
      activeClass: activeClass,
      active: selectedIndex === result.index
    }, /*#__PURE__*/React__default["default"].createElement(RendererComponent, _rollupPluginBabelHelpers._extends({}, result, itemProps)));
  }

  renderResultItem(_ref2) {
    let {
      renderer
    } = _ref2;
    const RendererComponent = renderer;
    return result => this.createSearchResultItem(result, RendererComponent);
  }

  renderVirtualResultItem(_ref3) {
    let {
      results,
      renderer
    } = _ref3;
    const RendererComponent = renderer;
    return _ref4 => {
      let {
        index,
        style
      } = _ref4;
      const result = results[index];
      return result && this.createSearchResultItem(result, RendererComponent, style);
    };
  }

  renderedResultGroups() {
    const {
      className,
      search: {
        pageIndex,
        showPagination,
        resultGroups,
        query,
        queryGroups,
        onPageIndexChange,
        onVisibleResultsChange
      }
    } = this.props;
    let index = 0;
    return queryGroups.map((queryGroup, i) => {
      // predicate to determine if queryGroup should be hidden
      if (invoke__default["default"](queryGroup, 'hideIf', query, resultGroups)) {
        return null;
      }

      const group = resultGroups[i];
      const indexedResults = group.results.map(item => {
        const lineResult = {
          index: index,
          queryGroup,
          ...item
        };
        index++;
        return lineResult;
      });
      return /*#__PURE__*/React__default["default"].createElement(SearchResultsPagination$1, {
        className: className,
        groupIndex: i,
        key: `SearchResultsPagination-${Guid.guid()}`,
        onResultsChange: onVisibleResultsChange,
        showPagination: showPagination,
        query: query,
        results: indexedResults,
        pageIndex: group.pageIndex,
        onPageIndexChange: onPageIndexChange,
        resultsPerPage: group.resultLimit
      }, this.renderPagedResults);
    });
  }

  render() {
    const {
      noResultsClass,
      search: {
        loading,
        error,
        isActive,
        alwaysShowResults,
        showNoResults,
        hasResults
      }
    } = this.props;

    if (error || !isActive && !alwaysShowResults) {
      return null;
    }

    if (!hasResults) {
      return showNoResults ? this.props.children( /*#__PURE__*/React__default["default"].createElement(SearchResultsEmpty$1, {
        loading: loading,
        className: noResultsClass
      })) : null;
    }

    return this.props.children(this.renderedResultGroups());
  }

}

SearchResults.propTypes = {
  children: propTypes.func.isRequired
};
var SearchResults$1 = SearchResults;

const SearchResultsPane = _ref => {
  let {
    children
  } = _ref;
  return /*#__PURE__*/React__default["default"].createElement("div", {
    "data-testid": "search-results-pane",
    className: "search-results border-b border-solid border-grey-lightest fade-in a-duration-med flex flex-col bg-white w-full overflow-hidden overflow-y-auto mb-4"
  }, /*#__PURE__*/React__default["default"].createElement("div", {
    className: "search-results-list overflow-hidden overflow-y-auto scrolling-touch pb-20 md:pb-0"
  }, children));
};

var SearchResultsPane$1 = SearchResultsPane;

const SearchContext = /*#__PURE__*/React__default["default"].createContext();

function withSearch(Comp) {
  class Wrapper extends Comp {
    render() {
      return /*#__PURE__*/React__default["default"].createElement(SearchContext.Consumer, null, contextValue => /*#__PURE__*/React__default["default"].createElement(Comp, _rollupPluginBabelHelpers._extends({
        search: contextValue
      }, this.props)));
    }

  }

  Wrapper.displayName = `withSearch(${Comp.displayName || Comp.name})`;
  return Wrapper;
}

class Search extends React.Component {
  static ResultsPane = SearchResultsPane$1;
  static ResultItem = SearchResultItem$1;
  static Input = withSearch(SearchInput$1);
  static Results = withSearch(SearchResults$1);
  queryProvider = Functions.noop;
  queryErrorCount = 0;
  queryErrorThreshold = 15; // start with empty list which gets updated by onResultChange events from SearchResultPagination groups

  visibleResultGroups = [];
  static defaultProps = {
    initialQuery: '',
    alwaysShowResults: false,
    hideOnFocusout: false,
    hideOnResultSelect: false,
    showDefaultResults: false,
    showNoResults: true,
    onResultSelect: Functions.noop,
    queryGroup: {
      itemSize: 40,
      virtualized: false,
      queryProps: [],
      list: []
    },
    resultLimit: 7,
    minQueryLength: 3
  };

  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      error: false,
      selectedIndex: -1,
      isFocused: false,
      isActive: false,
      hideOnFocusout: props.hideOnFocusout,
      initialQueryGroup: props.queryGroup,
      queryGroups: Array.isArray(props.queryGroup) ? props.queryGroup : [props.queryGroup],
      // if results are from a static Provider, initialize queryGroups with a constructed queryList
      queryProvider: props.queryProvider || Search.createQueryProvider(props.queryGroup),
      resultGroups: [],
      query: props.initialQuery || '',
      transientQuery: null // temporary query value for populated by results focused from keyboard

    };
  }

  static getDerivedStateFromProps(props, state) {
    if (!equals__default$1["default"](props.initialQuery, state.prevInitialQuery)) {
      return {
        prevInitialQuery: props.initialQuery,
        query: props.initialQuery
      };
    }

    if (!equals__default$1["default"](props.queryGroup, state.initialQueryGroup)) {
      return {
        isDirty: true,
        initialQueryGroup: props.queryGroup,
        queryGroups: Array.isArray(props.queryGroup) ? props.queryGroup : [props.queryGroup],
        queryProvider: props.queryProvider || Search.createQueryProvider(props.queryGroup)
      };
    }

    return null;
  }

  static createQueryProvider(queryGroup) {
    const queryGroups = Array.isArray(queryGroup) ? queryGroup : [queryGroup]; // create a list of searchContexts each with their own data sets that can later be queried

    return queryGroups.map(grp => {
      const {
        list,
        queryProps,
        useStrictMatching
      } = grp;
      const ctx = upiFuzzySearch.createSearchContext(list, queryProps, useStrictMatching); // note - sorting needs to happen before filtering

      if (grp.sort) {
        ctx.setSorting(grp.sort);
      }

      if (grp.filter) {
        ctx.setFilters(grp.filter);
      }

      return { ...grp,
        query: ctx.query
      };
    });
  }

  shouldComponentUpdate(nextProps, nextState) {
    return !equals__default$1["default"](this.props, nextProps) || !equals__default$1["default"](this.state, nextState);
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (this.state.isDirty && this.state.isActive) {
      this.setState({
        isDirty: false
      });
      this.onSearch(this.state.query);
    }
  }

  componentDidMount() {
    this._ismounted = true; // note - immediately initiate search so show default results

    if (this.props.showDefaultResults) {
      this.onSearch(this.state.query);
    }

    if (this.state.hideOnFocusout) {
      document.addEventListener('click', this.hideOnFocusout);
    }
  }

  componentWillUnmount() {
    this._ismounted = false;
    document.removeEventListener('click', this.hideOnFocusout);
  }

  hideOnFocusout = _ref => {
    let {
      target
    } = _ref;
    const breakpointName = mediaQuery__default["default"].getBreakPointAlias();

    if (breakpointName === 'small') {
      return;
    } // click occurred inside the search component or a page modal -> remain active


    while (target && target.nodeName && target !== this.wrapper && target.nodeName.toLowerCase() !== 'html') {
      target = target.parentNode;
    }

    if (!target || target && target.nodeName.toLowerCase() === 'html') {
      this.clearSoft();
    }
  }; // [[{results: a}],[{results: b}]] -> Array [a,b]

  flattenResultGroups = compose__default["default"](flatten__default["default"], map__default["default"](prop__default["default"]('results'))); // [[{results: a}],[{results: b}]] -> Int

  getResultCount = compose__default["default"](length__default["default"], this.flattenResultGroups); // [[a],[b]] -> Boolean

  hasResults = compose__default["default"](gte__default["default"](____default["default"], 1), this.getResultCount);
  getActiveState = (query, doShow) => and__default["default"](gte__default["default"](query.length, this.props.minQueryLength), doShow);
  getQueriedResults = query => {
    const lastQuery = this.state.query; // static queryProvider will be an Array of queryGroups that can be mapped over

    return this.state.queryProvider.map((ctx, index) => {
      const currentResultGroup = this.state.resultGroups[index];
      const {
        results
      } = ctx.query(query); // apply index & metadata to each result

      return {
        results,
        pageIndex: query === lastQuery && currentResultGroup ? currentResultGroup?.pageIndex : 0,
        // reset pageIndex only if query changes
        resultLimit: ctx.resultLimit || this.props.resultLimit
      };
    });
  };
  queryStaticProvider = query => {
    const {
      alwaysShowResults,
      showDefaultResults
    } = this.props;
    const isActive = showDefaultResults || this.getActiveState(query, alwaysShowResults || this.state.isFocused);
    this.setState({
      query,
      isActive,
      resultGroups: isActive ? this.getQueriedResults(query) : []
    });
  };
  queryApiProvider = async query => {
    const {
      alwaysShowResults,
      showDefaultResults
    } = this.props;
    const isActive = showDefaultResults || this.getActiveState(query, alwaysShowResults || this.state.isFocused);
    this.setState(state => ({
      query,
      isActive,
      loading: true,
      error: false,
      resultGroups: isActive ? state.resultGroups : []
    }));

    if (isActive) {
      try {
        const resultGroups = await this.state.queryProvider(query);
        this._ismounted && this.setState({
          loading: false,
          resultGroups
        });
      } catch (error) {
        this.queryErrorCount += 1;
        this._ismounted && this.setState({
          loading: false,
          error: true
        });
      }
    }
  };
  setSelectionIndex = index => {
    if (this.props.ignoreSelectedIndex) {
      // don't track selected index to reduce excessive re-renders
      return;
    } // force index boundaries from 0 - maxLength


    const visibleCount = this.getResultCount(this.visibleResultGroups);
    const selectedIndex = Math.min(Math.max(index, -1), visibleCount - 1);
    this.setState({
      selectedIndex
    });
  };
  getSelectedResultsByIndex = index => {
    const flatResults = this.flattenResultGroups(this.visibleResultGroups);
    return flatResults[index];
  }; // CLear EVERYTHING

  clearHard = () => {
    this.visibleResultGroups = [];
    this.setState({
      query: '',
      transientQuery: null,
      resultGroups: [],
      isActive: false
    });
  }; // Preserve QUERY state while clearing everything else

  clearSoft = () => {
    if (!this.props.alwaysShowResults) {
      this.applyTransientQuery();
      this.visibleResultGroups = [];
      this.setState({
        resultGroups: [],
        isActive: false
      });
    }
  };
  applyTransientQuery = () => {
    if (this.state.transientQuery) {
      this.setState(_ref2 => {
        let {
          transientQuery
        } = _ref2;
        return {
          query: transientQuery,
          transientQuery: null
        };
      });
    }
  };
  onVisibleResultsChange = (index, newResults) => {
    this.visibleResultGroups[index] = newResults;
  };
  handleResultClick = (evt, _ref3) => {
    let {
      index
    } = _ref3;
    const selection = this.getSelectedResultsByIndex(index);
    this.handleResultSelect(evt, selection);
  };
  handleResultHover = (evt, _ref4) => {
    let {
      index
    } = _ref4;
    this.setSelectionIndex(index);
  };
  handleResultFocus = result => {
    // apply transientQuery value when results is focused from keyboard
    const transientQueryProp = result?.queryGroup?.transientQueryProp;
    this.setState({
      transientQuery: transientQueryProp ? result[transientQueryProp] : null
    });
    invoke__default["default"](this.props, 'onResultFocus', result);
  };
  handleResultSelect = (evt, result) => {
    if (this.props.hideOnResultSelect) {
      this.clearSoft();
    }

    invoke__default["default"](this.props, 'onResultSelect', evt, result);
  };
  onSubmit = evt => {
    this.clearSoft();
    const currentQuery = this.state.transientQuery || this.state.query;
    invoke__default["default"](this.props, 'onSubmit', evt, currentQuery);
  };
  onEnter = evt => {
    evt.preventDefault();
    const index = this.state.selectedIndex;

    if (index === -1) {
      this.onSubmit(evt);
      return;
    }

    const selection = this.getSelectedResultsByIndex(index);
    this.handleResultSelect(evt, selection);
  };
  onInput = value => {
    // if receive input while transientQuery; apply transientQuery
    this.applyTransientQuery();
    this.onSearch(value);
  };
  onClear = () => {
    this.clearHard();
  };
  onFocus = () => {
    this.setState({
      isFocused: true
    });
    this.onSearch(this.state.query);
  };
  onKeyUp = keycode => {
    this.setState({
      isFocused: keycode !== 27
    });
  };
  onKeyDown = keycode => {
    let index;
    let selection;

    switch (keycode) {
      // UP_ARROW
      // decrement selection index
      case 38:
        index = this.state.selectedIndex - 1;
        selection = this.getSelectedResultsByIndex(index);
        this.setSelectionIndex(index);
        this.handleResultFocus(selection);
        break;
      // DOWN_ARROW
      // increment selection index

      case 40:
        index = this.state.selectedIndex + 1;
        selection = this.getSelectedResultsByIndex(index);
        this.setSelectionIndex(index);
        this.handleResultFocus(selection);
        break;
      // ESC
      // make inActive

      case 27:
        this.clearSoft();
        break;

    }
  };
  onPageIndexChange = (() => {
    var _this = this;

    return function (index) {
      let queryGroupIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

      _this.setState(state => {
        const {
          resultGroups
        } = state;
        const newResultGroups = [...resultGroups];
        newResultGroups[queryGroupIndex] = { ...newResultGroups[queryGroupIndex],
          pageIndex: index
        };
        return {
          resultGroups: newResultGroups
        };
      });
    };
  })();
  onSearch = query => {
    // check if error limit has been exceeded
    if (this.queryErrorCount >= this.queryErrorThreshold) {
      console.warn('[Search:queryApiProvider] - Operation ignored; too many exceptions');
      this.setState({
        query,
        isActive: false,
        loading: false,
        error: false,
        resultGroups: []
      });
      return;
    } // reset selectedIndex anytime a query changes


    this.setSelectionIndex(-1);

    if (this.props.queryProvider != null) {
      this.queryApiProvider(query);
      return;
    }

    this.queryStaticProvider(query);
  };

  render() {
    const {
      alwaysShowResults,
      showDefaultResults,
      showNoResults,
      showPagination,
      itemProps,
      children
    } = this.props;
    const {
      loading,
      error,
      isActive,
      resultGroups,
      queryGroups
    } = this.state;
    const eventHandlers = pick__default["default"](['onClear', 'onInput', 'onEnter', 'onSubmit', 'onKeyDown', 'onKeyUp', 'onFocus', 'onPageIndexChange', 'onVisibleResultsChange', 'handleResultHover', 'handleResultClick'], this);
    const sendProps = {
      loading,
      error,
      resultGroups,
      queryGroups,
      hasResults: this.hasResults(resultGroups),
      itemProps,
      isActive,
      alwaysShowResults,
      showDefaultResults,
      showPagination,
      showNoResults,
      ...eventHandlers,
      ...this.state
    };
    return /*#__PURE__*/React__default["default"].createElement(SearchContext.Provider, {
      value: sendProps
    }, /*#__PURE__*/React__default["default"].createElement("div", {
      ref: ref => this.wrapper = ref,
      "data-testid": "search-container",
      className: "w-full"
    }, children(sendProps)));
  }

}

Search.propTypes = {
  children: propTypes.func.isRequired
};
var Search$1 = Search;

const TRUNC_THRESHOLD$1 = 3;

const TruncatedList = _ref => {
  let {
    list,
    renderer,
    itemProps,
    maxLength,
    className
  } = _ref;
  const remainingListCount = list.length - maxLength;
  const [showAll, setShowAll] = React.useState(remainingListCount < TRUNC_THRESHOLD$1 ? true : false);
  const takeSize = showAll ? list.length : maxLength;
  const Component = renderer;

  if (EmptyOrNil.isEmptyOrNil(list)) {
    return /*#__PURE__*/React__default["default"].createElement("div", {
      className: cx__default["default"](className)
    }, t('lists.label.empty', 'No Items in this list'));
  }

  return /*#__PURE__*/React__default["default"].createElement("div", {
    className: cx__default["default"](className)
  }, take__default["default"](takeSize, list).map(props => /*#__PURE__*/React__default["default"].createElement(Component, _rollupPluginBabelHelpers._extends({
    key: Guid.guid()
  }, props, itemProps))), remainingListCount >= TRUNC_THRESHOLD$1 && /*#__PURE__*/React__default["default"].createElement("span", {
    className: "subheading-sm my-1 link-2 cursor-pointer",
    onClick: () => setShowAll(state => !state)
  }, showAll ? t('actionLabel.showLess', 'Show less') : t('label.plusMoreWithCount', '+ {{count}} more', {
    count: remainingListCount
  })));
};

var TruncatedList$1 = TruncatedList;

const FilterList = _ref => {
  let {
    filter,
    alwaysShowResults,
    minQueryLength,
    itemProps,
    queryProps = [],
    list = [],
    renderer = Functions.noop,
    onResultSelect = Functions.noop,
    searchPlaceholder = null,
    maxLength = 5,
    enableSearchAtCount = 11,
    className = ''
  } = _ref;

  if (!list || list.length <= 0) {
    return /*#__PURE__*/React__default["default"].createElement("div", null, t('lists.label.empty', 'No Items in this list'));
  }

  const queryGroup = {
    list,
    queryProps,
    renderer,
    filter
  };

  if (list.length > enableSearchAtCount) {
    return /*#__PURE__*/React__default["default"].createElement(Search$1, {
      minQueryLength: minQueryLength,
      resultLimit: maxLength,
      alwaysShowResults: alwaysShowResults,
      onResultSelect: onResultSelect,
      itemProps: itemProps,
      queryGroup: [queryGroup]
    }, searchProps => /*#__PURE__*/React__default["default"].createElement("div", {
      "data-testid": "filterlist-pane",
      className: className
    }, /*#__PURE__*/React__default["default"].createElement("span", {
      className: "text-xs text-grey-dark mb-1 block"
    }, t('filterList.label.filterFromWithCount', 'Filter from {{count}} items in this list', {
      count: list.length
    })), /*#__PURE__*/React__default["default"].createElement("div", {
      className: "flex w-full lg:flex-1 mb-4"
    }, /*#__PURE__*/React__default["default"].createElement(Search$1.Input, {
      placeholder: searchPlaceholder
    })), /*#__PURE__*/React__default["default"].createElement(Search$1.Results, {
      activeClass: "text-brand",
      noResultsClass: "font-semibold mb-8"
    }, results => /*#__PURE__*/React__default["default"].createElement("div", {
      className: "my-2",
      "data-testid": "filterlist-results"
    }, results)), !searchProps.hasResults && /*#__PURE__*/React__default["default"].createElement("div", {
      className: "my-2"
    }, /*#__PURE__*/React__default["default"].createElement(TruncatedList$1, {
      list: list,
      renderer: renderer,
      itemProps: itemProps,
      maxLength: maxLength
    }))));
  }

  return /*#__PURE__*/React__default["default"].createElement("div", {
    "data-testid": "filterlist-pane"
  }, /*#__PURE__*/React__default["default"].createElement(TruncatedList$1, {
    list: list,
    renderer: renderer,
    itemProps: itemProps,
    maxLength: maxLength
  }));
};

var FilterList$1 = FilterList;

const {
  screenSmall,
  screenMedium,
  screenLarge
} = mediaQuery.breakpoints;
/**
 * input(em) -> tailwind.config -> breakPoints -> px
 *      26em:       sm -> screenSmall -> 416px
 *      47em:       md -> screenMedium -> 752px
 *      64.0625em:  lg -> screenLarge -> 1024px
 *      80em:       xl -> screenBase -> 1280px
 */

/**
 *
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */

const Mobile = props => {
  const isMobile = useMediaQuery(`(max-width: ${screenSmall}px)`);
  return isMobile ? /*#__PURE__*/React__default["default"].createElement("div", props) : null;
};
const Tablet = props => {
  const isTablet = useMediaQuery(`(min-width: ${screenMedium}px) and (max-width: ${screenLarge - 1}px)`);
  return isTablet ? /*#__PURE__*/React__default["default"].createElement("div", props) : null;
};
const HandheldDevice = props => {
  const isHandheldDevice = useMediaQuery(`(min-width: 0px) and (max-width: ${screenLarge - 1}px)`);
  return isHandheldDevice ? /*#__PURE__*/React__default["default"].createElement("div", props) : null;
};
const Desktop = props => {
  const isDesktop = useMediaQuery(`(min-width: ${screenLarge}px)`);
  return isDesktop ? /*#__PURE__*/React__default["default"].createElement("div", props) : null;
};
const SmallDevice = props => {
  const isSmallDevice = useMediaQuery(`(max-width: ${screenMedium - 1}px)`);
  return isSmallDevice ? /*#__PURE__*/React__default["default"].createElement("div", props) : null;
}; // render for anything but Mobile devices

const MediumDevice = props => {
  const isMediumDevice = useMediaQuery(`(min-width: ${screenMedium}px)`);
  return isMediumDevice ? /*#__PURE__*/React__default["default"].createElement("div", props) : null;
};

const Message = _ref => {
  let {
    children,
    className,
    processing,
    info,
    fail,
    notice,
    success,
    ...props
  } = _ref;
  return /*#__PURE__*/React__default["default"].createElement("div", _rollupPluginBabelHelpers._extends({
    className: cx__default["default"]("message-bar p-4 font-normal rounded", {
      processing,
      success,
      notice,
      info,
      fail
    }, className)
  }, props), /*#__PURE__*/React__default["default"].createElement("span", {
    className: "message-bar-msg"
  }, children));
};

var Message$1 = Message;

const ProcessingBar = _ref => {
  let {
    animated,
    color
  } = _ref;
  const wrapperClassName = cx__default["default"]('h-1.5 block rounded-lg', {
    'shimmer-color': animated
  });
  const progressClassName = cx__default["default"]('absolute top-0 h-1.5 w-full m-0 rounded-lg border-none', `bg-${color} opacity-90`, {
    'shimmer': animated
  });
  return /*#__PURE__*/React__default["default"].createElement("div", {
    className: "fadeUp relative",
    "data-testid": "ProgressBar"
  }, /*#__PURE__*/React__default["default"].createElement("span", {
    className: wrapperClassName
  }, /*#__PURE__*/React__default["default"].createElement("hr", {
    className: progressClassName
  })));
};

const ProgressBar = _ref2 => {
  let {
    progress,
    animated = true,
    color = 'blue',
    backgroundColor = 'transparent',
    className = ''
  } = _ref2;
  return /*#__PURE__*/React__default["default"].createElement("div", {
    role: "progressbar",
    className: cx__default["default"](`bg-${backgroundColor} w-full rounded-full`, className)
  }, /*#__PURE__*/React__default["default"].createElement("div", {
    style: {
      width: progress + '%'
    }
  }, /*#__PURE__*/React__default["default"].createElement(ProcessingBar, {
    animated: animated,
    color: color
  })));
};

var ProgressBar$1 = ProgressBar;

function safeSize(size) {
  const sizeMap = {
    xs: 'md:max-w-xs',
    sm: 'md:max-w-sm',
    md: 'md:max-w-md',
    lg: 'md:max-w-lg',
    xl: 'md:max-w-xl',
    '2xl': 'md:max-w-2xl',
    '3xl': 'md:max-w-3xl'
  };
  return sizeMap[size] ?? `max-w-full`;
}

const ModalContext = /*#__PURE__*/React__default["default"].createContext();
const MODAL_CONTAIN_VERT = 'flex h-full flex-col justify-center';
const MODAL_CONTAIN_HORZ = 'relative flex flex-col h-full md:h-auto md:py-12';
const MODAL_CONTENT = 'pointer-events-auto pt-14 md:pt-0 w-full h-full mx-auto bg-white md:shadow-1-strong md:rounded md:overflow-hidden md:static md:h-auto md:bg-transparent';
const DRAWER_CONTENT = 'pointer-events-auto fixed left-0 right-0 bottom-0 h-4/5 shadow-2 bg-white slide-up';
const MODAL_HEADER_MOBILE = 'translate--y z-10 w-full flex justify-between items-center fixed text-base bg-white p-4 border-b border-solid border-grey-lighter';
const MODAL_HEADER_DESKTOP = 'modal-header flex w-full items-center justify-between';
const MODAL_PRINT_ONLY = 'modal-print-only';
const NO_SCROLL = 'no-scroll';

const renderAction = function () {
  let labels = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    backAction: 'Back',
    drawerAction: 'Done'
  };
  let isDrawer = arguments.length > 1 ? arguments[1] : undefined;
  let onClose = arguments.length > 2 ? arguments[2] : undefined;
  return isDrawer ? /*#__PURE__*/React__default["default"].createElement(BackButtonDrawer, {
    onClick: onClose
  }, labels.drawerAction) : /*#__PURE__*/React__default["default"].createElement(BackButton, {
    onClick: onClose
  }, labels.backAction);
};

const ModalHeader = _ref => {
  let {
    labels,
    title,
    drawer,
    isClosable,
    onClose,
    className
  } = _ref;
  return /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, /*#__PURE__*/React__default["default"].createElement(SmallDevice, null, /*#__PURE__*/React__default["default"].createElement("header", {
    className: cx__default["default"](MODAL_HEADER_MOBILE, className)
  }, isClosable ? renderAction(labels, drawer, onClose) : /*#__PURE__*/React__default["default"].createElement("span", {
    className: "flex-0 w-8"
  }), /*#__PURE__*/React__default["default"].createElement("h2", {
    className: "subheading-base px-4 ellipsis"
  }, title), /*#__PURE__*/React__default["default"].createElement("span", {
    className: "flex-0 w-8"
  }))), /*#__PURE__*/React__default["default"].createElement(MediumDevice, null, /*#__PURE__*/React__default["default"].createElement("header", {
    className: cx__default["default"](MODAL_HEADER_DESKTOP, className)
  }, /*#__PURE__*/React__default["default"].createElement("h2", {
    className: "headline-sm"
  }, title), isClosable && /*#__PURE__*/React__default["default"].createElement("span", {
    onClick: onClose,
    className: "cursor-pointer inline-block w-10 ml-4 -mr-2 leading-none text-center text-black text-3xl"
  }, "\xD7"))));
};

const UPIModal = _ref2 => {
  let {
    children,
    id = 'UPI_MODAL',
    refOverlay = null,
    disablePageScrolling = true,
    labels,
    ...props
  } = _ref2;

  const onClose = () => invoke__default["default"](props, 'onClose', id);

  const isClosable = typeof props.onClose === 'function';
  const modalTitle = props.title || '';
  const sizeClass = safeSize(props.size);
  const modalEl = React__default["default"].useRef({});
  const SlotHeader = props.slotHeader ?? ModalHeader;
  React__default["default"].useEffect(() => {
    if (props.isOpen) {
      // re-append Modal.node to it's parent so current "Active" modal is always top layer
      const modalNode = modalEl.current.node;

      if (modalNode) {
        modalNode.parentNode.appendChild(modalNode);
      }

      const modalWrap = document.querySelector('.ReactModal__Overlay'); // reset scroll on modal

      if (modalWrap && modalWrap.scrollTo) {
        modalWrap.scrollTo(0, 0);
      } // prevent scrolling on body


      disablePageScrolling && document.documentElement.classList.add(NO_SCROLL);
      props.printOnly && document.documentElement.classList.add(MODAL_PRINT_ONLY);
    } else {
      document.documentElement.classList.remove(NO_SCROLL, MODAL_PRINT_ONLY);
    }

    return () => {
      document.documentElement.classList.remove(NO_SCROLL, MODAL_PRINT_ONLY);
    };
  }, [props.isOpen]);
  const contentStyles = props.drawer ? DRAWER_CONTENT : cx__default["default"](`${sizeClass}`, MODAL_CONTENT);
  const headerStyles = cx__default["default"]({
    'translate--y': props.drawer
  }, props.headerClassName);
  const bodyStyles = cx__default["default"](sizeClass, 'modal-body overflow-y-auto w-full mx-auto relative', {
    'absolute-center top-0 h-full': props.drawer
  }, props.contentClassName); // <div className="flex-auto"> need to be set to height:100vh for mobile

  return /*#__PURE__*/React__default["default"].createElement(ModalContext.Provider, {
    value: {
      onClose,
      backButtonLabel: props.backButtonLabel
    }
  }, /*#__PURE__*/React__default["default"].createElement(Modal__default["default"], _rollupPluginBabelHelpers._extends({
    id: id,
    ref: modalEl,
    appElement: document.body,
    onRequestClose: onClose,
    className: cx__default["default"](`${sizeClass}`, 'mx-auto h-full pointer-events-none')
  }, props), /*#__PURE__*/React__default["default"].createElement("div", {
    "data-testid": id,
    className: "flex-auto h-screen md:h-auto"
  }, /*#__PURE__*/React__default["default"].createElement("div", {
    className: MODAL_CONTAIN_VERT
  }, /*#__PURE__*/React__default["default"].createElement("div", {
    className: MODAL_CONTAIN_HORZ
  }, /*#__PURE__*/React__default["default"].createElement("div", {
    className: contentStyles
  }, /*#__PURE__*/React__default["default"].createElement(SlotHeader, {
    title: modalTitle,
    labels: labels,
    drawer: props.drawer,
    isClosable: isClosable,
    onClose: onClose,
    className: headerStyles
  }), props.processing && /*#__PURE__*/React__default["default"].createElement(ProcessingBar, null), /*#__PURE__*/React__default["default"].createElement("section", {
    className: bodyStyles
  }, children)))))));
};

UPIModal.displayName = 'UPIModal';
var UPIModal$1 = UPIModal;

const NumberBadge = _ref => {
  let {
    color,
    textColor,
    children,
    className
  } = _ref;
  return /*#__PURE__*/React__default["default"].createElement("span", {
    className: cx__default["default"]('shadow-sm flex-none w-10 h-10 rounded-full flex justify-center items-center', textColor && `text-${textColor}`, color && `bg-${color}`, className)
  }, children);
};

NumberBadge.propTypes = {
  color: propTypes.string,
  textColor: propTypes.string
};
var NumberBadge$1 = NumberBadge;

const PicklistContext = /*#__PURE__*/React.createContext();

function withPickList(PickListComponent) {
  function Wrapper(props) {
    return /*#__PURE__*/React__default["default"].createElement(PicklistContext.Consumer, null, contextValue => /*#__PURE__*/React__default["default"].createElement(PickListComponent, _rollupPluginBabelHelpers._extends({
      pickList: { ...contextValue
      }
    }, props)));
  }

  Wrapper.displayName = `withPickList(${React.Component.displayName || React.Component.name})`;
  return Wrapper;
}

const labelClasses = 'text-inherit mb-2 border-solid box-border-round t-bg-color t-duration-short bg-white hover:bg-near-white';

class PickListItem extends React.Component {
  handleInput = e => {
    const {
      pickList
    } = this.props;
    let doHandleInput = false;

    switch (e.type) {
      case 'click':
        // Bug: onClick firing when radio button is selected with arrow keys
        // resource -> https://github.com/facebook/react/issues/7407
        if (e.clientX !== 0 && e.clientY !== 0) {
          doHandleInput = true;
        }

        break;

      case 'keydown':
        // [SPACE key]
        if (e.which === 32) {
          doHandleInput = true;
        }

        break;
    }

    if (doHandleInput) {
      invoke__default["default"](pickList.actions, 'handleItemChange', e.target.value);
    }
  };

  render() {
    const {
      itemIdProp,
      selectedItem,
      groupId
    } = this.props.pickList;
    const itemId = prop__default["default"](itemIdProp, this.props) || '';
    const isChecked = prop__default["default"](itemIdProp, selectedItem) === itemId;
    const ListItem = this.props.renderer || DefaultRenderer; // note - remove unwanted prop "Symbol" from prop list to avoid issue with overriding native Symbol

    delete this.props.Symbol;
    return /*#__PURE__*/React__default["default"].createElement("label", {
      htmlFor: `${groupId}-${itemId}`,
      className: labelClasses
    }, /*#__PURE__*/React__default["default"].createElement(ListItem, this.props, /*#__PURE__*/React__default["default"].createElement("span", {
      className: "wrap-check mr-4"
    }, /*#__PURE__*/React__default["default"].createElement("input", {
      id: `${groupId}-${itemId}`,
      type: "radio",
      tabIndex: "0",
      name: groupId,
      defaultValue: itemId,
      checked: isChecked,
      onChange: this.handleInput,
      onKeyDown: this.handleInput,
      onClick: this.handleInput
    }), /*#__PURE__*/React__default["default"].createElement("span", {
      className: cx__default["default"]('radio', {
        checked: isChecked
      })
    }))));
  }

}

const DefaultRenderer = _ref => {
  let {
    className = '',
    children,
    ...data
  } = _ref;
  return /*#__PURE__*/React__default["default"].createElement("div", {
    className: className
  }, children, Object.entries(data).map(_ref2 => {
    let [key, value] = _ref2;
    return /*#__PURE__*/React__default["default"].createElement("span", {
      key: key,
      className: "block"
    }, key, " - ", String(value));
  }));
};

var Item = withPickList(PickListItem);

class PickList$2 extends React.Component {
  static defaultProps = {
    maxResultCount: 7,
    enableSearchAtCount: 11,
    queryProps: [],
    searchPlaceholder: ''
  };
  onResultSelect = (evt, result) => {
    const {
      pickList
    } = this.props;
    invoke__default["default"](pickList.actions, 'handleItemChange', result[pickList.itemIdProp]);
  };
  /**
   * Sort pluck current selectedItem from list and shift to front to improve user interaction
   */

  shiftSelectedItem(list, selectedItem) {
    if (!selectedItem) {
      return list;
    }

    const itemId = this.props.pickList.itemIdProp;
    const filteredList = list.filter(item => item[itemId] !== selectedItem[itemId]);
    return [selectedItem].concat(filteredList);
  }

  render() {
    const {
      pickList,
      itemRenderer,
      maxResultCount,
      searchPlaceholder,
      enableSearchAtCount,
      queryProps
    } = this.props;

    if (!pickList.isEditing || pickList.list.length <= 0) {
      return null;
    }

    const sortedList = this.shiftSelectedItem(pickList.list, pickList.selectedItem);

    const listItemRenderer = item => /*#__PURE__*/React__default["default"].createElement(Item, _rollupPluginBabelHelpers._extends({}, item, {
      renderer: itemRenderer
    }));

    return /*#__PURE__*/React__default["default"].createElement("div", {
      "data-testid": "picklist-list"
    }, pickList.allowAddItem && /*#__PURE__*/React__default["default"].createElement("div", {
      onClick: pickList.actions.toggleAddItem,
      className: "button-add-item mb-2"
    }, t('pickList.actionLabel.addAnother', '＋ Add another'), " ", pickList.itemType), /*#__PURE__*/React__default["default"].createElement(FilterList$1, {
      onResultSelect: this.onResultSelect,
      list: sortedList,
      queryProps: queryProps,
      renderer: listItemRenderer,
      searchPlaceholder: searchPlaceholder,
      maxLength: maxResultCount,
      enableSearchAtCount: enableSearchAtCount
    }));
  }

}

var List = withPickList(PickList$2);

const PickListSelection = _ref => {
  let {
    pickList,
    itemRenderer,
    className = '',
    interactionClassName = ''
  } = _ref;
  const {
    itemType,
    selectedItem,
    itemIdProp,
    groupId,
    isEditing,
    actions
  } = pickList;
  const Component = itemRenderer || Item;
  const isEditable = pickList.isEditable();
  const editAction = isEditable ? actions.toggleEditing : Functions.noop;
  return /*#__PURE__*/React__default["default"].createElement("div", {
    "data-testid": "picklist-selection",
    className: cx__default["default"]({
      hidden: isEditing
    })
  }, selectedItem ? /*#__PURE__*/React__default["default"].createElement("div", {
    className: cx__default["default"](className, {
      [interactionClassName]: isEditable
    })
  }, /*#__PURE__*/React__default["default"].createElement(Component, _rollupPluginBabelHelpers._extends({}, selectedItem, {
    onClick: editAction
  }))) : /*#__PURE__*/React__default["default"].createElement("div", {
    className: cx__default["default"]({
      'button-add-item': isEditable
    }),
    onClick: editAction
  }, /*#__PURE__*/React__default["default"].createElement("em", {
    className: "inline-block"
  }, "No ", itemType, " selected")), /*#__PURE__*/React__default["default"].createElement("input", {
    id: groupId,
    name: groupId,
    type: "text",
    "data-testid": "picklist-value",
    className: "visually-hidden",
    defaultValue: selectedItem ? selectedItem[itemIdProp] : '',
    required: true
  }));
};

var Selection = withPickList(PickListSelection);

const EditAction = _ref => {
  let {
    pickList,
    className = 'link-2 font-normal text-base'
  } = _ref;
  const {
    list,
    itemType,
    allowAddItem,
    actions
  } = pickList;
  const btnLabel = pickList.getToggleButtonLabel();

  if (list.length === 0 && allowAddItem) {
    return /*#__PURE__*/React__default["default"].createElement("a", {
      "data-testid": "picklist-edit",
      className: className,
      title: `Add ${itemType}`,
      onClick: actions.toggleAddItem
    }, t('actionLabel.add', 'Add'), " ", itemType);
  }

  if (pickList.isEditable()) {
    return /*#__PURE__*/React__default["default"].createElement("a", {
      "data-testid": "picklist-edit",
      className: className,
      title: btnLabel,
      onClick: actions.toggleEditing
    }, btnLabel);
  }

  return null;
};

var EditAction$1 = withPickList(EditAction);

class PickList extends React.Component {
  static defaultProps = {
    list: [],
    itemIdProp: 'id',
    itemType: 'item',
    groupId: 'picklist',
    allowAddItem: false,
    defaultSelection: null,
    customProps: {}
  };
  static List = List;
  static Item = Item;
  static Selection = Selection;
  static EditAction = EditAction$1;

  constructor(props) {
    super(props);
    this.handleItemChange = this.handleItemChange.bind(this);
    this.handleItemAdded = this.handleItemAdded.bind(this);
    this.toggleEditing = this.toggleEditing.bind(this);
    this.toggleAddItem = this.toggleAddItem.bind(this);
    this.getToggleButtonLabel = this.getToggleButtonLabel.bind(this);
    this.isEditable = this.isEditable.bind(this);
    this.state = {
      allowAddItem: props.allowAddItem,
      selectedItem: this.getSelectedItem(props),
      isEditing: false,
      isAddingItem: false
    };
  }

  getSelectedItem(_ref) {
    let {
      defaultSelection,
      list
    } = _ref;
    // if we're dealing with a single item list this item should always be the selected item
    return list.length === 1 ? list[0] : defaultSelection;
  }

  componentWillMount() {
    const renderProp = this.props.children;
    this.renderChildren = typeof renderProp === 'function' ? renderProp : Functions.noop;
  }

  componentDidMount() {
    const {
      selectedItem
    } = this.state;

    if (selectedItem != null) {
      invoke__default["default"](this.props, 'onItemChange', selectedItem, this.props.groupId);
    }
  }

  componentDidUpdate(previousProps, previousState, previousContext) {
    const {
      list,
      itemIdProp,
      defaultSelection
    } = this.props;

    if (!previousProps.defaultSelection || !defaultSelection) {
      return;
    }

    if (previousProps.defaultSelection[itemIdProp] !== defaultSelection[itemIdProp]) {
      const selectedItem = list.find(item => String(defaultSelection[itemIdProp]) === String(item[itemIdProp]));
      this.setState({
        selectedItem
      });
    }
  }

  isEditable() {
    return this.props.list.length > 1 || this.state.allowAddItem;
  }

  handleItemChange(id) {
    const {
      list,
      itemIdProp,
      groupId
    } = this.props;
    const selectedItem = list.find(item => String(id) === String(item[itemIdProp]));
    this.toggleEditing();
    this.setState({
      selectedItem
    });
    invoke__default["default"](this.props, 'onItemChange', selectedItem, groupId);
  }

  handleItemAdded(newItem) {
    this.setState({
      selectedItem: newItem,
      isAddingItem: false,
      isEditing: false
    });

    for (var _len = arguments.length, rest = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      rest[_key - 1] = arguments[_key];
    }

    invoke__default["default"](this.props, 'onItemAdded', newItem, ...rest);
  }

  toggleEditing() {
    this.setState({
      isEditing: !this.state.isEditing,
      isAddingItem: false
    }); // return scroll to selected item

    if (this.container) {
      this.container.focus();
    }
  }

  toggleAddItem() {
    this.setState({
      isAddingItem: !this.state.isAddingItem
    });
  }

  getToggleButtonLabel() {
    const {
      isEditing,
      selectedItem
    } = this.state;

    if (isEditing) {
      return t('pickList.actionLabel.cancel', 'Cancel change');
    }

    if (!selectedItem) {
      return t('pickList.actionLabel.select', 'Select item', {
        itemType: this.props.itemType
      });
    }

    return t('pickList.actionLabel.change', 'Change');
  }

  getContext() {
    const {
      list,
      itemIdProp,
      itemType,
      groupId,
      allowAddItem,
      defaultSelection,
      customProps
    } = this.props;
    return { ...this.state,
      list,
      itemIdProp,
      itemType,
      groupId,
      allowAddItem,
      defaultSelection,
      ...customProps,
      getToggleButtonLabel: this.getToggleButtonLabel,
      isEditable: this.isEditable,
      actions: {
        handleItemChange: this.handleItemChange,
        handleItemAdded: this.handleItemAdded,
        toggleEditing: this.toggleEditing,
        toggleAddItem: this.toggleAddItem
      }
    };
  }

  render() {
    const {
      className
    } = this.props;
    const pickList = this.getContext();
    const containerClasses = cx__default["default"](className, 'relative');
    return /*#__PURE__*/React__default["default"].createElement(PicklistContext.Provider, {
      value: pickList
    }, /*#__PURE__*/React__default["default"].createElement("div", {
      className: containerClasses,
      tabIndex: "-1",
      ref: ref => this.container = ref
    }, this.renderChildren(pickList)));
  }

}

var PickList$1 = PickList;

const useInputFocus = isFocused => {
  const fieldRef = React.useRef();
  React.useEffect(() => {
    if (isFocused) {
      setTimeout(() => fieldRef.current?.focus(), 10);
    }
  }, []);
  return {
    fieldRef
  };
};

/**
 * Simple wrapper around Formik that uses the validate handler to broadcast "onChange" event that allows
 * the ability to track field states without the need of a form submission handler
 *
 * This component accepts the Formik interface
 * Any props passed are spread on the Formik component
 *
 * resource - https://jaredpalmer.com/formik/docs/api/formik
 */

const TrackedFields = _ref => {
  let {
    onChange,
    ...props
  } = _ref;
  return /*#__PURE__*/React__default["default"].createElement(formik.Formik, _rollupPluginBabelHelpers._extends({
    validateOnChange: true,
    enableReinitialize: true,
    validate: values => onChange && onChange(values)
  }, props));
};

const NativeField = props => /*#__PURE__*/React__default["default"].createElement("input", props);

const FieldWrapper = _ref2 => {
  let {
    disabledTooltip,
    children,
    nativeField,
    ...props
  } = _ref2;
  const InputField = nativeField ? NativeField : formik.Field;
  return /*#__PURE__*/React__default["default"].createElement(ShowTooltip, {
    tooltip: props.disabled && disabledTooltip,
    className: "w-full"
  }, /*#__PURE__*/React__default["default"].createElement(InputField, props, children));
};
const FieldLabel = _ref3 => {
  let {
    id,
    label,
    hint,
    tooltip,
    error,
    append,
    className
  } = _ref3;
  return /*#__PURE__*/React__default["default"].createElement("div", {
    className: "w-full flex justify-between items-end"
  }, /*#__PURE__*/React__default["default"].createElement("span", null, /*#__PURE__*/React__default["default"].createElement(Label, {
    htmlFor: id,
    error: error,
    className: cx__default["default"](className)
  }, label), /*#__PURE__*/React__default["default"].createElement(ShowTooltip, {
    tooltip: tooltip,
    useIcon: true
  }), /*#__PURE__*/React__default["default"].createElement(Hint, {
    htmlFor: id,
    error: error
  }, hint)), /*#__PURE__*/React__default["default"].createElement(Show$1, {
    when: append
  }, /*#__PURE__*/React__default["default"].createElement("span", {
    className: "mb-1 leading-tight"
  }, append)));
};
const Label = _ref4 => {
  let {
    error,
    className,
    children,
    ...props
  } = _ref4;
  return /*#__PURE__*/React__default["default"].createElement(Show$1, {
    when: children
  }, /*#__PURE__*/React__default["default"].createElement("label", _rollupPluginBabelHelpers._extends({
    className: cx__default["default"]('input-label', className)
  }, props), children));
};
const Hint = _ref5 => {
  let {
    error,
    className,
    children,
    ...props
  } = _ref5;
  return /*#__PURE__*/React__default["default"].createElement(Show$1, {
    when: children
  }, /*#__PURE__*/React__default["default"].createElement("span", _rollupPluginBabelHelpers._extends({
    className: "input-hint mb-1 block text-caption text-base leading-tight"
  }, props), children));
};
const InputFeedback = _ref6 => {
  let {
    error,
    className
  } = _ref6;
  return error ? /*#__PURE__*/React__default["default"].createElement("div", {
    className: cx__default["default"]('input-feedback error', className)
  }, error.short || error) : null;
};
const messageDefault = t('message.genericFormError', 'Please correct the following issues before continuing');
const FormFeedback = _ref7 => {
  let {
    message = messageDefault,
    customMessage,
    errors = [],
    submitCount,
    className
  } = _ref7;

  if (message === messageDefault && EmptyOrNil.isEmptyOrNil(errors) || submitCount < 1) {
    return null;
  }

  return /*#__PURE__*/React__default["default"].createElement(Message$1, {
    fail: true,
    className: `sticky top-16 z-10 ${className}`,
    onClick: e => e.currentTarget.classList.replace('sticky', 'static')
  }, /*#__PURE__*/React__default["default"].createElement(Show$1, {
    when: message
  }, /*#__PURE__*/React__default["default"].createElement("h3", {
    className: "font-medium text-base"
  }, message)), /*#__PURE__*/React__default["default"].createElement(Show$1, {
    when: EmptyOrNil.notEmptyOrNil(errors)
  }, Array.isArray(errors) ? /*#__PURE__*/React__default["default"].createElement("ul", {
    className: "bullets-x m-0 p-0 mt-2"
  }, errors.map(error => /*#__PURE__*/React__default["default"].createElement("li", {
    key: Guid.guid(),
    className: "text-sm font-medium"
  }, error))) : /*#__PURE__*/React__default["default"].createElement("div", {
    className: "pl-4 mt-2"
  }, Object.entries(errors).map(_ref8 => {
    let [field, error] = _ref8;
    return /*#__PURE__*/React__default["default"].createElement("label", {
      key: Guid.guid(),
      className: "m-0 text-white block",
      htmlFor: field
    }, "-", ' ', /*#__PURE__*/React__default["default"].createElement("span", {
      className: "inline hover:underline"
    }, error.long || error));
  }))), customMessage);
};

function Checkbox(_ref) {
  let {
    name,
    value,
    tooltip,
    isFocused,
    recede,
    disabled,
    disabledTooltip,
    labelClassName,
    inputClassName,
    label = '[no label]',
    onBlur = Functions.noop,
    ...props
  } = _ref;
  const {
    fieldRef
  } = useInputFocus(isFocused);
  return /*#__PURE__*/React__default["default"].createElement(FieldWrapper, {
    name: name,
    disabled: disabled,
    disabledTooltip: disabledTooltip
  }, _ref2 => {
    let {
      field,
      form
    } = _ref2;
    const isChecked = field.value && field.value.includes(value);
    const checkboxClasses = cx__default["default"]('checkbox', {
      'checked': isChecked,
      'disabled': disabled,
      'recede': recede
    });
    return /*#__PURE__*/React__default["default"].createElement("div", null, /*#__PURE__*/React__default["default"].createElement("label", {
      className: cx__default["default"]('font-normal', {
        'text-grey': disabled
      }, labelClassName)
    }, /*#__PURE__*/React__default["default"].createElement("span", {
      className: "wrap-check mr-2 flex-none"
    }, /*#__PURE__*/React__default["default"].createElement("input", _rollupPluginBabelHelpers._extends({}, props, {
      ref: fieldRef,
      type: "checkbox",
      name: name,
      value: value,
      disabled: disabled,
      checked: isChecked,
      onBlur: onBlur,
      onChange: e => {
        let nextValue;
        invoke__default["default"](props, 'onChange', e.target.checked, value, e);

        if (!field.value) {
          form.setFieldValue(name, [value]);
          return;
        }

        if (isChecked) {
          nextValue = field.value.filter(x => x !== value);
          form.setFieldValue(name, nextValue);
          return;
        }

        nextValue = field.value.concat(value);
        form.setFieldValue(name, nextValue);
      }
    })), /*#__PURE__*/React__default["default"].createElement("span", {
      className: cx__default["default"](inputClassName, checkboxClasses)
    })), label), /*#__PURE__*/React__default["default"].createElement(ShowTooltip, {
      useIcon: true,
      tooltip: !disabled && tooltip
    }));
  });
}

const OptionsMenu = _ref => {
  let {
    groupLabel,
    groupId,
    options,
    className
  } = _ref;
  return /*#__PURE__*/React__default["default"].createElement(Tooltip$1, {
    plugins: [TooltipPlugins.hideOnEsc],
    trigger: "click",
    arrow: false,
    placement: "bottom-start",
    interactive: true,
    theme: "light",
    content: /*#__PURE__*/React__default["default"].createElement("div", {
      className: "min-w-2xs text-base p-2"
    }, options.map(_ref2 => {
      let {
        id,
        label
      } = _ref2;
      return /*#__PURE__*/React__default["default"].createElement("div", {
        className: "flex pt-1",
        key: id
      }, /*#__PURE__*/React__default["default"].createElement(Checkbox, {
        inputClassName: "flex",
        labelClassName: "w-full flex items-start",
        name: groupId,
        id: id,
        value: id,
        label: label
      }));
    }))
  }, /*#__PURE__*/React__default["default"].createElement("span", {
    tabIndex: "0"
  }, /*#__PURE__*/React__default["default"].createElement(Button$1, {
    "data-testid": "status-filter-button",
    className: cx__default["default"]('mt-4 md:mt-0', className),
    tertiary: true,
    small: true,
    appendLabel: /*#__PURE__*/React__default["default"].createElement(Icon$1, {
      name: "MenuArrowDown",
      width: 20,
      height: 20,
      className: "ml-1"
    })
  }, groupLabel)));
};

var OptionsMenu$1 = OptionsMenu;

const Processing = _ref => {
  let {
    children,
    label = 'Loading...'
  } = _ref;
  return /*#__PURE__*/React__default["default"].createElement("div", {
    className: "bg-moon-grey rounded-full inline-block my-4"
  }, /*#__PURE__*/React__default["default"].createElement("div", {
    className: "flex items-center leading-collapse p-2 pr-4"
  }, /*#__PURE__*/React__default["default"].createElement("span", {
    className: "mr-2 w-6 h-6 spinner-reverse"
  }), children || label));
};

Processing.propTypes = {
  label: propTypes.string
};
var Processing$1 = Processing;

const StepLink = _ref => {
  let {
    active,
    visited,
    completed,
    onClick,
    children,
    ...props
  } = _ref;
  return visited && !active ? /*#__PURE__*/React__default["default"].createElement("a", _rollupPluginBabelHelpers._extends({}, props, {
    onClick: onClick
  }), children) : /*#__PURE__*/React__default["default"].createElement("div", props, children);
};

const ProgressStep = _ref2 => {
  let {
    children,
    step = 1,
    route,
    active,
    visited,
    completed,
    beforeLeave,
    className
  } = _ref2;
  const navigate = reactRouterDom.useNavigate();

  const handleNavigate = async e => {
    e.preventDefault();

    if (typeof beforeLeave === 'function') {
      const doContinue = await beforeLeave();

      if (!doContinue) {
        console.log('[ProgressStepper] - Navigation prevented by onBeforeLeave handler');
        return;
      }
    }

    navigate(`../${route.path}`);
  };

  const stepClassName = cx__default["default"]('progress-step t-opacity t-duration-short', {
    active,
    completed,
    visited
  }, {
    'hover:opacity-60 cursor-pointer': !active && (completed || visited)
  }, className);
  return /*#__PURE__*/React__default["default"].createElement(StepLink, {
    "data-testid": `ProgressStep-${step}${cx__default["default"]({
      '-active': active
    })}`,
    onClick: handleNavigate,
    active: active,
    visited: visited,
    completed: completed,
    className: stepClassName
  }, /*#__PURE__*/React__default["default"].createElement(NumberBadge$1, {
    className: "progress-step-indicator relative"
  }, completed && !active ? /*#__PURE__*/React__default["default"].createElement(Icon$1, {
    name: "Checkmark",
    width: "16"
  }) : step), /*#__PURE__*/React__default["default"].createElement("span", {
    className: "progress-step-label"
  }, children));
};

const ProgressStepper = _ref3 => {
  let {
    steps = [],
    progress = [],
    onBeforeLeave = Functions.noop,
    className = ''
  } = _ref3;
  const activeIndex = steps.reduce((acc, curr, index) => curr.active ? index : acc, 0);
  return /*#__PURE__*/React__default["default"].createElement("div", {
    "data-testid": "ProgressStepper",
    className: cx__default["default"]('progress-steps', className)
  }, steps.map((step, index) => /*#__PURE__*/React__default["default"].createElement(ProgressStep, {
    key: index,
    beforeLeave: onBeforeLeave,
    visited: progress?.[index]?.visited,
    completed: progress?.[index]?.completed,
    active: index === activeIndex,
    route: steps[index],
    step: index + 1
  }, step.label)));
};

ProgressStepper.propTypes = {
  steps: propTypes.arrayOf(propTypes.shape({
    active: propTypes.bool,
    label: propTypes.string,
    path: propTypes.string
  })),
  progress: propTypes.arrayOf(propTypes.shape({
    visited: propTypes.bool,
    completed: propTypes.bool
  })),
  onBeforeLeave: propTypes.func
};
var ProgressStepper$1 = ProgressStepper;

const StickyPane = _ref => {
  let {
    children,
    className = '',
    innerPaneClassName = '',
    expandedOffset = 0
  } = _ref;
  const paneNode = React.useRef();
  const paneInnerNode = React.useRef();
  /**
   * Toggle height style for facet pane to avoid offscreen scrolling when in initial state
   */

  React.useEffect(() => {
    if (!paneNode.current) {
      return Functions.noop;
    }

    const bodyRect = document.body.getBoundingClientRect();
    const containerBounds = paneNode.current.getBoundingClientRect();

    const collapse = () => {
      if (!paneInnerNode.current) {
        return;
      }

      paneInnerNode.current.style.height = `calc(100vh - ${containerBounds.top - bodyRect.top}px)`;
    };

    const expand = () => {
      if (!paneInnerNode.current) {
        return;
      }

      paneInnerNode.current.style.height = `calc(100vh - ${expandedOffset}px)`;
    };

    collapse();
    const wp = new window.Waypoint({
      element: paneNode.current,
      handler: function (direction) {
        if (direction === 'down') {
          expand();
          return;
        }

        collapse();
      }
    });
    return () => wp.destroy();
  }, [expandedOffset]);
  return /*#__PURE__*/React__default["default"].createElement("div", {
    ref: paneNode,
    className: className
  }, /*#__PURE__*/React__default["default"].createElement("div", {
    ref: paneInnerNode,
    className: cx__default["default"]('sticky overflow-auto top-0 h-screen', innerPaneClassName)
  }, children));
};

var StickyPane$1 = StickyPane;

const transformTagLabel = (groupName, label) => {
  if (/^yes$/i.test(label)) {
    return `With ${groupName}`;
  }

  if (/^no$/i.test(label)) {
    return `Without ${groupName}`;
  }

  return label;
};

function Token(_ref) {
  let {
    tag,
    color = 'near-black',
    textColor = 'near-white',
    removeButtonText = 'Remove',
    onDelete = Functions.noop
  } = _ref;
  const tagBaseStyle = 'whitespace-pre-wrap break-all badge-hollow m-1 cursor-pointer';
  const tagColorStyle = tag.isValid ? `text-${textColor} bg-${color}` : 'text-fail border border-fail bg-white';
  return /*#__PURE__*/React__default["default"].createElement("span", {
    className: cx__default["default"](tagBaseStyle, tagColorStyle),
    title: removeButtonText,
    onClick: onDelete
  }, tag.name, " ", /*#__PURE__*/React__default["default"].createElement("b", {
    className: "cursor-pointer inline-flex leading-none text-center ml-1"
  }, "\xD7"));
}

Token.propTypes = {
  tag: propTypes.shape({
    name: propTypes.string,
    isValid: propTypes.bool
  }).isRequired,
  color: propTypes.string,
  textColor: propTypes.string,
  removeButtonText: propTypes.string,
  onDelete: propTypes.func
};

const TokenFilter = _ref2 => {
  let {
    groupName,
    label,
    color = 'near-black',
    textColor = 'near-white',
    textSize = 'xs',
    className = '',
    onClick = Functions.noop
  } = _ref2;
  const tagBaseStyle = 'tag px-4 py-1 my-1 mr-2 cursor-pointer';
  const tagColorStyle = `text-${textColor} bg-${color} text-${textSize}`;
  return /*#__PURE__*/React__default["default"].createElement(Tooltip$1, {
    content: `Remove filter`
  }, /*#__PURE__*/React__default["default"].createElement("span", {
    className: cx__default["default"](tagBaseStyle, tagColorStyle, className),
    onClick: onClick
  }, transformTagLabel(groupName, label), /*#__PURE__*/React__default["default"].createElement("span", {
    className: "tag-append"
  }, /*#__PURE__*/React__default["default"].createElement(Icon$1, {
    name: "Cross",
    width: "12"
  }))));
};

TokenFilter.propTypes = {
  color: propTypes.string,
  textColor: propTypes.string,
  groupName: propTypes.string,
  label: propTypes.node,
  onClick: propTypes.func
};

const moreBtnStyle = 'flex flex-col items-center justify-center h-full text-title leading-tight rounded bg-moon-grey link-2 t-bg-color t-duration-short hover:bg-blue hover:text-white';
const thumbnailStyle = 'block mb-4 link-hover';
const TRUNC_THRESHOLD = 4;

const ThumbnailList = _ref => {
  let {
    list,
    assetComponent,
    maxLength = 0,
    ...props
  } = _ref;
  const remainingListCount = list.length - maxLength;
  const showMoreAction = maxLength > 0 && remainingListCount >= TRUNC_THRESHOLD;
  const takeSize = showMoreAction ? maxLength : list.length;

  const handleClick = e => invoke__default["default"](props, 'onMoreClick', e);

  const AssetComponent = assetComponent;
  return /*#__PURE__*/React__default["default"].createElement("nav", {
    className: "gap-4 grid auto-rows-fr grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 justify-center items-center"
  }, take__default["default"](takeSize, list).map(asset => /*#__PURE__*/React__default["default"].createElement(AssetComponent, _rollupPluginBabelHelpers._extends({
    key: asset.id
  }, asset))), showMoreAction && /*#__PURE__*/React__default["default"].createElement("button", {
    onClick: handleClick,
    className: cx__default["default"](thumbnailStyle, moreBtnStyle)
  }, /*#__PURE__*/React__default["default"].createElement("span", null, t('label.plusMoreWithCount', '+ {{count}} more', {
    count: list.length - maxLength
  }))));
};

var ThumbnailList$1 = ThumbnailList;

const ToggleButton = _ref => {
  let {
    isTruncated,
    onToggle
  } = _ref;
  return /*#__PURE__*/React__default["default"].createElement("div", {
    className: "mt-4"
  }, /*#__PURE__*/React__default["default"].createElement("span", {
    className: "flex link-2 text-sm",
    onClick: onToggle
  }, "Show ", isTruncated ? 'more' : 'less', /*#__PURE__*/React__default["default"].createElement(Icon$1, {
    name: isTruncated ? 'menu-arrow-down' : 'menu-arrow-up',
    className: "ml-1 text-lg"
  })));
};

class TruncateText extends React.Component {
  state = {
    isTruncated: true,
    isToggleable: false
  };
  static defaultProps = {
    maxCharacters: 100,
    maxLines: 3
  };

  constructor(props) {
    super(props);
    this.toggleContent = this.toggleContent.bind(this);
  }

  componentWillMount() {
    this.setTruncatedState(this.props);
  }

  componentWillReceiveProps(nextProps, nextContext) {
    if (this.props.children !== nextProps.children) {
      this.setTruncatedState(nextProps);
    }
  }

  setTruncatedState(_ref2) {
    let {
      children,
      maxCharacters,
      maxLines
    } = _ref2;

    if (children.length > 1) {
      console.warn('<TruncateText> received more than one child but expects only a single string of text. This may produce unexpected results');
    }

    const text = children;
    const truncatedText = Strings.truncateString(text, maxCharacters, maxLines);
    const isToggleable = truncatedText !== text;
    this.setState({
      isToggleable: isToggleable,
      isTruncated: isToggleable,
      truncatedContent: `${truncatedText}...`
    });
  }

  toggleContent() {
    this.setState({
      isTruncated: !this.state.isTruncated
    });
  }

  renderContent() {
    if (this.state.isTruncated) {
      return this.state.truncatedContent;
    }

    return this.props.children;
  }

  render() {
    const {
      isTruncated
    } = this.state;
    return /*#__PURE__*/React__default["default"].createElement("div", {
      className: this.props.className
    }, this.renderContent(), this.state.isToggleable ? /*#__PURE__*/React__default["default"].createElement(ToggleButton, {
      isTruncated: isTruncated,
      onToggle: this.toggleContent
    }) : null);
  }

}

var TruncateText$1 = TruncateText;

const FileDrop = _ref => {
  let {
    id,
    onFileAdded
  } = _ref;
  const onDrop = React.useCallback(acceptedFiles => {
    acceptedFiles.forEach(file => {
      const reader = new FileReader();

      reader.onabort = () => console.warn('file reading was aborted');

      reader.onerror = err => console.error('[ReadFile Failed]', err);

      reader.onload = () => {
        const base64Str = reader.result;
        onFileAdded({
          fileName: file.name,
          data: base64Str
        });
      }; // reader.readAsArrayBuffer( file )


      reader.readAsDataURL(file);
    });
  }, []);
  const {
    getRootProps,
    getInputProps,
    isDragActive
  } = reactDropzone.useDropzone({
    onDrop
  });
  return /*#__PURE__*/React__default["default"].createElement("div", _rollupPluginBabelHelpers._extends({}, getRootProps(), {
    className: "text-center text-title text-grey-dark p-6 bg-near-white border-2 border-dashed border-grey-lighter rounded-lg"
  }), /*#__PURE__*/React__default["default"].createElement("input", _rollupPluginBabelHelpers._extends({
    id: id,
    name: id
  }, getInputProps())), isDragActive ? /*#__PURE__*/React__default["default"].createElement("p", {
    className: "text-blue"
  }, t('fileDrop.actionLabel.dropHere', 'Drop files here...')) : /*#__PURE__*/React__default["default"].createElement("p", {
    className: "hover:link-2-underline"
  }, t('fileDrop.actionLabel.dragAndDropFiles', 'Drag and drop files here, or browse')));
};

const FileAttachment = _ref2 => {
  let {
    fileName,
    onRemove
  } = _ref2;
  return /*#__PURE__*/React__default["default"].createElement("div", {
    className: "flex items-center bg-near-white rounded-lg mb-2 px-4 py-2"
  }, /*#__PURE__*/React__default["default"].createElement("span", {
    className: "flex-auto"
  }, fileName), /*#__PURE__*/React__default["default"].createElement("div", {
    onClick: onRemove,
    className: "h-8 w-4 text-2xl leading-none hover:text-fail cursor-pointer"
  }, "\xD7"));
};
var FileDrop$1 = FileDrop;

const Radio = _ref => {
  let {
    id,
    name,
    label,
    value,
    tooltip,
    disabled,
    recede,
    disabledTooltip,
    isFocused,
    toggleable,
    labelClassName,
    inputClassName,
    ...props
  } = _ref;
  const {
    fieldRef
  } = useInputFocus(isFocused);
  return /*#__PURE__*/React__default["default"].createElement(FieldWrapper, {
    name: name,
    disabled: disabled,
    disabledTooltip: disabledTooltip
  }, _ref2 => {
    let {
      field,
      form
    } = _ref2;
    const fieldValue = field.value && field.value.toString() || '';
    const isChecked = fieldValue.includes(value);
    const checkboxClasses = cx__default["default"]('radio', {
      'checked': isChecked,
      'disabled': disabled,
      'recede': recede
    }); // render as child prop

    if (typeof props.children === 'function') {
      return /*#__PURE__*/React__default["default"].createElement("label", {
        className: cx__default["default"]('font-normal m-0', labelClassName),
        htmlFor: id
      }, /*#__PURE__*/React__default["default"].createElement("input", {
        ref: fieldRef,
        className: "hidden",
        type: "radio",
        name: name,
        id: id,
        title: label,
        disabled: disabled,
        value: value,
        checked: isChecked,
        onClick: () => {
          if (isChecked && toggleable) {
            form.setFieldValue(name, '');
          }

          invoke__default["default"](props, 'onClick', value);
        },
        onBlur: e => {
          form.handleBlur(e);
          invoke__default["default"](props, 'onBlur', value);
        },
        onChange: e => {
          form.setFieldValue(name, value);
          invoke__default["default"](props, 'onChange', value);
        }
      }), props.children({
        field,
        form,
        id,
        name,
        label,
        value,
        tooltip,
        disabled,
        inputClassName,
        isChecked,
        ...props
      }));
    }

    return /*#__PURE__*/React__default["default"].createElement("div", null, /*#__PURE__*/React__default["default"].createElement("label", {
      className: cx__default["default"]('font-normal', {
        'text-grey': disabled
      }, labelClassName)
    }, /*#__PURE__*/React__default["default"].createElement("span", {
      className: cx__default["default"](inputClassName, 'wrap-check mr-2 flex-none')
    }, /*#__PURE__*/React__default["default"].createElement("input", _rollupPluginBabelHelpers._extends({}, props, {
      ref: fieldRef,
      type: "radio",
      name: name,
      id: id,
      title: label,
      disabled: disabled,
      value: value,
      checked: isChecked,
      onBlur: form.handleBlur,
      onChange: e => {
        form.setFieldValue(name, value);
        invoke__default["default"](props, 'onChange', value);
      }
    })), /*#__PURE__*/React__default["default"].createElement("span", {
      className: checkboxClasses
    })), label), /*#__PURE__*/React__default["default"].createElement(ShowTooltip, {
      useIcon: true,
      tooltip: !disabled && tooltip
    }));
  });
};

const OptionBox = _ref => {
  let {
    id,
    name,
    value,
    label,
    disabled,
    className,
    children,
    ...props
  } = _ref;
  return /*#__PURE__*/React__default["default"].createElement(Radio, _rollupPluginBabelHelpers._extends({}, props, {
    toggleable: true,
    className: "mb-1",
    id: id,
    name: name,
    value: value,
    label: label,
    disabled: disabled
  }), inputProps => /*#__PURE__*/React__default["default"].createElement(ActionTile$1, {
    label: label,
    isChecked: inputProps.isChecked,
    disabled: disabled
  }, children));
};

const SelectFauxField = _ref => {
  let {
    id,
    _name,
    label,
    labelAppend,
    hint,
    error,
    errorShown,
    tooltip,
    _value,
    isFocused,
    labelClassName,
    inputClassName,
    className,
    children,
    ...props
  } = _ref;
  const {
    fieldRef
  } = useInputFocus(isFocused);
  const groupClasses = cx__default["default"]('select-group', className, {
    'animated shake error': !!error || !!errorShown
  });
  const inputClasses = cx__default["default"]('input-select px-3 w-full h-10 bg-white rounded flex items-center justify-between cursor-pointer whitespace-nowrap', {
    'disabled': props.disabled
  }, inputClassName);

  const handleKeyDown = e => {
    if (e.keyCode === 13) {
      invoke__default["default"](props, 'onClick', e);
    }
  };

  const handleClick = e => {
    invoke__default["default"](props, 'onClick', e);
  };

  return /*#__PURE__*/React__default["default"].createElement("div", {
    className: groupClasses
  }, /*#__PURE__*/React__default["default"].createElement(FieldLabel, {
    label: label,
    append: labelAppend,
    tooltip: tooltip,
    id: id,
    hint: hint,
    error: error,
    className: labelClassName
  }), /*#__PURE__*/React__default["default"].createElement("div", _rollupPluginBabelHelpers._extends({
    ref: fieldRef,
    onClick: handleClick,
    onKeyDown: handleKeyDown,
    className: inputClasses
  }, props), /*#__PURE__*/React__default["default"].createElement("span", {
    className: "ellipsis"
  }, children)), /*#__PURE__*/React__default["default"].createElement(InputFeedback, {
    error: error
  }));
};

const SelectField = _ref => {
  let {
    id,
    name,
    label,
    labelAppend,
    hint,
    error,
    errorShown,
    tooltip,
    value,
    isFocused,
    labelClassName,
    inputClassName,
    className,
    children,
    ...props
  } = _ref;
  const {
    fieldRef
  } = useInputFocus(isFocused);

  const handleBlur = e => invoke__default["default"](props, 'onBlur', e);

  const handleChange = e => invoke__default["default"](props, 'onChange', e);

  const groupClasses = cx__default["default"]('select-group', className, {
    'animated shake error': !!error || !!errorShown
  });
  const inputClasses = cx__default["default"]('input-select w-full', {
    'disabled': props.disabled
  }, inputClassName);
  return /*#__PURE__*/React__default["default"].createElement("div", {
    className: groupClasses
  }, /*#__PURE__*/React__default["default"].createElement(FieldLabel, {
    label: label,
    append: labelAppend,
    tooltip: tooltip,
    id: id,
    hint: hint,
    error: error,
    className: labelClassName
  }), /*#__PURE__*/React__default["default"].createElement(FieldWrapper, _rollupPluginBabelHelpers._extends({
    component: "select",
    innerRef: fieldRef,
    id: id,
    name: name || id,
    className: inputClasses,
    onBlur: handleBlur,
    onChange: handleChange,
    value: value
  }, props), children), /*#__PURE__*/React__default["default"].createElement(InputFeedback, {
    error: error
  }));
};

const Textarea = _ref => {
  let {
    id,
    name,
    label,
    labelAppend,
    hint,
    error,
    errorShown,
    tooltip,
    value,
    isFocused,
    onChange,
    onBlur,
    className,
    labelClassName,
    inputClassName,
    children,
    debounceOnChange = true,
    ...props
  } = _ref;
  const [innerValue, setInnerValue] = React.useState(value);
  React.useEffect(() => {
    if (value) {
      setInnerValue(value);
    } else {
      setInnerValue('');
    }
  }, [value]);
  const debouncedHandleOnChange = useDebounce.useDebouncedCallback(event => onChange(event), 200);
  const handleOnChange = React.useCallback(event => {
    event.persist();
    const newValue = event.currentTarget.value;
    setInnerValue(newValue);

    if (onChange) {
      debounceOnChange ? debouncedHandleOnChange(event) : onChange(event);
    }
  }, []);
  const {
    fieldRef
  } = useInputFocus(isFocused);
  const groupClasses = cx__default["default"]('w-full textarea-group', className, {
    'animated shake error': !!error || !!errorShown
  });
  const inputClasses = cx__default["default"]('textarea block w-full', {
    'disabled': props.disabled
  }, inputClassName);
  return /*#__PURE__*/React__default["default"].createElement("div", {
    className: groupClasses
  }, /*#__PURE__*/React__default["default"].createElement(FieldLabel, {
    label: label,
    append: labelAppend,
    tooltip: tooltip,
    id: id,
    hint: hint,
    error: error,
    className: labelClassName
  }), /*#__PURE__*/React__default["default"].createElement(FieldWrapper, _rollupPluginBabelHelpers._extends({
    tabIndex: 0,
    component: "textarea",
    innerRef: fieldRef,
    id: id,
    name: name || id,
    className: inputClasses,
    onBlur: onBlur,
    onChange: handleOnChange,
    value: innerValue
  }, props), children), /*#__PURE__*/React__default["default"].createElement(InputFeedback, {
    error: error
  }));
};

const TextField = /*#__PURE__*/React.memo(props => {
  const {
    id,
    name,
    type = 'text',
    label,
    labelAppend,
    append,
    prepend,
    hint,
    isFocused,
    mask,
    disabled,
    error,
    errorShown,
    tooltip,
    value,
    onChange,
    onBlur,
    className,
    labelClassName,
    groupClassName,
    inputClassName,
    children,
    debounceOnChange = false,
    ...restProps
  } = props;
  const [innerValue, setInnerValue] = React.useState(value);
  const {
    fieldRef
  } = useInputFocus(isFocused);
  React.useEffect(() => {
    if (value) {
      setInnerValue(value);
    } else {
      setInnerValue('');
    }
  }, [value]);
  const debouncedHandleOnChange = useDebounce.useDebouncedCallback(event => onChange(event), 200);
  const handleOnChange = React.useCallback(event => {
    event.persist();
    const newValue = event.currentTarget.value;
    setInnerValue(newValue);

    if (onChange) {
      debounceOnChange ? debouncedHandleOnChange(event) : onChange(event);
    }
  }, []);
  const groupClasses = cx__default["default"]('input-group', groupClassName, {
    'animated shake error': !!error || !!errorShown
  });
  const inputClasses = cx__default["default"]('input-field w-full', {
    disabled: disabled
  }, inputClassName);
  return /*#__PURE__*/React__default["default"].createElement("div", {
    className: cx__default["default"]('w-full', {
      disabled: disabled
    }, className)
  }, /*#__PURE__*/React__default["default"].createElement(FieldLabel, {
    label: label,
    append: labelAppend,
    tooltip: tooltip,
    id: id,
    hint: hint,
    error: error,
    className: labelClassName
  }), /*#__PURE__*/React__default["default"].createElement("div", {
    className: groupClasses
  }, /*#__PURE__*/React__default["default"].createElement(Show$1, {
    when: prepend
  }, /*#__PURE__*/React__default["default"].createElement("div", {
    className: "input-group-prepend"
  }, /*#__PURE__*/React__default["default"].createElement("span", {
    className: "input-group-text"
  }, prepend))), /*#__PURE__*/React__default["default"].createElement(Show$1, {
    when: append
  }, /*#__PURE__*/React__default["default"].createElement("div", {
    className: "input-group-append"
  }, /*#__PURE__*/React__default["default"].createElement("span", {
    className: "input-group-text"
  }, append))), /*#__PURE__*/React__default["default"].createElement("div", {
    className: "input-group-input"
  }, mask ? /*#__PURE__*/React__default["default"].createElement(FieldWrapper, {
    name: name,
    innerRef: ref => fieldRef.current = ref
  }, () => /*#__PURE__*/React__default["default"].createElement(MaskedInput__default["default"], _rollupPluginBabelHelpers._extends({
    tabIndex: 0,
    mask: mask,
    type: type,
    id: id,
    name: name || id,
    className: inputClasses,
    onBlur: onBlur,
    onChange: handleOnChange,
    disabled: disabled,
    value: innerValue
  }, restProps), children)) : /*#__PURE__*/React__default["default"].createElement(FieldWrapper, _rollupPluginBabelHelpers._extends({
    tabIndex: 0,
    innerRef: ref => fieldRef.current = ref,
    type: type,
    id: id,
    name: name || id,
    className: inputClasses,
    onBlur: onBlur,
    onChange: handleOnChange,
    disabled: disabled,
    value: innerValue
  }, restProps), children))), /*#__PURE__*/React__default["default"].createElement(InputFeedback, {
    error: error
  }));
}, arePropsEqual(['value', 'label', 'labelAppend', 'type', 'minlength', 'maxlength', 'min', 'max', 'size', 'step', 'disabled', 'error', 'errorShown', 'isFocused', 'className', 'groupClassName', 'inputClassName', 'children', 'debounceOnChange']));
TextField.masks = {
  phoneNumberUS: ['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]
};

function ToggleSwitch(_ref) {
  let {
    name,
    value,
    tooltip,
    isFocused,
    disabled,
    disabledTooltip,
    labelClassName,
    inputClassName,
    label = '',
    onBlur = Functions.noop,
    switchLabels = ['off', 'on'],
    ...props
  } = _ref;
  const {
    fieldRef
  } = useInputFocus(isFocused);
  return /*#__PURE__*/React__default["default"].createElement(FieldWrapper, {
    name: name,
    disabled: disabled,
    disabledTooltip: disabledTooltip
  }, _ref2 => {
    let {
      field,
      form
    } = _ref2;
    const isChecked = field.value && field.value.includes(value);
    const toggleSwitchClasses = cx__default["default"]('slider', {
      'checked': isChecked,
      'disabled': disabled
    });
    return /*#__PURE__*/React__default["default"].createElement("div", {
      className: cx__default["default"]('inline-flex')
    }, /*#__PURE__*/React__default["default"].createElement("label", {
      className: cx__default["default"]('flex items-center font-normal', {
        'text-grey': disabled
      }, labelClassName)
    }, /*#__PURE__*/React__default["default"].createElement("span", {
      className: "switch mr-2 flex-none"
    }, /*#__PURE__*/React__default["default"].createElement("input", _rollupPluginBabelHelpers._extends({}, props, {
      ref: fieldRef,
      type: "checkbox",
      name: name,
      value: value,
      disabled: disabled,
      checked: isChecked,
      onBlur: onBlur,
      onChange: e => {
        let nextValue;
        invoke__default["default"](props, 'onChange', e.target.checked, value, e);

        if (!field.value) {
          form.setFieldValue(name, [value]);
          return;
        }

        if (isChecked) {
          nextValue = field.value.filter(x => x !== value);
          form.setFieldValue(name, nextValue);
          return;
        }

        nextValue = field.value.concat(value);
        form.setFieldValue(name, nextValue);
      }
    })), /*#__PURE__*/React__default["default"].createElement("span", {
      "data-label-off": switchLabels[0],
      "data-label-on": switchLabels[1],
      className: cx__default["default"](inputClassName, toggleSwitchClasses)
    })), label), /*#__PURE__*/React__default["default"].createElement("div", {
      className: "mb-2 flex items-center"
    }, /*#__PURE__*/React__default["default"].createElement(ShowTooltip, {
      useIcon: true,
      tooltip: !disabled && tooltip
    })));
  });
}

function SuggestionComponent(_ref) {
  let {
    item,
    query
  } = _ref;
  return /*#__PURE__*/React__default["default"].createElement("span", {
    id: item.id,
    className: "px-4 py-1 m-0 block w-full cursor-pointer hover:bg-near-white active:bg-blue active:text-white"
  }, item.name);
}
/**
 * Note - This Field is only a Facade and does not store values in Formik state by default
 *  This field accepts a tag list but the parent component must manage it's own
 *  form state using Formik.setFieldValue (onChange, onBlur events will be ignored)
 */


const TokenizedInput = /*#__PURE__*/React.memo(props => {
  const {
    id,
    name,
    label,
    labelAppend,
    append,
    prepend,
    hint,
    isFocused,
    mask,
    disabled,
    error,
    errorShown,
    tags,
    tooltip,
    placeholder,
    suggestions,
    suggestionComponent = SuggestionComponent,
    minQueryLength = 1,
    maxSuggestionsLength = 16,
    onAddTag,
    onRemoveTag,
    className,
    tagComponent,
    labelClassName,
    groupClassName,
    inputClassName,
    children,
    ...restProps
  } = props;
  const fieldRef = React.useRef(null);
  const groupClasses = cx__default["default"]('input-group', groupClassName, {
    'animated shake error': !!error || !!errorShown
  });
  const inputClasses = cx__default["default"]('input-field text-field rounded w-full py-2', {
    'disabled': disabled
  }, inputClassName);

  const handleInput = e => {
    invoke__default["default"](restProps, 'onInput', e);
  };

  const handleFocus = e => {
    invoke__default["default"](restProps, 'onFocus', e);
  };

  const handleBlur = e => {
    invoke__default["default"](restProps, 'onBlur', e);
  };

  return /*#__PURE__*/React__default["default"].createElement("div", {
    className: cx__default["default"]('w-full', {
      'disabled': disabled
    }, className)
  }, /*#__PURE__*/React__default["default"].createElement(FieldLabel, {
    label: label,
    append: labelAppend,
    tooltip: tooltip,
    id: id,
    hint: hint,
    error: error,
    className: labelClassName
  }), /*#__PURE__*/React__default["default"].createElement("div", {
    className: groupClasses
  }, /*#__PURE__*/React__default["default"].createElement(Show$1, {
    when: prepend
  }, /*#__PURE__*/React__default["default"].createElement("div", {
    className: "input-group-prepend"
  }, /*#__PURE__*/React__default["default"].createElement("span", {
    className: "input-group-text"
  }, prepend))), /*#__PURE__*/React__default["default"].createElement(Show$1, {
    when: append
  }, /*#__PURE__*/React__default["default"].createElement("div", {
    className: "input-group-append"
  }, /*#__PURE__*/React__default["default"].createElement("span", {
    className: "input-group-text"
  }, append))), /*#__PURE__*/React__default["default"].createElement("div", {
    className: "input-group-input"
  }, /*#__PURE__*/React__default["default"].createElement("div", {
    className: inputClasses,
    style: {
      height: 'auto'
    }
  }, /*#__PURE__*/React__default["default"].createElement(TokenInput__default["default"], {
    ref: fieldRef,
    classNames: {
      // root: 'w-full md:flex-1',
      // searchInput: 'text-field w-full',
      root: 'react-tags md:flex flex-auto flex-wrap items-center',
      rootFocused: 'is-focused',
      selected: 'react-tags__selected',
      selectedTag: 'react-tags__selected-tag',
      selectedTagName: 'react-tags__selected-tag-name',
      search: 'react-tags__search min-w-2xs flex-auto',
      searchWrapper: 'react-tags__search-wrapper',
      searchInput: 'react-tags__search-input text-field ghosted w-full min-w-xs',
      suggestions: 'react-tags__suggestions absolute bg-white shadow-1 py-2 z-10 min-w-xs max-h-40 overflow-y-auto',
      suggestionActive: 'is-active',
      suggestionDisabled: 'is-disabled text-grey'
    },
    placeholderText: placeholder,
    allowNew: true,
    autoresize: false,
    addOnBlur: true,
    delimiters: ['Enter', ','],
    tags: tags,
    suggestions: suggestions,
    suggestionComponent: suggestionComponent,
    minQueryLength: minQueryLength,
    maxSuggestionsLength: maxSuggestionsLength,
    tagComponent: tagComponent,
    onBlur: handleBlur,
    onFocus: handleFocus,
    onInput: handleInput,
    onAddition: onAddTag,
    onDelete: onRemoveTag
  })))), /*#__PURE__*/React__default["default"].createElement(InputFeedback, {
    error: error
  }));
}, arePropsEqual(['tags', 'error', 'errorShown', 'isFocused', 'className', 'groupClassName', 'inputClassName', 'children']));

const checkErrors = formik => fieldName => formik.touched[fieldName] && formik.errors[fieldName];
/**
 * note - Below helpers are for dealing with input group sets where the data model
 * may consist of an array of object values where items should be set and validated as a group
 */

const getIndexedValue = _ref => {
  let {
    values,
    index
  } = _ref;
  return fieldName => values && values[index] && values[index][fieldName] || '';
};
const getIndexedError = _ref2 => {
  let {
    errors,
    touched,
    index
  } = _ref2;
  return name => {
    const fieldTouched = touched && touched[index] && touched[index][name];

    if (!Array.isArray(errors) || !errors[index] || !fieldTouched) {
      return null;
    }

    return errors[index][name];
  };
};
const seedIndexedErrorList = errors => (name, index) => {
  const err = errors[name] || [];
  return err[index] || {};
};

exports.AccordionItem = AccordionItem;
exports.ActionTile = ActionTile$1;
exports.Avatar = Avatar$1;
exports.BackButton = BackButton;
exports.BackButtonDrawer = BackButtonDrawer;
exports.Badge = Badge$1;
exports.Button = Button$1;
exports.Checkbox = Checkbox;
exports.ContextMenu = ContextMenu;
exports.DateRange = DateRange$1;
exports.DateRangePicker = DateRangePicker$1;
exports.Desktop = Desktop;
exports.FieldLabel = FieldLabel;
exports.FileAttachment = FileAttachment;
exports.FileDownloadButton = FileDownloadButton$1;
exports.FileDrop = FileDrop$1;
exports.FileList = FileList$1;
exports.FilterList = FilterList$1;
exports.FormFeedback = FormFeedback;
exports.HandheldDevice = HandheldDevice;
exports.Hint = Hint;
exports.InputFeedback = InputFeedback;
exports.Label = Label;
exports.MediumDevice = MediumDevice;
exports.Message = Message$1;
exports.Mobile = Mobile;
exports.Modal = UPIModal$1;
exports.NumberBadge = NumberBadge$1;
exports.OptionBox = OptionBox;
exports.OptionsMenu = OptionsMenu$1;
exports.PickList = PickList$1;
exports.Processing = Processing$1;
exports.ProcessingBar = ProcessingBar;
exports.ProgressBar = ProgressBar$1;
exports.ProgressStepper = ProgressStepper$1;
exports.Radio = Radio;
exports.ReactHelpers = ReactHelpers;
exports.ReactHooks = ReactHooks;
exports.Search = Search$1;
exports.SelectFauxField = SelectFauxField;
exports.SelectField = SelectField;
exports.Show = Show$1;
exports.SkeletonElement = SkeletonElement$1;
exports.SmallDevice = SmallDevice;
exports.StickyPane = StickyPane$1;
exports.Tablet = Tablet;
exports.TextField = TextField;
exports.Textarea = Textarea;
exports.ThumbnailList = ThumbnailList$1;
exports.ToggleSwitch = ToggleSwitch;
exports.Token = Token;
exports.TokenFilter = TokenFilter;
exports.TokenizedInput = TokenizedInput;
exports.Tooltip = Tooltip$1;
exports.TooltipPlugins = TooltipPlugins;
exports.TrackedFields = TrackedFields;
exports.TruncateText = TruncateText$1;
exports.TruncatedList = TruncatedList$1;
exports.checkErrors = checkErrors;
exports.getIndexedError = getIndexedError;
exports.getIndexedValue = getIndexedValue;
exports.seedIndexedErrorList = seedIndexedErrorList;
exports.t = t;
exports.tippy = tippy;
exports.useInputFocus = useInputFocus;
//# sourceMappingURL=index.js.map
